import { useState, useEffect } from "react";
import { supabase } from "./supabaseClient";
import AuthPage from "./AuthPage";
import InstallPrompt from "./InstallPrompt";

const SUPER_ADMIN_EMAIL = "privacyshield@gmail.com";

const TAB_ICONS = {
  team:      (c) => <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke={c} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M5 17H3a2 2 0 01-2-2v-3l2.5-5h15L21 12v3a2 2 0 01-2 2h-2"/><circle cx="7.5" cy="17" r="2"/><circle cx="16.5" cy="17" r="2"/><path d="M7.5 15h9"/></svg>,
  transfers: (c) => <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke={c} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M7 16V4m0 0L3 8m4-4l4 4M17 8v12m0 0l4-4m-4 4l-4-4"/></svg>,
  leagues:   (c) => <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke={c} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M8 21h8m-4-4v4M7 3h10l-1.5 8a4.5 4.5 0 01-7 0L7 3z"/><path d="M7 5H4a1 1 0 00-1 1v1a4 4 0 004 4M17 5h3a1 1 0 011 1v1a4 4 0 01-4 4"/></svg>,
  races:     (c) => <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke={c} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="4" width="18" height="18" rx="2"/><path d="M16 2v4M8 2v4M3 10h18"/></svg>,
  stats:     (c) => <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke={c} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M18 20V10M12 20V4M6 20v-6"/></svg>,
  profile:   (c) => <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke={c} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="8" r="4"/><path d="M4 20c0-4 3.6-7 8-7s8 3 8 7"/></svg>,
  rules:     (c) => <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke={c} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2"/><rect x="9" y="3" width="6" height="4" rx="1"/><line x1="9" y1="12" x2="15" y2="12"/><line x1="9" y1="16" x2="13" y2="16"/></svg>,
};

const DRIVERS = [
  { id: 1, name: "Lando Norris",       team: "McLaren",         number: 1,  price: 26.0, prevPrice: 26.1, fantasyPoints: 0, country: "GB", teamColor: "#FF8000" },
  { id: 2, name: "Oscar Piastri",      team: "McLaren",         number: 81, price: 23.3, prevPrice: 23.4, fantasyPoints: 0, country: "AU", teamColor: "#FF8000" },
  { id: 3, name: "Kimi Antonelli",     team: "Mercedes",        number: 12, price: 27.4, prevPrice: 27.1, fantasyPoints: 0, country: "IT", teamColor: "#27F4D2" },
  { id: 4, name: "Charles Leclerc",    team: "Ferrari",         number: 16, price: 24.4, prevPrice: 24.1, fantasyPoints: 0, country: "MC", teamColor: "#E8002D" },
  { id: 5, name: "Lewis Hamilton",     team: "Ferrari",         number: 44, price: 24.7, prevPrice: 24.4, fantasyPoints: 0, country: "GB", teamColor: "#E8002D" },
  { id: 6, name: "Max Verstappen",     team: "Red Bull Racing", number: 3,  price: 28.5, prevPrice: 28.2, fantasyPoints: 0, country: "NL", teamColor: "#3671C6" },
  { id: 7, name: "George Russell",     team: "Mercedes",        number: 63, price: 27.6, prevPrice: 27.9, fantasyPoints: 0, country: "GB", teamColor: "#27F4D2" },
  { id: 8, name: "Isack Hadjar",       team: "Red Bull Racing", number: 6,  price: 16.5, prevPrice: 16.3, fantasyPoints: 0, country: "FR", teamColor: "#3671C6" },
  { id: 9, name: "Pierre Gasly",       team: "Alpine",          number: 10, price: 9.6, prevPrice: 10.2, fantasyPoints: 0, country: "FR", teamColor: "#FF87BC" },
  { id: 10, name: "Carlos Sainz",       team: "Williams",        number: 55, price: 8.2, prevPrice: 8.4, fantasyPoints: 0, country: "ES", teamColor: "#64C4FF" },
  { id: 11, name: "Alexander Albon",    team: "Williams",        number: 23, price: 4.0, prevPrice: 4.6,  fantasyPoints: 0, country: "TH", teamColor: "#64C4FF" },
  { id: 12, name: "Fernando Alonso",    team: "Aston Martin",    number: 14, price: 6.0, prevPrice: 5.4,  fantasyPoints: 0, country: "ES", teamColor: "#229971" },
  { id: 13, name: "Lance Stroll",       team: "Aston Martin",    number: 18, price: 3.0, prevPrice: 3.0,  fantasyPoints: 0, country: "CA", teamColor: "#229971" },
  { id: 14, name: "Oliver Bearman",     team: "Haas",            number: 87, price: 6.2, prevPrice: 6.4,  fantasyPoints: 0, country: "GB", teamColor: "#B6BABD" },
  { id: 15, name: "Esteban Ocon",       team: "Haas",            number: 31, price: 10.1, prevPrice: 9.9, fantasyPoints: 0, country: "FR", teamColor: "#B6BABD" },
  { id: 16, name: "Nico Hülkenberg",    team: "Audi",            number: 27, price: 7.2, prevPrice: 6.6,  fantasyPoints: 0, country: "DE", teamColor: "#C60000" },
  { id: 17, name: "Liam Lawson",        team: "Red Bull Racing", number: 30, price: 10.5, prevPrice: 9.9, fantasyPoints: 0, country: "NZ", teamColor: "#3671C6" },
  { id: 18, name: "Gabriel Bortoleto",  team: "Audi",            number: 5,  price: 6.4, prevPrice: 7.0,  fantasyPoints: 0, country: "BR", teamColor: "#C60000" },
  { id: 19, name: "Arvid Lindblad",     team: "Racing Bulls",    number: 41, price: 10.6, prevPrice: 10.0,  fantasyPoints: 0, country: "GB", teamColor: "#6692FF" },
  { id: 20, name: "Franco Colapinto",   team: "Alpine",          number: 43, price: 8.2, prevPrice: 8.8, fantasyPoints: 0, country: "AR", teamColor: "#FF87BC" },
  { id: 21, name: "Sergio Pérez",       team: "Cadillac",        number: 11, price: 3.0, prevPrice: 3.6,  fantasyPoints: 0, country: "MX", teamColor: "#CC1020" },
  { id: 22, name: "Valtteri Bottas",    team: "Cadillac",        number: 77, price: 3.0, prevPrice: 3.0,  fantasyPoints: 0, country: "FI", teamColor: "#CC1020" },
  { id: 23, name: "Yuki Tsunoda",       team: "Racing Bulls",    number: 22, price: 9.7, prevPrice: 9.7,  fantasyPoints: 0, country: "JP", teamColor: "#6692FF" },
];

const CONSTRUCTORS = [
  { id: 1,  name: "Mercedes",        price: 34.0, prevPrice: 34.0, points: 0, color: "#27F4D2" },
  { id: 2,  name: "McLaren",         price: 32.7, prevPrice: 32.4, points: 0, color: "#FF8000" },
  { id: 3,  name: "Red Bull Racing", price: 33.0, prevPrice: 32.7, points: 0, color: "#3671C6" },
  { id: 4,  name: "Ferrari",         price: 28.5, prevPrice: 28.2, points: 0, color: "#E8002D" },
  { id: 5,  name: "Alpine",          price: 18.5, prevPrice: 18.8, points: 0, color: "#FF87BC" },
  { id: 6,  name: "Williams",        price: 12.0, prevPrice: 12.6, points: 0, color: "#64C4FF" },
  { id: 7,  name: "Aston Martin",    price: 5.1, prevPrice: 4.5,  points: 0, color: "#229971" },
  { id: 8,  name: "Haas",            price: 12.6, prevPrice: 12.0, points: 0, color: "#B6BABD" },
  { id: 9,  name: "Audi",            price: 11.0, prevPrice: 10.4,  points: 0, color: "#C60000" },
  { id: 10, name: "Racing Bulls",    price: 17.1, prevPrice: 16.5, points: 0, color: "#6692FF" },
  { id: 11, name: "Cadillac",        price: 3.0,  prevPrice: 3.0,  points: 0, color: "#CC1020" },
];

const RACES = [
  { round: 1,  name: "Australian GP",    circuit: "Albert Park Circuit",               date: "Mar 6–8",     sprint: false, qualiDate: "2026-03-07T05:00:00Z", raceDate: "2026-03-08T04:00:00Z", winner: null },
  { round: 2,  name: "Chinese GP",       circuit: "Shanghai International Circuit",    date: "Mar 13–15",   sprint: true,  sprintLockDate: "2026-03-14T03:00:00Z", qualiDate: "2026-03-14T07:00:00Z", raceDate: "2026-03-15T07:00:00Z", winner: null },
  { round: 3,  name: "Japanese GP",      circuit: "Suzuka International Racing Course",date: "Mar 27–29",   sprint: false, qualiDate: "2026-03-28T06:00:00Z", raceDate: "2026-03-29T05:00:00Z", winner: null },
  { round: 4,  name: "Bahrain GP",       circuit: "Bahrain International Circuit",     date: "Apr 10–12",   sprint: false, qualiDate: "2026-04-11T16:00:00Z", raceDate: "2026-04-12T15:00:00Z", winner: null, cancelled: true },
  { round: 5,  name: "Saudi Arabian GP", circuit: "Jeddah Corniche Circuit",           date: "Apr 17–19",   sprint: false, qualiDate: "2026-04-18T17:00:00Z", raceDate: "2026-04-19T17:00:00Z", winner: null, cancelled: true },
  { round: 6,  name: "Miami GP",         circuit: "Miami International Autodrome",     date: "May 1–3",     sprint: true,  sprintLockDate: "2026-05-02T16:00:00Z", qualiDate: "2026-05-02T20:00:00Z", raceDate: "2026-05-03T20:00:00Z", winner: null },
  { round: 7,  name: "Canadian GP",      circuit: "Circuit Gilles Villeneuve",         date: "May 22–24",   sprint: true,  sprintLockDate: "2026-05-23T16:00:00Z", qualiDate: "2026-05-23T20:00:00Z", raceDate: "2026-05-24T18:00:00Z", winner: null },
  { round: 8,  name: "Monaco GP",        circuit: "Circuit de Monaco",                 date: "Jun 5–7",     sprint: false, qualiDate: "2026-06-06T14:00:00Z", raceDate: "2026-06-07T13:00:00Z", winner: null },
  { round: 9,  name: "Barcelona GP",     circuit: "Circuit de Barcelona-Catalunya",    date: "Jun 12–14",   sprint: false, qualiDate: "2026-06-13T14:00:00Z", raceDate: "2026-06-14T13:00:00Z", winner: null },
  { round: 10, name: "Austrian GP",      circuit: "Red Bull Ring, Spielberg",          date: "Jun 26–28",   sprint: false, qualiDate: "2026-06-27T15:15:00Z", raceDate: "2026-06-28T13:00:00Z", winner: null },
  { round: 11, name: "British GP",       circuit: "Silverstone Circuit",               date: "Jul 3–5",     sprint: true,  sprintLockDate: "2026-07-04T11:00:00Z", qualiDate: "2026-07-04T15:00:00Z", raceDate: "2026-07-05T14:00:00Z", winner: null },
  { round: 12, name: "Belgian GP",       circuit: "Circuit de Spa-Francorchamps",      date: "Jul 17–19",   sprint: false, qualiDate: "2026-07-18T14:00:00Z", raceDate: "2026-07-19T13:00:00Z", winner: null },
  { round: 13, name: "Hungarian GP",     circuit: "Hungaroring, Budapest",             date: "Jul 24–26",   sprint: false, qualiDate: "2026-07-25T14:00:00Z", raceDate: "2026-07-26T13:00:00Z", winner: null },
  { round: 14, name: "Dutch GP",         circuit: "Circuit Zandvoort",                 date: "Aug 21–23",   sprint: true,  sprintLockDate: "2026-08-22T10:00:00Z", qualiDate: "2026-08-22T14:00:00Z", raceDate: "2026-08-23T13:00:00Z", winner: null },
  { round: 15, name: "Italian GP",       circuit: "Autodromo Nazionale Monza",         date: "Sep 4–6",     sprint: false, qualiDate: "2026-09-05T14:00:00Z", raceDate: "2026-09-06T13:00:00Z", winner: null },
  { round: 16, name: "Spanish GP",       circuit: "Madrid Street Circuit",             date: "Sep 11–13",   sprint: false, qualiDate: "2026-09-12T14:00:00Z", raceDate: "2026-09-13T13:00:00Z", winner: null },
  { round: 17, name: "Azerbaijan GP",    circuit: "Baku City Circuit",                 date: "Sep 24–26",   sprint: false, qualiDate: "2026-09-25T12:00:00Z", raceDate: "2026-09-26T11:00:00Z", winner: null },
  { round: 18, name: "Singapore GP",     circuit: "Marina Bay Street Circuit",         date: "Oct 9–11",    sprint: true,  sprintLockDate: "2026-10-10T04:00:00Z", qualiDate: "2026-10-10T13:00:00Z", raceDate: "2026-10-11T12:00:00Z", winner: null },
  { round: 19, name: "US GP",            circuit: "Circuit of the Americas, Austin",   date: "Oct 23–25",   sprint: false, qualiDate: "2026-10-24T21:00:00Z", raceDate: "2026-10-25T19:00:00Z", winner: null },
  { round: 20, name: "Mexico City GP",   circuit: "Autodromo Hermanos Rodriguez",      date: "Oct 30–Nov 1", sprint: false, qualiDate: "2026-10-31T21:00:00Z", raceDate: "2026-11-01T20:00:00Z", winner: null },
  { round: 21, name: "São Paulo GP",     circuit: "Autodromo Jose Carlos Pace",        date: "Nov 6–8",     sprint: false, qualiDate: "2026-11-07T18:00:00Z", raceDate: "2026-11-08T17:00:00Z", winner: null },
  { round: 22, name: "Las Vegas GP",     circuit: "Las Vegas Strip Circuit",           date: "Nov 19–21",   sprint: false, qualiDate: "2026-11-21T04:00:00Z", raceDate: "2026-11-22T06:00:00Z", winner: null },
  { round: 23, name: "Qatar GP",         circuit: "Lusail International Circuit",      date: "Nov 27–29",   sprint: false, qualiDate: "2026-11-28T18:00:00Z", raceDate: "2026-11-29T17:00:00Z", winner: null },
  { round: 24, name: "Abu Dhabi GP",     circuit: "Yas Marina Circuit",                date: "Dec 4–6",     sprint: false, qualiDate: "2026-12-05T14:00:00Z", raceDate: "2026-12-06T13:00:00Z", winner: null },
];

const TEAM_ABBR = {
  "Red Bull Racing": "RBR",
  "Ferrari": "SF",
  "McLaren": "MCL",
  "Mercedes": "AMG",
  "Aston Martin": "AMR",
  "Audi": "ADI",
  "Racing Bulls": "RB",
  "Alpine": "ALP",
  "Williams": "WIL",
  "Haas": "HAA",
  "Cadillac": "CAD",
};

const FLAG_MAP = { NL: "🇳🇱", MX: "🇲🇽", GB: "🇬🇧", MC: "🇲🇨", AU: "🇦🇺", IT: "🇮🇹", ES: "🇪🇸", CA: "🇨🇦", DE: "🇩🇪", FI: "🇫🇮", FR: "🇫🇷", JP: "🇯🇵", TH: "🇹🇭", NZ: "🇳🇿", BR: "🇧🇷", AR: "🇦🇷" };

const CONSTRUCTOR_LOGO_FILE = {
  "McLaren":         "mclaren",
  "Mercedes":        "mercedes",
  "Ferrari":         "ferrari",
  "Red Bull Racing": "redbull",
  "Williams":        "williams",
  "Aston Martin":    "astonmartin",
  "Alpine":          "alpine",
  "Haas":            "haas",
  "Audi":            "audi",
  "Racing Bulls":    "racingbulls",
  "Cadillac":        "cadillac",
};

const TeamLogo = ({ team, size = 26 }) => {
  const file = CONSTRUCTOR_LOGO_FILE[team];
  if (!file) return <div style={{ width: size, height: size, borderRadius: 6, background: "#eee" }} />;
  return (
    <div style={{ width: size, height: size, background: "#fff", borderRadius: 6, display: "flex", alignItems: "center", justifyContent: "center", overflow: "hidden", padding: 2, flexShrink: 0 }}>
      <img
        src={`/constructors/${file}.png`}
        alt={team}
        style={{ width: "100%", height: "100%", objectFit: "contain" }}
      />
    </div>
  );
};


// ── Scoring breakdown helper ─────────────────────────────────────────────────
// Returns [{label, value, pts}] rows for a given session breakdown object
function calcBreakdownRows(sessionName, bd) {
  if (!bd) return [];
  const rows = [];
  if (sessionName === "Qualifying") {
    const ptsArr = [10,9,8,7,6,5,4,3,2,1];
    if (bd.no_time) {
      rows.push({ label: "Not Classified", value: "NC", pts: -5 });
    } else if (bd.pos != null) {
      rows.push({ label: "Qualifying Position", value: `P${bd.pos}`, pts: ptsArr[bd.pos - 1] || 0 });
    }
  } else if (sessionName === "Sprint Qualifying") {
    // No points for Sprint Qualifying
  } else if (sessionName === "Race" || sessionName === "Sprint") {
    const ptsArr = sessionName === "Race" ? [25,18,15,12,10,8,6,4,2,1] : [8,7,6,5,4,3,2,1];
    const dnfPts = sessionName === "Race" ? -20 : -10;
    if (bd.dnf) {
      rows.push({ label: "DNF Penalty", value: "DNF", pts: dnfPts });
    } else if (bd.finish != null) {
      rows.push({ label: "Race Position", value: `P${bd.finish}`, pts: ptsArr[bd.finish - 1] || 0 });
    } else {
      rows.push({ label: "Race Position", value: "P11+", pts: 0 });
    }
    if (!bd.dnf && bd.gained > 0) {
      rows.push({ label: "Positions Gained", value: `+${bd.gained}`, pts: bd.gained });
    }
    if (bd.overtakes > 0) {
      rows.push({ label: "Overtake Bonus", value: bd.overtakes, pts: bd.overtakes });
    }
    if (bd.fl) rows.push({ label: "Fastest Lap", value: "Yes", pts: sessionName === "Race" ? 10 : 5 });
    if (bd.dotd) rows.push({ label: "Driver of the Day", value: "Yes", pts: 10 });
  }
  return rows;
}

// ── F1 Fantasy 2026 Scoring ───────────────────────────────────────────────────
// Race:          P1=25, P2=18, P3=15, P4=12, P5=10, P6=8, P7=6, P8=4, P9=2, P10=1
// Qualifying:    P1=10, P2=9 … P10=1
// Sprint Race:   P1=8, P2=7 … P8=1
// Sprint Quali:  No points awarded (official F1 Fantasy rules)
// +1 per position gained vs qualifying grid (race only)

const RACE_POINTS         = [25, 18, 15, 12, 10, 8, 6, 4, 2, 1];
const QUALI_POINTS        = [10,  9,  8,  7,  6, 5, 4, 3, 2, 1];
const SPRINT_POINTS       = [ 8,  7,  6,  5,  4, 3, 2, 1];

// driver.number → driver.id
const DRIVER_NUMBER_MAP = Object.fromEntries(DRIVERS.map(d => [d.number, d.id]));

// ── OpenF1 API ────────────────────────────────────────────────────────────────
const OPENF1_BASE = "https://api.openf1.org/v1";

async function openf1Get(path) {
  const res = await fetch(`${OPENF1_BASE}${path}`);
  if (!res.ok) throw new Error(`OpenF1 ${res.status} — ${path}`);
  return res.json();
}

// Returns final standings for a session: last position entry per driver, sorted by position
async function getSessionFinalStandings(sessionKey) {
  const entries = await openf1Get(`/position?session_key=${sessionKey}`);
  if (!entries.length) return [];
  const byDriver = {};
  entries.forEach(e => {
    if (!byDriver[e.driver_number] || e.date > byDriver[e.driver_number].date) {
      byDriver[e.driver_number] = e;
    }
  });
  return Object.values(byDriver).sort((a, b) => a.position - b.position);
}

const BUDGET = 100.0;
const MAX_DRIVERS = 5;

// ── Scoring helpers ───────────────────────────────────────────────────────────
async function getFastestLapDriver(sessionKey) {
  try {
    const laps = await openf1Get(`/laps?session_key=${sessionKey}`);
    const valid = laps.filter(l => l.lap_duration > 0 && !l.is_pit_out_lap);
    if (!valid.length) return null;
    return valid.reduce((best, l) => l.lap_duration < best.lap_duration ? l : best).driver_number;
  } catch { return null; }
}

async function getPitStops(sessionKey) {
  try {
    return await openf1Get(`/pit?session_key=${sessionKey}`);
  } catch { return []; }
}

function pitStopBonus(duration, isFastest) {
  let pts = 0;
  if (duration < 1.8)       pts = 35; // sub-1.8 world record (20 + 15 bonus)
  else if (duration < 2.0)  pts = 20;
  else if (duration < 2.2)  pts = 10;
  else if (duration <= 2.5)  pts =  5;
  else if (duration < 3.0)  pts =  2;
  if (isFastest) pts += 5;
  return pts;
}

function calcConstructorQualiBonus(constructorName, qualiPositions) {
  const teamNums = new Set(DRIVERS.filter(d => d.team === constructorName).map(d => d.number));
  const teamPos = qualiPositions.filter(p => teamNums.has(p.driver_number)).map(p => p.position);
  const q3count = teamPos.filter(pos => pos <= 10).length;
  const q2count = teamPos.filter(pos => pos <= 15).length;
  if (q3count === 2) return 10;
  if (q3count === 1) return 5;
  if (q2count === 2) return 3;
  if (q2count === 1) return 1;
  return -1;
}

// ── Auto-lineup helpers ────────────────────────────────────────────────────────

function hashUserId(str) {
  let h = 0;
  for (let i = 0; i < str.length; i++) h = Math.imul(31, h) + str.charCodeAt(i) | 0;
  return Math.abs(h);
}

function seededRng(seed) {
  let s = seed >>> 0;
  return () => {
    s = Math.imul(s ^ (s >>> 15), s | 1);
    s ^= s + Math.imul(s ^ (s >>> 7), s | 61);
    return ((s ^ (s >>> 14)) >>> 0) / 0x100000000;
  };
}

async function getFP3Results() {
  try {
    const year = new Date().getFullYear();
    const meetings = await openf1Get(`/meetings?year=${year}`);
    const now = Date.now();
    // Find the meeting closest to now (upcoming or just passed)
    const relevant = meetings
      .filter(m => !m.meeting_name.toLowerCase().includes("testing"))
      .sort((a, b) => Math.abs(new Date(a.date_start) - now) - Math.abs(new Date(b.date_start) - now));
    if (!relevant.length) return {};
    const meeting = relevant[0];
    const sessions = await openf1Get(`/sessions?meeting_key=${meeting.meeting_key}`);
    // Prefer FP3, fall back to FP2, then FP1
    const fp = sessions.find(s => s.session_name === "Practice 3")
            || sessions.find(s => s.session_name === "Practice 2")
            || sessions.find(s => s.session_name === "Practice 1");
    if (!fp) return { meetingName: meeting.meeting_name };
    const positions = await getSessionFinalStandings(fp.session_key);
    const posMap = {};
    positions.forEach((p, i) => { posMap[p.driver_number] = i + 1; });
    return { posMap, sessionName: fp.session_name, meetingName: meeting.meeting_name };
  } catch { return {}; }
}

function greedyPickDrivers(scoredDrivers, budgetRemaining, count) {
  const picked = [];
  let budget = budgetRemaining;
  for (const driver of scoredDrivers) {
    if (picked.length >= count) break;
    if (driver.price > budget) continue;
    // Ensure enough budget remains for all remaining slots at minimum price
    const slotsLeft = count - picked.length - 1;
    const cheapestRemaining = [...scoredDrivers]
      .filter(d => !picked.some(p => p.id === d.id) && d.id !== driver.id)
      .sort((a, b) => a.price - b.price)
      .slice(0, slotsLeft)
      .reduce((s, d) => s + d.price, 0);
    if (budget - driver.price >= cheapestRemaining) {
      picked.push(driver);
      budget -= driver.price;
    }
  }
  return picked.length === count ? picked : null;
}

function optimizeLineup(currentDrivers, fp3Map, userId = "") {
  const rng = seededRng(hashUserId(userId));
  const PERTURBATION = 0.14; // ±14% per-user variation — keeps lineups good but unique

  const NUM_DRIVERS = currentDrivers.length;
  const maxPts = Math.max(...currentDrivers.map(d => d.fantasyPoints || 0), 1);
  const maxValue = Math.max(...currentDrivers.map(d => (d.fantasyPoints || 0) / d.price), 0.01);

  const scoredDrivers = currentDrivers.map(d => {
    const fp3pos = fp3Map[d.number] || 15;
    const seasonScore  = (d.fantasyPoints || 0) / maxPts;
    const fp3Score     = (NUM_DRIVERS - fp3pos) / NUM_DRIVERS;
    const valueScore   = ((d.fantasyPoints || 0) / d.price) / maxValue;
    const base = seasonScore * 0.45 + fp3Score * 0.35 + valueScore * 0.20;
    const nudge = 1 + (rng() - 0.5) * 2 * PERTURBATION;
    return { ...d, score: base * nudge };
  }).sort((a, b) => b.score - a.score);

  const maxConPts = Math.max(...CONSTRUCTORS.map(c => c.points || 0), 1);
  const scoredConstructors = CONSTRUCTORS.map(c => {
    const teamDriverAvg = scoredDrivers
      .filter(d => d.team === c.name)
      .reduce((s, d, _, arr) => s + d.score / arr.length, 0);
    const valueScore = (c.points || 0) / maxConPts / c.price;
    const base = teamDriverAvg * 0.65 + valueScore * 0.35;
    const nudge = 1 + (rng() - 0.5) * 2 * PERTURBATION;
    return { ...c, score: base * nudge };
  }).sort((a, b) => b.score - a.score);

  // Try top N constructor pairs to find the best overall lineup
  const topCons = scoredConstructors.slice(0, 6);
  let best = null;
  for (let i = 0; i < topCons.length - 1; i++) {
    for (let j = i + 1; j < topCons.length; j++) {
      const cons = [topCons[i], topCons[j]];
      const consCost = cons.reduce((s, c) => s + c.price, 0);
      if (consCost > BUDGET - 5 * 4) continue; // leave at least $4m per driver slot
      const drivers = greedyPickDrivers(scoredDrivers, BUDGET - consCost, MAX_DRIVERS);
      if (!drivers) continue;
      const totalScore = drivers.reduce((s, d) => s + d.score, 0) + cons.reduce((s, c) => s + c.score, 0);
      if (!best || totalScore > best.totalScore) {
        best = { drivers, constructors: cons, captain: drivers[0], totalScore };
      }
    }
  }
  return best;
}

function PriceDelta({ item }) {
  if (!item?.prevPrice) return null;
  const delta = Math.round((item.price - item.prevPrice) * 10) / 10;
  if (delta === 0) return null;
  const up = delta > 0;
  return (
    <span style={{ fontSize: 10, fontWeight: 700, color: up ? "#0fd679" : "#e10600", marginLeft: 4 }}>
      {up ? "▲" : "▼"} ${Math.abs(delta).toFixed(1)}
    </span>
  );
}

function DriverCard({ driver, isOut, onClick }) {
  return (
    <div onClick={onClick} style={{ flex: 1, background: "var(--bg-card)", border: `1px solid ${isOut ? "#e1060044" : "var(--border)"}`, borderRadius: 12, overflow: "hidden", cursor: onClick ? "pointer" : "default", position: "relative" }}>
      {driver ? (
        <>
          <div style={{ background: driver.teamColor + "22", height: 100, display: "flex", alignItems: "flex-end", justifyContent: "center", overflow: "hidden" }}>
            <img src={`/drivers/driver-${driver.id}.png`} alt={driver.name} style={{ width: 90, height: 90, objectFit: "cover", objectPosition: "top center" }} />
          </div>
          <div style={{ padding: "8px 10px", borderTop: "1px solid var(--border-sub)" }}>
            <div style={{ fontFamily: "'Barlow Condensed', sans-serif", fontWeight: 900, fontSize: 14, textTransform: "uppercase", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
              {driver.name.split(" ")[0][0]}. <strong>{driver.name.split(" ").slice(1).join(" ").toUpperCase()}</strong>
            </div>
            <div style={{ fontSize: 11, color: "var(--text-muted)", marginTop: 2 }}>${driver.price}m</div>
          </div>
        </>
      ) : (
        <div style={{ height: 140, display: "flex", alignItems: "center", justifyContent: "center", color: "var(--text-faint)", fontSize: 13 }}>Select player</div>
      )}
    </div>
  );
}

function ConCard({ con, isOut, onClick }) {
  return (
    <div onClick={onClick} style={{ flex: 1, background: "var(--bg-card)", border: `1px solid ${isOut ? "#e1060044" : "var(--border)"}`, borderRadius: 12, overflow: "hidden", cursor: onClick ? "pointer" : "default" }}>
      {con ? (
        <div style={{ padding: "16px 12px", display: "flex", alignItems: "center", gap: 8 }}>
          <div style={{ width: 4, height: 32, borderRadius: 2, background: con.color, flexShrink: 0 }} />
          <div>
            <div style={{ fontFamily: "'Barlow Condensed', sans-serif", fontWeight: 900, fontSize: 14, textTransform: "uppercase" }}>{con.name}</div>
            <div style={{ fontSize: 11, color: "var(--text-muted)" }}>${con.price}m</div>
          </div>
        </div>
      ) : (
        <div style={{ height: 64, display: "flex", alignItems: "center", justifyContent: "center", color: "var(--text-faint)", fontSize: 13 }}>Select constructor</div>
      )}
    </div>
  );
}

export default function App() {
  const [session, setSession] = useState(undefined);

  useEffect(() => {
    supabase.auth.getSession().then(({ data: { session } }) => {
      setSession(session);
    });
    const { data: { subscription } } = supabase.auth.onAuthStateChange((_event, session) => {
      setSession(session);
    });
    return () => subscription.unsubscribe();
  }, []);

  if (session === undefined) return null;
  if (!session) return <AuthPage />;
  return <><F1Fantasy user={session.user} /><InstallPrompt /></>;
}

function F1Fantasy({ user }) {
  const [activeTab, setActiveTab] = useState("team");
  const [selectedDrivers, setSelectedDrivers] = useState([]);
  const [selectedConstructors, setSelectedConstructors] = useState([]);
  const [captain, setCaptain] = useState(null);
  const [filterTeam, setFilterTeam] = useState("All");
  const [sortBy, setSortBy] = useState("price");
  const [isDark, setIsDark] = useState(() => localStorage.getItem("theme") !== "light");
  const [toast, setToast] = useState(null); // { message, type: 'success'|'error' }
  const [searchQuery, setSearchQuery] = useState("");
  const [driverView, setDriverView] = useState("drivers");
  const [showCaptainModal, setShowCaptainModal] = useState(false);
  const [drivers, setDrivers] = useState(DRIVERS);
  const [syncStatus, setSyncStatus] = useState(null); // null | "loading" | "success" | "error"
  const [lastSynced, setLastSynced] = useState(null);
  const [raceLog, setRaceLog] = useState([]);
  const [syncedSessions, setSyncedSessions] = useState(new Set());
  const [now, setNow] = useState(() => new Date());
  const [leagues, setLeagues] = useState([]);
  const [leagueMembers, setLeagueMembers] = useState([]);
  const [expandedMember, setExpandedMember] = useState(null); // user_id
  const [selectedLeague, setSelectedLeague] = useState(null); // league object for drill-down
  const [selectedStatsDriver, setSelectedStatsDriver] = useState(null); // driver for breakdown modal
  const [memberTeams, setMemberTeams] = useState({}); // { user_id: team_data }
  const [memberRoundResults, setMemberRoundResults] = useState({}); // { user_id: round_results[] }
  const [showCreateLeague, setShowCreateLeague] = useState(false);
  const [newLeagueName, setNewLeagueName] = useState("");
  const [joinCode, setJoinCode] = useState("");
  const [leagueError, setLeagueError] = useState("");
  const [displayName, setDisplayName] = useState("");
  const [profileSaved, setProfileSaved] = useState(false);
  const [addMemberLeagueId, setAddMemberLeagueId] = useState(null);
  const [addMemberEmail, setAddMemberEmail] = useState("");
  const [addMemberError, setAddMemberError] = useState("");
  const [addMemberSuggestions, setAddMemberSuggestions] = useState([]);
  const [selectedRaceRound, setSelectedRaceRound] = useState(null);
  const [raceResults, setRaceResults] = useState({}); // keyed by race.round
  const [loadingRaceKey, setLoadingRaceKey] = useState(null);
  const [autoLineup, setAutoLineup] = useState(() => localStorage.getItem("autoLineup") !== "false");
  const [autoLineupNote, setAutoLineupNote] = useState(null); // { raceName, session } shown as banner
  const [isMobile, setIsMobile] = useState(() => window.innerWidth < 768);
  const [mobileTeamView, setMobileTeamView] = useState("pick"); // "pick" | "team"
  const [qualiPositions, setQualiPositions] = useState({}); // { driver_id: grid_position }
  const [constructors, setConstructors] = useState(CONSTRUCTORS); // with live fantasyPoints
  // Admin state
  const [adminRaces, setAdminRaces] = useState([]);
  const [adminSelectedMeeting, setAdminSelectedMeeting] = useState(null);
  const [adminDotd, setAdminDotd] = useState("");
  const [adminOvertakes, setAdminOvertakes] = useState({});
  const [adminSaving, setAdminSaving] = useState(false);
  const [adminLoading, setAdminLoading] = useState(false);

  // Transfer system state
  const [lockedTeam, setLockedTeam] = useState(null);
  const [allLockedTeams, setAllLockedTeams] = useState([]); // one per completed round, for scoring
  const [transferState, setTransferState] = useState(null); // { free_transfers, wildcard_used }
  const [freeTransfersStart, setFreeTransfersStart] = useState(2); // original allocation for this window
  const [pendingDrivers, setPendingDrivers] = useState([]);
  const [pendingConstructors, setPendingConstructors] = useState([]);
  const [pendingCaptain, setPendingCaptain] = useState(null);
  const [wildcardActive, setWildcardActive] = useState(false);
  const [transferPenalties, setTransferPenalties] = useState(0); // total penalty pts this user has
  const [pickingSlot, setPickingSlot] = useState(null); // { type: 'driver'|'constructor', replacing: driver|con|null }

  // Tick every second for countdown
  useEffect(() => {
    const t = setInterval(() => setNow(new Date()), 1000);
    return () => clearInterval(t);
  }, []);

  // Track mobile breakpoint
  useEffect(() => {
    const handler = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handler);
    return () => window.removeEventListener("resize", handler);
  }, []);

  // Compute next race + lock status
  // Once the first qualifying has started, teams are locked for the season (changes via transfers only)
  const SEASON_LOCK = new Date(RACES[0].qualiDate);
  const nextRace = RACES.find(r => !r.cancelled && new Date(r.raceDate) > now) || RACES[RACES.length - 1];
  const nextRaceLockDate = new Date(nextRace.qualiDate);
  const lockTime = now < SEASON_LOCK ? SEASON_LOCK : nextRaceLockDate;
  const isLocked = now >= SEASON_LOCK;
  const isRoundLocked = now >= nextRaceLockDate;
  const msUntilLock = isLocked ? Math.max(0, nextRaceLockDate - now) : Math.max(0, SEASON_LOCK - now);

  const lastCompletedRace = [...RACES].reverse().find(r => !r.cancelled && now > new Date(new Date(r.raceDate).getTime() + 2 * 3600 * 1000)) || null;
  const inTransferWindow = !!lastCompletedRace && now < nextRaceLockDate;

  const formatCountdown = (ms) => {
    if (ms <= 0) return "LOCKED";
    const d = Math.floor(ms / 86400000);
    const h = Math.floor((ms % 86400000) / 3600000);
    const m = Math.floor((ms % 3600000) / 60000);
    const s = Math.floor((ms % 60000) / 1000);
    if (d > 0) return `${d}d ${h}h ${m}m`;
    if (h > 0) return `${h}h ${m}m ${s}s`;
    return `${m}m ${s}s`;
  };

  function showToast(message, type = 'success') {
    setToast({ message, type });
    setTimeout(() => setToast(null), 3000);
  }

  // Load saved team on mount
  useEffect(() => {
    if (!user) return;
    supabase
      .from('teams')
      .select('*')
      .eq('user_id', user.id)
      .single()
      .then(({ data }) => {
        if (!data) return;
        if (data.driver_ids?.length) setSelectedDrivers(DRIVERS.filter(d => data.driver_ids.includes(String(d.id))));
        if (data.constructor_ids?.length) {
          setSelectedConstructors(CONSTRUCTORS.filter(c => data.constructor_ids.includes(String(c.id))));
        } else if (data.constructor_id) {
          const c = CONSTRUCTORS.find(c => String(c.id) === String(data.constructor_id));
          if (c) setSelectedConstructors([c]);
        }
        if (data.captain_id) setCaptain(DRIVERS.find(d => String(d.id) === String(data.captain_id)) || null);
      });
  }, [user]);

  // Load display name from user metadata
  useEffect(() => {
    if (!user) return;
    const name = user.user_metadata?.display_name
      || user.user_metadata?.full_name
      || user.user_metadata?.name
      || user.email.split("@")[0];
    setDisplayName(name);
  }, [user]);

  // Load leagues on mount
  useEffect(() => {
    if (!user) return;
    loadLeagues();
  }, [user]); // eslint-disable-line react-hooks/exhaustive-deps

  // Auto-join league from URL param or localStorage (post-OAuth)
  useEffect(() => {
    if (!user) return;
    const params = new URLSearchParams(window.location.search);
    const code = params.get("join") || params.get("code") || localStorage.getItem("pendingJoinCode");
    if (!code) return;
    window.history.replaceState({}, "", "/");
    localStorage.removeItem("pendingJoinCode");
    const upper = code.toUpperCase();
    // Auto-join silently then land on leagues tab
    supabase.from('leagues').select('*').eq('code', upper).single().then(({ data: league }) => {
      if (!league) { setJoinCode(upper); setActiveTab("leagues"); return; }
      supabase.from('league_members')
        .insert({ league_id: league.id, user_id: user.id, user_email: user.email, display_name: user.user_metadata?.display_name || user.email })
        .then(() => { loadLeagues(); setActiveTab("leagues"); });
    });
  }, [user]); // eslint-disable-line react-hooks/exhaustive-deps

  async function loadLeagues() {
    const { data: members } = await supabase
      .from('league_members')
      .select('league_id')
      .eq('user_id', user.id);
    const myLeagueIds = (members || []).map(m => m.league_id);
    if (myLeagueIds.length === 0) { setLeagues([]); setLeagueMembers([]); return; }
    const { data: leagueData } = await supabase
      .from('leagues')
      .select('*')
      .in('id', myLeagueIds);
    setLeagues(leagueData || []);
    const { data: allMembers } = await supabase
      .from('league_members')
      .select('*')
      .in('league_id', myLeagueIds);
    setLeagueMembers(allMembers || []);
    // Batch-fetch all member teams so we can compute live points for everyone
    const allUserIds = [...new Set((allMembers || []).map(m => m.user_id))];
    const { data: allTeams } = await supabase.from('teams').select('*').in('user_id', allUserIds);
    const teamsById = {};
    (allTeams || []).forEach(t => { teamsById[t.user_id] = t; });
    setMemberTeams(teamsById);
  }

  function countNetTransfers(locked, pending, pendingCons) {
    if (!locked) return 0;
    const oldD = new Set((locked.driver_ids || []).map(String));
    const newD = new Set(pending.map(d => String(d.id)));
    const oldC = new Set((locked.constructor_ids || []).map(String));
    const newC = new Set(pendingCons.map(c => String(c.id)));
    return [...oldD].filter(id => !newD.has(id)).length + [...oldC].filter(id => !newC.has(id)).length;
  }

  async function saveTransfers() {
    const netChanges = wildcardActive ? 0 : countNetTransfers(lockedTeam, pendingDrivers, pendingConstructors);
    const freeAvail = transferState?.free_transfers ?? 2;
    const extraTransfers = Math.max(0, netChanges - freeTransfersStart);
    const penalty = extraTransfers * 10;

    if (penalty > 0) {
      const ok = window.confirm(`You are making ${netChanges} transfer${netChanges > 1 ? 's' : ''} (${freeAvail} free). This will cost ${penalty} points. Proceed?`);
      if (!ok) return;
    }

    // Save team
    const { error } = await supabase.from('teams').upsert({
      user_id: user.id,
      driver_ids: pendingDrivers.map(d => String(d.id)),
      constructor_ids: pendingConstructors.map(c => String(c.id)),
      constructor_id: pendingConstructors[0] ? String(pendingConstructors[0].id) : null,
      captain_id: pendingCaptain ? String(pendingCaptain.id) : null,
      updated_at: new Date().toISOString(),
    }, { onConflict: 'user_id' });
    if (error) { showToast('Failed to save: ' + error.message, 'error'); return; }

    // Apply penalty
    if (penalty > 0) {
      await supabase.from('transfer_penalties').insert({
        user_id: user.id, round: nextRace.round, penalty_pts: -penalty,
      });
      setTransferPenalties(prev => prev - penalty);
    }

    // Update local team state
    setSelectedDrivers(pendingDrivers);
    setSelectedConstructors(pendingConstructors);
    setCaptain(pendingCaptain);

    // Store remaining free transfers for this window (rollover applied at next window open)
    const used = wildcardActive ? 0 : Math.min(netChanges, freeAvail);
    const remaining = Math.max(0, freeAvail - used);
    await supabase.from('transfer_state').upsert({
      user_id: user.id,
      free_transfers: remaining,
      round: nextRace.round,
      wildcard_used: wildcardActive ? true : (transferState?.wildcard_used || false),
    }, { onConflict: 'user_id' });
    setTransferState(prev => ({ ...prev, free_transfers: remaining, wildcard_used: wildcardActive ? true : prev?.wildcard_used }));
    setWildcardActive(false);

    showToast(penalty > 0 ? `Transfers saved (−${penalty} pts penalty)` : 'Transfers saved!', penalty > 0 ? 'error' : 'success');
  }

  function computeMemberPts(team) {
    if (!team?.driver_ids?.length) return 0;
    const captainId = team.captain_id ? String(team.captain_id) : null;
    const dPts = DRIVERS
      .filter(d => (team.driver_ids || []).map(String).includes(String(d.id)))
      .reduce((s, d) => {
        const live = drivers.find(ld => ld.id === d.id) || d;
        return s + (String(d.id) === captainId ? live.fantasyPoints * 2 : live.fantasyPoints);
      }, 0);
    const cPts = CONSTRUCTORS
      .filter(c => (team.constructor_ids || []).map(String).includes(String(c.id)))
      .reduce((s, c) => s + (constructors.find(lc => lc.id === c.id)?.points || 0), 0);
    return dPts + cPts;
  }

  function generateCode() {
    const chars = "ABCDEFGHJKLMNPQRSTUVWXYZ23456789";
    let code = "";
    for (let i = 0; i < 6; i++) code += chars[Math.floor(Math.random() * chars.length)];
    return code;
  }

  async function createLeague() {
    if (!newLeagueName.trim()) return;
    setLeagueError("");
    const code = generateCode();
    const { data, error } = await supabase
      .from('leagues')
      .insert({ name: newLeagueName.trim(), code, created_by: user.id })
      .select()
      .single();
    if (error) { setLeagueError(error.message); return; }
    // Auto-join the league
    await supabase
      .from('league_members')
      .insert({ league_id: data.id, user_id: user.id, user_email: user.email, display_name: displayName });
    setNewLeagueName("");
    setShowCreateLeague(false);
    loadLeagues();
  }

  async function joinLeague() {
    if (!joinCode.trim()) return;
    setLeagueError("");
    const { data: league, error: findErr } = await supabase
      .from('leagues')
      .select('*')
      .eq('code', joinCode.trim().toUpperCase())
      .single();
    if (findErr || !league) { setLeagueError("League not found. Check the code and try again."); return; }
    const { error: joinErr } = await supabase
      .from('league_members')
      .insert({ league_id: league.id, user_id: user.id, user_email: user.email, display_name: displayName });
    if (joinErr) {
      if (joinErr.code === '23505') setLeagueError("You're already in this league!");
      else setLeagueError(joinErr.message);
      return;
    }
    setJoinCode("");
    setLeagueError("");
    loadLeagues();
  }

  async function searchMembers(query, leagueId) {
    setAddMemberEmail(query);
    setAddMemberError("");
    if (query.length < 2) { setAddMemberSuggestions([]); return; }
    const { data } = await supabase
      .from('profiles')
      .select('email, display_name')
      .ilike('email', `%${query}%`)
      .limit(6);
    // Filter out users already in this league
    const inLeague = new Set(leagueMembers.filter(m => m.league_id === leagueId).map(m => m.user_email));
    setAddMemberSuggestions((data || []).filter(r => !inLeague.has(r.email)));
  }

  async function addMemberToLeague(leagueId) {
    const email = addMemberEmail.trim().toLowerCase();
    if (!email) return;
    setAddMemberError("");
    // Look up user from profiles table
    const { data: existing } = await supabase
      .from('profiles')
      .select('user_id, display_name, email')
      .eq('email', email)
      .limit(1);
    if (!existing || existing.length === 0) {
      setAddMemberError("User not found. They need to sign up first.");
      return;
    }
    const { user_id, display_name, email: user_email } = existing[0];
    const { error } = await supabase
      .from('league_members')
      .insert({ league_id: leagueId, user_id, user_email, display_name: display_name || user_email.split("@")[0] });
    if (error) {
      if (error.code === '23505') setAddMemberError("That user is already in this league.");
      else setAddMemberError(error.message);
      return;
    }
    setAddMemberEmail("");
    setAddMemberLeagueId(null);
    loadLeagues();
  }

  async function saveProfile() {
    const name = displayName.trim();
    if (!name) return;
    const { error } = await supabase.auth.updateUser({ data: { display_name: name } });
    if (error) { showToast('Failed to save: ' + error.message, 'error'); return; }
    await supabase.from('league_members').update({ display_name: name }).eq('user_id', user.id);
    await supabase.from('profiles').update({ display_name: name }).eq('user_id', user.id);
    loadLeagues();
    setProfileSaved(true);
    setTimeout(() => setProfileSaved(false), 2000);
  }

  async function leaveLeague(leagueId) {
    const league = leagues.find(l => l.id === leagueId);
    if (league && league.created_by === user.id) {
      if (!window.confirm(`Delete "${league.name}"? This will remove the league and all members permanently.`)) return;
      if (!window.confirm("Are you sure? This cannot be undone.")) return;
      await supabase.from('leagues').delete().eq('id', leagueId);
    } else {
      if (!window.confirm(`Leave "${league.name}"?`)) return;
      await supabase.from('league_members').delete()
        .eq('league_id', leagueId).eq('user_id', user.id);
    }
    loadLeagues();
  }

  async function clearTeam() {
    if (isLocked) return;
    setSelectedDrivers([]);
    setSelectedConstructors([]);
    setCaptain(null);
    await supabase.from('teams').upsert({
      user_id: user.id,
      driver_ids: [],
      constructor_ids: [],
      constructor_id: null,
      captain_id: null,
      updated_at: new Date().toISOString(),
    }, { onConflict: 'user_id' });
    showToast("Team cleared", "info");
  }

  async function saveTeam() {
    if (isLocked) return;
    const { error } = await supabase
      .from('teams')
      .upsert({
        user_id: user.id,
        driver_ids: selectedDrivers.map(d => String(d.id)),
        constructor_ids: selectedConstructors.map(c => String(c.id)),
        constructor_id: selectedConstructors[0] ? String(selectedConstructors[0].id) : null,
        captain_id: captain ? String(captain.id) : null,
        updated_at: new Date().toISOString(),
      }, { onConflict: 'user_id' });
    if (error) { showToast('Failed to save: ' + error.message, 'error'); return; }
    loadLeagues();
    showToast('Team saved!');
  }

  async function applyAutoLineup() {
    const { posMap = {}, sessionName = "Practice", meetingName = "race" } = await getFP3Results();
    const lineup = optimizeLineup(drivers, posMap, user.id);
    if (!lineup) return;
    setSelectedDrivers(lineup.drivers);
    setSelectedConstructors(lineup.constructors);
    setCaptain(lineup.captain);
    // Save immediately
    const { error } = await supabase.from('teams').upsert({
      user_id: user.id,
      driver_ids: lineup.drivers.map(d => String(d.id)),
      constructor_ids: lineup.constructors.map(c => String(c.id)),
      constructor_id: lineup.constructors[0] ? String(lineup.constructors[0].id) : null,
      captain_id: lineup.captain ? String(lineup.captain.id) : null,
      updated_at: new Date().toISOString(),
    }, { onConflict: 'user_id' });
    if (!error) {
      const note = { raceName: meetingName, session: sessionName };
      setAutoLineupNote(note);
      localStorage.setItem("autoLineupNote", JSON.stringify(note));
      showToast(`Auto-lineup applied for ${meetingName}!`);
    }
  }

  // Trigger auto-lineup: locked + no saved team + autoLineup enabled
  useEffect(() => {
    if (!isLocked || !autoLineup) return;
    supabase.from('teams').select('user_id').eq('user_id', user.id).single()
      .then(({ data }) => {
        if (!data) applyAutoLineup();
      });
  }, [isLocked]); // eslint-disable-line react-hooks/exhaustive-deps

  // Snapshot locked team when the upcoming race actually locks (sprint quali or regular quali)
  useEffect(() => {
    if (!isRoundLocked || !user || !nextRace || selectedDrivers.length === 0) return;
    supabase.from('locked_teams')
      .select('user_id').eq('user_id', user.id).eq('round', nextRace.round).maybeSingle()
      .then(async ({ data }) => {
        if (!data) {
          const spent = selectedDrivers.reduce((s, d) => s + d.price, 0) + selectedConstructors.reduce((s, c) => s + c.price, 0);
          // Load most recent locked team (skip cancelled rounds) to compute running budget balance (stock market model)
          const { data: prevLocked } = await supabase.from('locked_teams')
            .select('*').eq('user_id', user.id).lt('round', nextRace.round).order('round', { ascending: false }).limit(1).maybeSingle();
          const prevHeadroom = prevLocked ? parseFloat(prevLocked.budget_remaining || 0) : BUDGET;
          const prevSpent = (prevLocked?.driver_ids || []).map(id => DRIVERS.find(d => String(d.id) === String(id))).filter(Boolean).reduce((s, d) => s + d.price, 0)
            + (prevLocked?.constructor_ids || []).map(id => CONSTRUCTORS.find(c => String(c.id) === String(id))).filter(Boolean).reduce((s, c) => s + c.price, 0);
          supabase.from('locked_teams').insert({
            user_id: user.id, round: nextRace.round,
            driver_ids: selectedDrivers.map(d => String(d.id)),
            constructor_ids: selectedConstructors.map(c => String(c.id)),
            captain_id: captain ? Number(captain.id) : null,
            budget_remaining: prevHeadroom + prevSpent - spent,
          });
        }
      });
  }, [isRoundLocked, user?.id, nextRace?.round]); // eslint-disable-line react-hooks/exhaustive-deps

  // Load transfer data when transfer window opens
  useEffect(() => {
    if (!user || !inTransferWindow || !lastCompletedRace) return;
    // Load most recent locked team at or before last completed race
    supabase.from('locked_teams')
      .select('*').eq('user_id', user.id).lte('round', lastCompletedRace.round).order('round', { ascending: false }).limit(1).maybeSingle()
      .then(({ data }) => setLockedTeam(data || null));
    // Load transfer state — if stored round differs from current window, compute new allocation (rollover)
    supabase.from('transfer_state')
      .select('*').eq('user_id', user.id).maybeSingle()
      .then(({ data }) => {
        if (!data || data.round !== nextRace.round) {
          // Compute free transfer allocation for this window:
          // - No prior state (null round): if races have been completed, user missed at least one window → 3; otherwise first-ever → 2
          // - State is stale (round < last completed): user missed the most recent window, had unused transfers → 3
          // - State is current (round = last completed): normal rollover
          let newFree;
          if (!data || data.round === null) {
            newFree = lastCompletedRace ? 3 : 2;
          } else if (data.round < lastCompletedRace.round) {
            newFree = 3;
          } else {
            newFree = Math.min(3, 2 + Math.min(1, data.free_transfers ?? 2));
          }
          const newState = { free_transfers: newFree, wildcard_used: data?.wildcard_used || false, round: nextRace.round };
          supabase.from('transfer_state').upsert({ user_id: user.id, ...newState }, { onConflict: 'user_id' });
          setTransferState(newState);
          setFreeTransfersStart(newFree);
        } else {
          setTransferState(data);
          setFreeTransfersStart(data.free_transfers ?? 2);
        }
      });
    // Load total penalties
    supabase.from('transfer_penalties')
      .select('penalty_pts').eq('user_id', user.id)
      .then(({ data }) => setTransferPenalties(data ? data.reduce((s, r) => s + r.penalty_pts, 0) : 0));
  }, [inTransferWindow, user?.id]); // eslint-disable-line react-hooks/exhaustive-deps

  // Init pending team whenever selectedDrivers loads (handles async timing)
  useEffect(() => {
    if (selectedDrivers.length > 0 && pendingDrivers.length === 0) {
      setPendingDrivers([...selectedDrivers]);
      setPendingConstructors([...selectedConstructors]);
      setPendingCaptain(captain);
    }
  }, [selectedDrivers.length]); // eslint-disable-line react-hooks/exhaustive-deps

  // Always load all locked team snapshots for scoring
  useEffect(() => {
    if (!user) return;
    supabase.from('locked_teams').select('*').eq('user_id', user.id)
      .then(({ data }) => setAllLockedTeams(data || []));
  }, [user?.id]); // eslint-disable-line react-hooks/exhaustive-deps

  // Keep league_members.total_points in sync from round_results (immutable) + penalties
  useEffect(() => {
    if (!user) return;
    supabase.from('round_results').select('total_points').eq('user_id', user.id)
      .then(({ data }) => {
        if (!data || data.length === 0) return;
        const myPts = data.reduce((s, r) => s + (r.total_points || 0), 0) + transferPenalties;
        supabase.from('league_members').update({ total_points: myPts }).eq('user_id', user.id);
      });
  }, [transferPenalties]); // eslint-disable-line react-hooks/exhaustive-deps

  // Show persisted auto-lineup note on load
  useEffect(() => {
    const stored = localStorage.getItem("autoLineupNote");
    if (stored) { try { setAutoLineupNote(JSON.parse(stored)); } catch {} }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  // On mount: load cached results from DB, then silently check for new sessions
  useEffect(() => {
    loadScoredSessions().then(() => syncResults(true));
    // Poll every 10 minutes for new completed sessions
    const interval = setInterval(() => syncResults(true), 10 * 60 * 1000);
    return () => clearInterval(interval);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  // Load cached scored results from Supabase — no OpenF1 calls
  async function loadScoredSessions() {
    const { data, error } = await supabase.from('scored_sessions').select('*').order('scored_at', { ascending: true });
    if (error || !data?.length) return;

    const totalPts = {};
    const totalConPts = {};
    data.forEach(s => {
      if (s.driver_points) {
        Object.entries(s.driver_points).forEach(([id, pts]) => {
          totalPts[parseInt(id)] = (totalPts[parseInt(id)] || 0) + pts;
        });
      }
      if (s.constructor_points) {
        Object.entries(s.constructor_points).forEach(([id, pts]) => {
          totalConPts[parseInt(id)] = (totalConPts[parseInt(id)] || 0) + pts;
        });
      }
    });
    setDrivers(DRIVERS.map(d => ({ ...d, fantasyPoints: totalPts[d.id] || 0 })));
    setConstructors(CONSTRUCTORS.map(c => ({ ...c, points: totalConPts[c.id] || 0 })));
    setSyncedSessions(new Set(data.map(s => s.session_key)));
    setRaceLog(
      data
        .filter(s => s.driver_points && Object.keys(s.driver_points).length > 0)
        .reverse()
        .map(s => ({ session_name: s.session_name, session_key: s.session_key, meeting_name: s.meeting_name, top5: s.top5 || [], pts: s.driver_points || {}, breakdown: s.driver_breakdown || {}, scored: true }))
    );
    const lastQuali = [...data].reverse().find(s => s.session_name === 'Qualifying' && s.quali_order?.length);
    if (lastQuali) {
      const qp = {};
      lastQuali.quali_order.forEach((driverNum, i) => {
        const id = DRIVER_NUMBER_MAP[driverNum];
        if (id !== undefined) qp[id] = i + 1;
      });
      setQualiPositions(qp);
    }
    setLastSynced(new Date().toLocaleTimeString());
  }

  // Fetch new sessions from OpenF1, score them, and save to DB
  async function syncResults(silent = false) {
    if (!silent) setSyncStatus("loading");
    try {
      const now = new Date();
      const year = now.getFullYear();

      // Load already-scored keys from DB (source of truth — survives refresh)
      const { data: existing } = await supabase.from('scored_sessions').select('session_key');
      const scoredKeys = new Set((existing || []).map(r => r.session_key));

      const meetings = await openf1Get(`/meetings?year=${year}`);
      const started = meetings
        .filter(m => !m.meeting_name.toLowerCase().includes("testing"))
        .filter(m => new Date(m.date_start) <= now)
        .sort((a, b) => new Date(a.date_start) - new Date(b.date_start));

      if (!started.length) {
        if (!silent) { setSyncStatus("success"); setTimeout(() => setSyncStatus(null), 2000); }
        return;
      }

      const newLog = [];
      let totalNewPts = {};
      let totalNewConPts = {};
      let hadNew = false;

      for (const meeting of started) {
        const allSessions = await openf1Get(`/sessions?meeting_key=${meeting.meeting_key}`);
        const completed = allSessions
          .filter(s => new Date(s.date_end) < now)
          .sort((a, b) => new Date(a.date_start) - new Date(b.date_start));

        const newSessions = completed.filter(s => !scoredKeys.has(s.session_key));
        if (!newSessions.length) continue;

        hadNew = true;

        // Reconstruct quali standings from DB if already scored (needed for race grid)
        let qualiStandings = null;
        let sprintQualiStandings = null;
        const qualiSession = completed.find(s => s.session_name === 'Qualifying' && scoredKeys.has(s.session_key));
        if (qualiSession) {
          const { data: qs } = await supabase.from('scored_sessions').select('quali_order').eq('session_key', qualiSession.session_key).maybeSingle();
          if (qs?.quali_order) qualiStandings = qs.quali_order.map((num, i) => ({ driver_number: num, position: i + 1 }));
        }
        const sprintQualiSession = completed.find(s => s.session_name === 'Sprint Qualifying' && scoredKeys.has(s.session_key));
        if (sprintQualiSession) {
          const { data: sqs } = await supabase.from('scored_sessions').select('quali_order').eq('session_key', sprintQualiSession.session_key).maybeSingle();
          if (sqs?.quali_order) sprintQualiStandings = sqs.quali_order.map((num, i) => ({ driver_number: num, position: i + 1 }));
        }

        for (const session of newSessions) {
          const { session_key, session_name } = session;
          const positions = await getSessionFinalStandings(session_key);
          const top5 = positions.slice(0, 5).map(p => ({ driver_number: p.driver_number, position: p.position }));
          const classified = new Set(positions.map(p => p.driver_number));
          const dnfIds = DRIVERS.filter(d => !classified.has(d.number)).map(d => d.id);

          let pts = {};
          let conPts = {};
          let breakdown = {};
          let scored = false;
          let qualiOrder = null;

          if (session_name === "Qualifying") {
            qualiStandings = positions;
            qualiOrder = positions.map(p => p.driver_number);
            const newQualiPos = {};
            positions.forEach((p, i) => {
              const id = DRIVER_NUMBER_MAP[p.driver_number];
              if (id !== undefined) {
                pts[id] = QUALI_POINTS[i] || 0;
                newQualiPos[id] = i + 1;
                breakdown[id] = { pos: i + 1 };
              }
            });
            setQualiPositions(newQualiPos);
            // Drivers who never set a valid lap time (no time / DNS) → -5
            const laps = await openf1Get(`/laps?session_key=${session_key}`);
            const driversWithTime = new Set(laps.filter(l => !l.is_pit_out_lap && l.lap_duration != null).map(l => l.driver_number));
            DRIVERS.forEach(d => {
              if (!driversWithTime.has(d.number)) { pts[d.id] = -5; breakdown[d.id] = { no_time: true }; }
            });
            // Constructor points: driver sum + Q2/Q3 bonus
            CONSTRUCTORS.forEach(c => {
              const dPts = DRIVERS.filter(d => d.team === c.name).reduce((s, d) => s + (pts[d.id] || 0), 0);
              conPts[c.id] = dPts + calcConstructorQualiBonus(c.name, positions);
            });
            scored = true;

          } else if (session_name === "Sprint Qualifying") {
            // Sprint Qualifying does not award fantasy points (official F1 Fantasy rules).
            // We still track the order for use as the sprint race grid.
            sprintQualiStandings = positions;
            qualiOrder = positions.map(p => p.driver_number);
            CONSTRUCTORS.forEach(c => { conPts[c.id] = 0; });
            scored = true;

          } else if (session_name === "Sprint") {
            const sprintGridMap = {};
            if (sprintQualiStandings) sprintQualiStandings.forEach((q, i) => { sprintGridMap[q.driver_number] = i + 1; });
            positions.forEach((p, i) => {
              const id = DRIVER_NUMBER_MAP[p.driver_number];
              if (id === undefined) return;
              const grid = sprintGridMap[p.driver_number] || null;
              const gained = grid ? (grid - (i + 1)) : 0;
              pts[id] = (SPRINT_POINTS[i] || 0) + gained;
              breakdown[id] = { finish: i < 8 ? i + 1 : null, grid, gained, fl: false, dnf: false };
            });
            // Detect DNFs via lap count
            const sprintLaps = await openf1Get(`/laps?session_key=${session_key}`);
            const sprintLapsByDriver = {};
            sprintLaps.forEach(l => { sprintLapsByDriver[l.driver_number] = (sprintLapsByDriver[l.driver_number] || 0) + 1; });
            const sprintMaxLaps = Math.max(...Object.values(sprintLapsByDriver), 0);
            const sprintDnfIds = DRIVERS.filter(d => !sprintLapsByDriver[d.number] || sprintLapsByDriver[d.number] < sprintMaxLaps * 0.9).map(d => d.id);
            sprintDnfIds.forEach(id => { pts[id] = -10; if (breakdown[id]) { breakdown[id].dnf = true; breakdown[id].gained = 0; } });
            const fl = await getFastestLapDriver(session_key);
            if (fl !== null) { const id = DRIVER_NUMBER_MAP[fl]; if (id !== undefined) { pts[id] = (pts[id] || 0) + 5; if (breakdown[id]) breakdown[id].fl = true; } }
            CONSTRUCTORS.forEach(c => {
              conPts[c.id] = DRIVERS.filter(d => d.team === c.name).reduce((s, d) => s + (pts[d.id] || 0), 0);
            });
            scored = true;

          } else if (session_name === "Race") {
            const gridMap = {};
            if (qualiStandings) qualiStandings.forEach((q, i) => { gridMap[q.driver_number] = i + 1; });
            positions.forEach((p, i) => {
              const id = DRIVER_NUMBER_MAP[p.driver_number];
              if (id === undefined) return;
              const grid = gridMap[p.driver_number] || null;
              const gained = grid ? (grid - (i + 1)) : 0;
              pts[id] = (RACE_POINTS[i] || 0) + gained;
              breakdown[id] = { finish: i < 10 ? i + 1 : null, grid, gained, overtakes: 0, fl: false, dotd: false, dnf: false };
            });
            // Detect DNFs via lap count — OpenF1 position endpoint includes all 22 drivers even if retired
            const raceLaps = await openf1Get(`/laps?session_key=${session_key}`);
            const lapsByDriver = {};
            raceLaps.forEach(l => { lapsByDriver[l.driver_number] = (lapsByDriver[l.driver_number] || 0) + 1; });
            const maxLaps = Math.max(...Object.values(lapsByDriver), 0);
            const raceDnfIds = DRIVERS.filter(d => !lapsByDriver[d.number] || lapsByDriver[d.number] < maxLaps * 0.9).map(d => d.id);
            raceDnfIds.forEach(id => { pts[id] = -20; if (breakdown[id]) { breakdown[id].dnf = true; breakdown[id].gained = 0; } });
            const fl = await getFastestLapDriver(session_key);
            if (fl !== null) { const id = DRIVER_NUMBER_MAP[fl]; if (id !== undefined) { pts[id] = (pts[id] || 0) + 10; if (breakdown[id]) breakdown[id].fl = true; } }
            const { data: manualData } = await supabase.from('manual_scoring').select('*').eq('session_key', session.meeting_key).maybeSingle();
            if (manualData) {
              if (manualData.dotd_driver_id != null) {
                pts[manualData.dotd_driver_id] = (pts[manualData.dotd_driver_id] || 0) + 10;
                if (breakdown[manualData.dotd_driver_id]) breakdown[manualData.dotd_driver_id].dotd = true;
              }
              if (manualData.overtakes) {
                Object.entries(manualData.overtakes).forEach(([dId, cnt]) => {
                  const id = parseInt(dId); const n = parseInt(cnt);
                  pts[id] = (pts[id] || 0) + n;
                  if (breakdown[id]) breakdown[id].overtakes = n;
                });
              }
            }
            // Constructor points: driver sum + pit stop bonus
            const pits = await getPitStops(session_key);
            const validPits = pits.filter(p => (p.stop_duration ?? p.pit_duration) > 0);
            const durOf = p => p.stop_duration ?? p.pit_duration;
            const fastestOverall = validPits.length ? Math.min(...validPits.map(durOf)) : Infinity;
            CONSTRUCTORS.forEach(c => {
              const teamNums = new Set(DRIVERS.filter(d => d.team === c.name).map(d => d.number));
              const dPts = DRIVERS.filter(d => d.team === c.name).reduce((s, d) => s + (pts[d.id] || 0), 0);
              const teamPits = validPits.filter(p => teamNums.has(p.driver_number));
              const bestPit = teamPits.length ? Math.min(...teamPits.map(durOf)) : null;
              const pitBonus = bestPit ? pitStopBonus(bestPit, bestPit === fastestOverall) : 0;
              conPts[c.id] = dPts + pitBonus;
            });
            scored = true;
          }
          // Practice — no fantasy points

          // Persist to DB
          await supabase.from('scored_sessions').upsert({
            session_key,
            meeting_key: meeting.meeting_key,
            meeting_name: meeting.meeting_name,
            session_name,
            driver_points: scored ? pts : null,
            constructor_points: scored && Object.keys(conPts).length ? conPts : null,
            quali_order: qualiOrder,
            top5,
            driver_breakdown: scored ? breakdown : null,
            scored_at: new Date().toISOString(),
          }, { onConflict: 'session_key' });

          scoredKeys.add(session_key);

          if (scored) {
            Object.entries(pts).forEach(([id, p]) => {
              totalNewPts[id] = (totalNewPts[id] || 0) + p;
            });
            Object.entries(conPts).forEach(([id, p]) => {
              totalNewConPts[id] = (totalNewConPts[id] || 0) + p;
            });
          }
          newLog.push({ session_name, session_key, meeting_name: meeting.meeting_name, top5, pts, breakdown, scored });
        }
      }

      if (Object.keys(totalNewPts).length > 0) {
        setDrivers(prev => prev.map(d => ({ ...d, fantasyPoints: (d.fantasyPoints || 0) + (totalNewPts[d.id] || 0) })));
      }
      if (Object.keys(totalNewConPts).length > 0) {
        setConstructors(prev => prev.map(c => ({ ...c, points: (c.points || 0) + (totalNewConPts[c.id] || 0) })));
      }
      if (hadNew) {
        setSyncedSessions(new Set(scoredKeys));
        setRaceLog(prev => [...newLog, ...prev]);
      }
      setLastSynced(new Date().toLocaleTimeString());
      if (!silent) { setSyncStatus("success"); setTimeout(() => setSyncStatus(null), 3000); }
    } catch (e) {
      console.error("Sync error:", e.message);
      if (!silent) { setSyncStatus("error"); setTimeout(() => setSyncStatus(null), 4000); }
    }
  }

  async function loadAdminRaces() {
    setAdminLoading(true);
    try {
      const year = new Date().getFullYear();
      const meetings = await openf1Get(`/meetings?year=${year}`);
      const completed = meetings
        .filter(m => !m.meeting_name.toLowerCase().includes("testing"))
        .filter(m => new Date(m.date_start) <= new Date())
        .sort((a, b) => new Date(b.date_start) - new Date(a.date_start));
      setAdminRaces(completed);
      if (completed.length) {
        setAdminSelectedMeeting(completed[0]);
        loadAdminScoring(completed[0].meeting_key);
      }
    } catch (e) {
      console.error("Admin load error:", e);
    }
    setAdminLoading(false);
  }

  async function loadAdminScoring(meetingKey) {
    const { data } = await supabase.from('manual_scoring').select('*').eq('session_key', meetingKey).maybeSingle();
    if (data) {
      setAdminDotd(data.dotd_driver_id != null ? String(data.dotd_driver_id) : "");
      setAdminOvertakes(data.overtakes || {});
    } else {
      setAdminDotd("");
      setAdminOvertakes({});
    }
  }

  async function saveManualScoring() {
    if (!adminSelectedMeeting) return;
    setAdminSaving(true);
    const payload = {
      session_key: adminSelectedMeeting.meeting_key,
      meeting_name: adminSelectedMeeting.meeting_name,
      dotd_driver_id: adminDotd ? parseInt(adminDotd) : null,
      overtakes: adminOvertakes,
      updated_at: new Date().toISOString(),
    };
    const { error } = await supabase.from('manual_scoring').upsert(payload, { onConflict: 'session_key' });
    if (error) showToast("Save failed: " + error.message, "error");
    else showToast("Manual scoring saved!", "success");
    setAdminSaving(false);
  }

  async function loadRaceWeekend(race) {
    const roundKey = race.round;
    if (raceResults[roundKey]?.loaded) return;
    setLoadingRaceKey(roundKey);
    try {
      const year = new Date(race.raceDate).getFullYear();
      const meetings = await openf1Get(`/meetings?year=${year}`);
      const raceDate = new Date(race.raceDate);
      const meeting = meetings
        .filter(m => !m.meeting_name.toLowerCase().includes("testing"))
        .find(m => Math.abs(new Date(m.date_start) - raceDate) < 8 * 86400000);

      if (!meeting) {
        setRaceResults(prev => ({ ...prev, [roundKey]: { loaded: true, noData: true, sessions: [] } }));
        setLoadingRaceKey(null);
        return;
      }

      const allSessions = await openf1Get(`/sessions?meeting_key=${meeting.meeting_key}`);
      const nowMs = Date.now();
      const sessionsData = [];
      let qualiPositions = null;
      let sprintQualiPositions = null;

      for (const session of allSessions.sort((a, b) => new Date(a.date_start) - new Date(b.date_start))) {
        const sessionStart = new Date(session.date_start);
        const sessionEnd = new Date(session.date_end);
        const isLive = sessionStart <= nowMs && nowMs <= sessionEnd.getTime() + 45 * 60000;
        const isCompleted = sessionEnd < nowMs && !isLive;
        const isUpcoming = sessionStart > nowMs;

        let positions = [];
        let pts = {};           // driver id → fantasy pts
        let constructorPts = {}; // constructor name → { driverPts, bonus, bestPit, total }
        let fastestLapNum = null;

        if (isCompleted || isLive) {
          try {
            positions = await getSessionFinalStandings(session.session_key);
            const { session_name } = session;
            const classified = new Set(positions.map(p => p.driver_number));
            const dnfIds = DRIVERS.filter(d => !classified.has(d.number)).map(d => d.id);

            if (session_name === "Qualifying") {
              qualiPositions = positions;
              positions.forEach((p, i) => {
                const id = DRIVER_NUMBER_MAP[p.driver_number];
                if (id !== undefined) pts[id] = QUALI_POINTS[i] || 0;
              });
              dnfIds.forEach(id => { pts[id] = -5; });
              // Constructor Q2/Q3 bonuses
              CONSTRUCTORS.forEach(c => {
                const driverPts = DRIVERS.filter(d => d.team === c.name).reduce((s, d) => s + (pts[d.id] || 0), 0);
                const bonus = calcConstructorQualiBonus(c.name, positions);
                constructorPts[c.name] = { driverPts, bonus, total: driverPts + bonus };
              });

            } else if (session_name === "Sprint Qualifying") {
              // Sprint Qualifying does not award fantasy points (official F1 Fantasy rules).
              // We still track positions for use as the sprint race grid.
              sprintQualiPositions = positions;
              CONSTRUCTORS.forEach(c => { constructorPts[c.name] = { driverPts: 0, total: 0 }; });

            } else if (session_name === "Sprint") {
              const sprintGridMap = {};
              if (sprintQualiPositions) sprintQualiPositions.forEach((q, i) => { sprintGridMap[q.driver_number] = i + 1; });
              positions.forEach((p, i) => {
                const id = DRIVER_NUMBER_MAP[p.driver_number];
                if (id === undefined) return;
                pts[id] = SPRINT_POINTS[i] || 0;
                const grid = sprintGridMap[p.driver_number];
                if (grid) pts[id] += (grid - (i + 1));
              });
              dnfIds.forEach(id => { pts[id] = -10; });
              fastestLapNum = await getFastestLapDriver(session.session_key);
              if (fastestLapNum !== null) {
                const id = DRIVER_NUMBER_MAP[fastestLapNum];
                if (id !== undefined) pts[id] = (pts[id] || 0) + 5;
              }
              CONSTRUCTORS.forEach(c => {
                const total = DRIVERS.filter(d => d.team === c.name).reduce((s, d) => s + (pts[d.id] || 0), 0);
                constructorPts[c.name] = { total };
              });

            } else if (session_name === "Race") {
              const gridMap = {};
              if (qualiPositions) qualiPositions.forEach((q, i) => { gridMap[q.driver_number] = i + 1; });
              positions.forEach((p, i) => {
                const id = DRIVER_NUMBER_MAP[p.driver_number];
                if (id === undefined) return;
                pts[id] = RACE_POINTS[i] || 0;
                const grid = gridMap[p.driver_number];
                if (grid) pts[id] += Math.max(0, grid - (i + 1));
              });
              dnfIds.forEach(id => { pts[id] = -20; });
              fastestLapNum = await getFastestLapDriver(session.session_key);
              if (fastestLapNum !== null) {
                const id = DRIVER_NUMBER_MAP[fastestLapNum];
                if (id !== undefined) pts[id] = (pts[id] || 0) + 10;
              }
              // Constructor pitstop bonuses
              const pits = await getPitStops(session.session_key);
              const validPits = pits.filter(p => p.pit_duration > 0);
              const fastestOverall = validPits.length ? Math.min(...validPits.map(p => p.pit_duration)) : Infinity;
              CONSTRUCTORS.forEach(c => {
                const teamDriverNums = new Set(DRIVERS.filter(d => d.team === c.name).map(d => d.number));
                const driverPts = DRIVERS.filter(d => d.team === c.name).reduce((s, d) => s + (pts[d.id] || 0), 0);
                const teamPits = validPits.filter(p => teamDriverNums.has(p.driver_number));
                let bestPit = null, pitBonus = 0;
                if (teamPits.length) {
                  bestPit = Math.min(...teamPits.map(p => p.pit_duration));
                  pitBonus = pitStopBonus(bestPit, bestPit === fastestOverall);
                }
                constructorPts[c.name] = { driverPts, pitBonus, bestPit, total: driverPts + pitBonus };
              });
            }
            // Practice — no fantasy pts, just show order
          } catch (e) { /* data not ready */ }
        }

        sessionsData.push({ session, positions: positions.slice(0, 20), pts, constructorPts, fastestLapNum, isCompleted, isLive, isUpcoming });
      }

      setRaceResults(prev => ({ ...prev, [roundKey]: { loaded: true, sessions: sessionsData, meeting } }));
    } catch (e) {
      setRaceResults(prev => ({ ...prev, [roundKey]: { loaded: true, noData: true, sessions: [], error: e.message } }));
    }
    setLoadingRaceKey(null);
  }

  // Auto-refresh live sessions every 30s
  useEffect(() => {
    if (activeTab !== "races" || !selectedRaceRound) return;
    const roundData = raceResults[selectedRaceRound];
    if (!roundData?.sessions?.some(s => s.isLive)) return;
    const interval = setInterval(() => {
      const race = RACES.find(r => r.round === selectedRaceRound);
      if (race) {
        setRaceResults(prev => {
          const next = { ...prev };
          if (next[selectedRaceRound]) next[selectedRaceRound] = { ...next[selectedRaceRound], loaded: false };
          return next;
        });
        loadRaceWeekend(race);
      }
    }, 30000);
    return () => clearInterval(interval);
  }, [activeTab, selectedRaceRound, raceResults]); // eslint-disable-line react-hooks/exhaustive-deps

  const spent = selectedDrivers.reduce((s, d) => s + d.price, 0) + selectedConstructors.reduce((s, c) => s + c.price, 0);
  const remaining = (() => {
    if (isLocked && lockedTeam) {
      const lockedSpent = (lockedTeam.driver_ids || []).map(id => DRIVERS.find(d => String(d.id) === String(id))).filter(Boolean).reduce((s, d) => s + d.price, 0)
        + (lockedTeam.constructor_ids || []).map(id => CONSTRUCTORS.find(c => String(c.id) === String(id))).filter(Boolean).reduce((s, c) => s + c.price, 0);
      return parseFloat(lockedTeam.budget_remaining || 0) + lockedSpent - spent;
    }
    return Math.max(0, BUDGET - spent);
  })();
  const totalPoints = selectedDrivers.reduce((s, d) => {
    const live = drivers.find(ld => ld.id === d.id) || d;
    const pts = live.id === captain?.id ? live.fantasyPoints * 2 : live.fantasyPoints;
    return s + pts;
  }, 0) + selectedConstructors.reduce((s, c) => s + (constructors.find(lc => lc.id === c.id)?.points || 0), 0);
  // Use persisted DB value for display — immune to transfer changes
  const myMember = leagueMembers.find(m => m.user_id === user?.id);
  const displayPoints = myMember?.total_points ?? (isLocked ? 0 : totalPoints);

  const budgetAfterRemoving = (driver) => BUDGET - (spent - driver.price);
  const canAddDriver = (driver) => BUDGET - spent >= driver.price;
  const canAddConstructor = (c) => {
    const isSelected = selectedConstructors.some(sc => sc.id === c.id);
    return isSelected || (selectedConstructors.length < 2 && BUDGET - spent >= c.price);
  };

  const teams = ["All", ...new Set(drivers.map(d => d.team))].sort();

  const filtered = drivers
    .filter(d => filterTeam === "All" || d.team === filterTeam)
    .filter(d => d.name.toLowerCase().includes(searchQuery.toLowerCase()) || d.team.toLowerCase().includes(searchQuery.toLowerCase()))
    .sort((a, b) => sortBy === "points" ? b.fantasyPoints - a.fantasyPoints : b.price - a.price);

  function toggleDriver(driver) {
    if (isLocked) return;
    if (selectedDrivers.find(d => d.id === driver.id)) {
      setSelectedDrivers(selectedDrivers.filter(d => d.id !== driver.id));
      if (captain?.id === driver.id) setCaptain(null);
    } else {
      if (selectedDrivers.length >= MAX_DRIVERS) return;
      if (!canAddDriver(driver)) return;
      setSelectedDrivers([...selectedDrivers, driver]);
      if (isMobile) setMobileTeamView("team");
    }
  }

  function toggleConstructor(c) {
    if (isLocked) return;
    const isSelected = selectedConstructors.some(sc => sc.id === c.id);
    if (isSelected) {
      setSelectedConstructors(prev => prev.filter(sc => sc.id !== c.id));
    } else {
      if (!canAddConstructor(c)) return;
      setSelectedConstructors(prev => [...prev, c]);
      if (isMobile) setMobileTeamView("team");
    }
  }

  const isDriverSelected = (d) => !!selectedDrivers.find(s => s.id === d.id);
  const canAfford = (price) => remaining >= price;

  function toggleTheme() {
    const next = !isDark;
    setIsDark(next);
    localStorage.setItem("theme", next ? "dark" : "light");
  }

  return (
    <div data-theme={isDark ? "dark" : "light"} style={{
      fontFamily: "'Titillium Web', 'Barlow Condensed', sans-serif",
      background: "var(--bg-main)",
      minHeight: "100dvh",
      color: "var(--text)",
      position: "relative",
    }}>
      {/* Toast notification */}
      {toast && (
        <div style={{
          position: "fixed", bottom: 80, left: "50%", transform: "translateX(-50%)",
          zIndex: 9999, pointerEvents: "none",
          background: toast.type === "error" ? "rgba(225,6,0,0.95)" : "rgba(15,214,121,0.95)",
          color: "#fff", borderRadius: 10,
          padding: "12px 20px", fontSize: 14, fontWeight: 700,
          boxShadow: "0 8px 32px rgba(0,0,0,0.4)",
          letterSpacing: 0.3, whiteSpace: "nowrap",
          animation: "fadeInUp 0.2s ease",
        }}>
          {toast.type === "error" ? "✕  " : "✓  "}{toast.message}
        </div>
      )}
      <style>{`
        [data-theme="dark"] {
          --bg-main: #0f0d0d;
          --bg-header: #0c0a0a;
          --bg-card: #141111;
          --bg-elevated: #181414;
          --bg-input: #181414;
          --border: #211d1d;
          --border-sub: #1d1919;
          --border-strong: #2e2929;
          --text: #f0eded;
          --text-secondary: #888;
          --text-muted: #5a5555;
          --text-faint: #3a3535;
          --shadow-card: 0 2px 16px rgba(0,0,0,0.5);
          --shadow-hover: 0 4px 24px rgba(0,0,0,0.6);
        }
        [data-theme="light"] {
          --bg-main: #f5f2ef;
          --bg-header: #ffffff;
          --bg-card: #ffffff;
          --bg-elevated: #ede9e5;
          --bg-input: #f8f5f2;
          --border: #e2ddd9;
          --border-sub: #ece8e4;
          --border-strong: #cdc8c4;
          --text: #1a1716;
          --text-secondary: #6a6360;
          --text-muted: #9a9290;
          --text-faint: #c0bcba;
          --shadow-card: 0 2px 16px rgba(0,0,0,0.07);
          --shadow-hover: 0 4px 24px rgba(0,0,0,0.12);
        }

        * { box-sizing: border-box; margin: 0; padding: 0; }
        ::-webkit-scrollbar { width: 4px; height: 4px; }
        ::-webkit-scrollbar-track { background: var(--bg-card); }
        ::-webkit-scrollbar-thumb { background: var(--border-strong); border-radius: 2px; }

        .nav-btn {
          background: none; border: none; color: var(--text-muted); cursor: pointer;
          font-family: 'Barlow Condensed', sans-serif;
          font-size: 12px; font-weight: 700; letter-spacing: 2px;
          text-transform: uppercase; padding: 12px 18px;
          border-bottom: 2px solid transparent; transition: all 0.2s;
        }
        .nav-btn:hover { color: var(--text-secondary); }
        .nav-btn.active { color: var(--text); border-bottom-color: #e10600; }

        .tab-bar-btn {
          flex: 1; background: none; border: none; cursor: pointer;
          display: flex; flex-direction: column; align-items: center; justify-content: center;
          gap: 3px; padding: 6px 4px; min-height: 50px;
          color: var(--text-faint); transition: color 0.2s;
          font-family: 'Barlow Condensed', sans-serif;
          font-size: 10px; font-weight: 700; letter-spacing: 1px; text-transform: uppercase;
        }
        .tab-bar-btn.active { color: #e10600; }
        .tab-bar-btn:hover { color: var(--text-secondary); }
        .tab-bar-btn .tab-icon { line-height: 1; }
        .tab-bar-btn.active .tab-dot {
          width: 3px; height: 3px; background: #e10600; border-radius: 50%; margin-top: 2px;
        }

        .driver-card {
          background: var(--bg-card);
          border: 1px solid var(--border);
          border-radius: 10px;
          padding: 0; cursor: pointer;
          transition: border-color 0.2s, background 0.2s, box-shadow 0.2s;
          position: relative; overflow: hidden;
          display: flex; align-items: stretch; min-height: 72px;
          box-shadow: var(--shadow-card);
        }
        .driver-card:hover { border-color: var(--border-strong); background: var(--bg-elevated); box-shadow: var(--shadow-hover); }
        .driver-card.disabled { opacity: 0.3; cursor: not-allowed; pointer-events: none; }

        .team-slot {
          background: var(--bg-card);
          border: 1.5px dashed var(--border-strong);
          border-radius: 10px; min-height: 64px;
          display: flex; align-items: center;
          transition: all 0.2s; position: relative; overflow: hidden;
        }
        .team-slot.filled { border-style: solid; }
        .team-slot.captain-slot {
          border-color: rgba(245,166,35,0.4) !important;
          background: rgba(245,166,35,0.03) !important;
        }

        .btn-primary {
          background: #e10600; color: #fff; border: none;
          padding: 10px 24px; border-radius: 6px;
          font-family: 'Barlow Condensed', sans-serif;
          font-weight: 700; font-size: 14px; letter-spacing: 1px;
          text-transform: uppercase; cursor: pointer; transition: all 0.2s;
        }
        .btn-primary:hover { background: #c90500; box-shadow: 0 4px 16px rgba(225,6,0,0.3); }
        .btn-primary:disabled { background: var(--border-strong); color: var(--text-muted); cursor: not-allowed; box-shadow: none; }

        .btn-ghost {
          background: transparent; color: var(--text-secondary);
          border: 1px solid var(--border-strong);
          padding: 8px 16px; border-radius: 6px;
          font-family: 'Barlow Condensed', sans-serif;
          font-weight: 600; font-size: 13px; letter-spacing: 1px;
          text-transform: uppercase; cursor: pointer; transition: all 0.2s;
        }
        .btn-ghost:hover { border-color: var(--text-muted); color: var(--text); }
        .btn-ghost.active { border-color: #e10600; color: #e10600; }

        .stats-bar { animation: slideIn 0.4s ease-out; }
        @keyframes slideIn { from { opacity: 0; transform: translateY(-10px); } to { opacity: 1; transform: translateY(0); } }

        .pulse { animation: pulse 2s infinite; }
        @keyframes pulse { 0%, 100% { opacity: 1; } 50% { opacity: 0.5; } }

        .grid-checker {
          background-image: linear-gradient(var(--border-sub) 1px, transparent 1px),
                            linear-gradient(90deg, var(--border-sub) 1px, transparent 1px);
          background-size: 40px 40px;
        }

        .modal-overlay {
          position: fixed; inset: 0;
          background: rgba(0,0,0,0.88);
          display: flex; align-items: center; justify-content: center;
          z-index: 100; backdrop-filter: blur(6px);
        }

        .tag {
          display: inline-flex; align-items: center;
          background: var(--bg-elevated); border-radius: 4px;
          padding: 2px 8px; font-size: 11px; font-weight: 700;
          letter-spacing: 0.5px; text-transform: uppercase;
        }

        input[type="text"] {
          background: var(--bg-input); border: 1px solid var(--border-strong);
          color: var(--text); padding: 10px 14px; border-radius: 6px;
          font-family: 'Titillium Web', sans-serif; font-size: 14px;
          outline: none; transition: border-color 0.2s;
        }
        input[type="text"]:focus { border-color: #e10600; }
        input[type="text"]::placeholder { color: var(--text-faint); }

        select {
          background: var(--bg-input); border: 1px solid var(--border-strong);
          color: var(--text); padding: 10px 14px; border-radius: 6px;
          font-family: 'Titillium Web', sans-serif; font-size: 14px;
          outline: none; cursor: pointer; appearance: none;
        }

        .race-row { transition: background 0.15s; }
        .race-row:hover { background: var(--bg-elevated); }

        .leaderboard-row { border-bottom: 1px solid var(--border-sub); transition: background 0.15s; }
        .leaderboard-row:hover { background: var(--bg-elevated); }

        .progress-bar-bg { background: var(--bg-elevated); border-radius: 2px; height: 4px; }
        .progress-bar-fill { background: #e10600; border-radius: 2px; height: 100%; transition: width 0.5s ease; }

        /* Mobile: show bottom tab bar, hide desktop nav */
        @media (max-width: 768px) {
          .desktop-nav { display: none !important; }
          .bottom-tab-bar { display: flex !important; }
          .main-content { padding-bottom: calc(64px + env(safe-area-inset-bottom)) !important; }
          .budget-bar-inner { flex-wrap: wrap; gap: 8px !important; }
        }
        /* Desktop: hide bottom tab bar */
        @media (min-width: 769px) {
          .bottom-tab-bar { display: none !important; }
          .desktop-nav { display: flex !important; }
        }
      `}</style>

      {/* Header */}
      <header style={{
        background: "var(--bg-header)",
        position: "sticky",
        top: 0,
        zIndex: 50,
        paddingTop: "env(safe-area-inset-top)",
        paddingLeft: "env(safe-area-inset-left)",
        paddingRight: "env(safe-area-inset-right)",
        boxShadow: "0 1px 0 var(--border)",
      }}>
        <div style={{ height: 2, background: "#e10600", opacity: 0.9 }} />
        <div>
        <div style={{ maxWidth: 1200, margin: "0 auto", padding: "0 16px" }}>
          <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", height: 52 }}>
            {/* Logo */}
            <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
              <div style={{ width: 3, height: 28, background: "#e10600", borderRadius: 2, flexShrink: 0 }} />
              <div>
                <div style={{ fontFamily: "'Barlow Condensed', sans-serif", fontWeight: 900, fontSize: 18, letterSpacing: 3, textTransform: "uppercase", lineHeight: 1, color: "var(--text)" }}>F1 Fantasy</div>
                <div style={{ fontSize: 9, color: "var(--text-muted)", letterSpacing: 2, textTransform: "uppercase", fontWeight: 600, marginTop: 2, fontFamily: "'Barlow Condensed', sans-serif" }}>2026 Season</div>
              </div>
            </div>

            {/* Desktop nav — hidden on mobile */}
            <nav style={{ display: "flex" }} className="desktop-nav">
              {["team", "transfers", "leagues", "races", "stats", "rules", "profile", ...(user.email === SUPER_ADMIN_EMAIL ? ["admin"] : [])].map(tab => (
                <button key={tab} className={`nav-btn ${activeTab === tab ? "active" : ""}`} onClick={() => setActiveTab(tab)}>
                  {tab}
                </button>
              ))}
            </nav>

            {/* Right side */}
            <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
              <div style={{ textAlign: "right" }}>
                <div style={{ fontSize: 10, color: "var(--text-muted)", letterSpacing: 1, textTransform: "uppercase" }}>PTS</div>
                <div style={{ fontSize: 16, fontWeight: 800, fontFamily: "'Barlow Condensed', sans-serif", color: "#e10600" }}>{displayPoints.toLocaleString()}</div>
              </div>
              {/* Theme toggle */}
              <button
                onClick={toggleTheme}
                title={isDark ? "Switch to light mode" : "Switch to dark mode"}
                style={{ background: "none", border: "1px solid var(--border-strong)", borderRadius: 4, color: "var(--text-secondary)", width: 32, height: 32, cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}
              >
                {isDark
                  ? <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="5"/><line x1="12" y1="1" x2="12" y2="3"/><line x1="12" y1="21" x2="12" y2="23"/><line x1="4.22" y1="4.22" x2="5.64" y2="5.64"/><line x1="18.36" y1="18.36" x2="19.78" y2="19.78"/><line x1="1" y1="12" x2="3" y2="12"/><line x1="21" y1="12" x2="23" y2="12"/><line x1="4.22" y1="19.78" x2="5.64" y2="18.36"/><line x1="18.36" y1="5.64" x2="19.78" y2="4.22"/></svg>
                  : <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 12.79A9 9 0 1111.21 3 7 7 0 0021 12.79z"/></svg>
                }
              </button>
              {!isMobile && (
                <button
                  onClick={() => supabase.auth.signOut()}
                  style={{ background: "none", border: "1px solid var(--border-strong)", borderRadius: 4, color: "var(--text-secondary)", fontSize: 11, padding: "6px 10px", cursor: "pointer", whiteSpace: "nowrap", minHeight: 32 }}
                >
                  Sign Out
                </button>
              )}
            </div>
          </div>
        </div>
        </div>
      </header>

      {/* Bottom Tab Bar — mobile only */}
      <nav style={{
        position: "fixed", bottom: 0, left: 0, right: 0, zIndex: 100,
        background: "var(--bg-header)",
        borderTop: "1px solid var(--border)",
        display: "flex",
        paddingBottom: "env(safe-area-inset-bottom)",
        paddingLeft: "env(safe-area-inset-left)",
        paddingRight: "env(safe-area-inset-right)",
      }} className="bottom-tab-bar">
        {[
          { id: "team",      label: "Team" },
          { id: "transfers", label: "Xfer" },
          { id: "leagues",   label: "Leagues" },
          { id: "races",     label: "Races" },
          { id: "stats",     label: "Stats" },
          { id: "rules",     label: "Rules" },
          { id: "profile",   label: "Profile" },
          ...(user.email === SUPER_ADMIN_EMAIL ? [{ id: "admin", label: "Admin" }] : []),
        ].map(tab => (
          <button
            key={tab.id}
            className={`tab-bar-btn ${activeTab === tab.id ? "active" : ""}`}
            onClick={() => setActiveTab(tab.id)}
          >
            <span className="tab-icon">{TAB_ICONS[tab.id]?.(activeTab === tab.id ? "#e10600" : "#555")}</span>
            <span>{tab.label}</span>
            {activeTab === tab.id && <span className="tab-dot" />}
          </button>
        ))}
      </nav>

      {/* Budget Bar */}
      <div className="stats-bar" style={{ background: "var(--bg-header)", borderBottom: "1px solid var(--border)", padding: isMobile ? "8px 0 6px" : "8px 0" }}>
        <div className="budget-bar-inner" style={{ maxWidth: 1200, margin: "0 auto", padding: "0 16px" }}>
          {isMobile ? (
            /* Mobile: two compact rows */
            <>
              <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 6 }}>
                <div style={{ fontFamily: "'Barlow Condensed', sans-serif", fontWeight: 700, fontSize: 15 }}>
                  <span style={{ color: remaining <= 0 ? "#e10600" : remaining < 10 ? "#f5a623" : "#0fd679" }}>${remaining.toFixed(1)}M</span>
                  <span style={{ color: "var(--text-faint)", fontSize: 12 }}> left</span>
                </div>
                <div style={{ flex: 1 }}>
                  <div className="progress-bar-bg">
                    <div className="progress-bar-fill" style={{ width: `${Math.min((spent / BUDGET) * 100, 100)}%`, background: remaining <= 0 ? "#e10600" : remaining < 10 ? "#f5a623" : "#0fd679" }} />
                  </div>
                </div>
                <div style={{ fontFamily: "'Barlow Condensed', sans-serif", fontWeight: 700, fontSize: 13, color: isLocked ? "#e10600" : msUntilLock < 3600000 ? "#f5a623" : "#0fd679" }}>
                  {isLocked ? "Locked" : formatCountdown(msUntilLock)}
                </div>
              </div>
              <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                <div style={{ fontSize: 11, color: "var(--text-secondary)", flex: 1 }}>
                  <span style={{ color: "var(--text)", fontWeight: 700 }}>{selectedDrivers.length}</span>/5
                  <span style={{ color: "var(--text-faint)" }}> D · </span>
                  <span style={{ color: "var(--text)", fontWeight: 700 }}>{selectedConstructors.length}</span>/2
                  <span style={{ color: "var(--text-faint)" }}> C · Cap: </span>
                  <span style={{ color: captain ? "#f5a623" : "var(--text-faint)", fontWeight: 700 }}>{captain ? captain.name.split(" ").pop() : "—"}</span>
                </div>
                {!isLocked && (
                  <>
                    <button className="btn-ghost" style={{ padding: "5px 10px", fontSize: 12 }} onClick={clearTeam}>Clear</button>
                    <button className="btn-primary" style={{ padding: "5px 12px", fontSize: 12 }} disabled={selectedDrivers.length < MAX_DRIVERS || selectedConstructors.length < 2 || !captain} onClick={saveTeam}>Save</button>
                  </>
                )}
              </div>
            </>
          ) : (
            /* Desktop: single row */
            <div style={{ display: "flex", alignItems: "center", gap: 16 }}>
              <div style={{ display: "flex", alignItems: "center", gap: 24, flex: 1 }}>
                <div>
                  <div style={{ fontSize: 10, color: "var(--text-muted)", letterSpacing: 1, textTransform: "uppercase", marginBottom: 2 }}>Budget</div>
                  <div style={{ fontFamily: "'Barlow Condensed', sans-serif", fontWeight: 700, fontSize: 16 }}>
                    <span style={{ color: remaining <= 0 ? "#e10600" : remaining < 10 ? "#f5a623" : "#0fd679" }}>${remaining.toFixed(1)}M</span>
                    <span style={{ color: "#333", fontSize: 13 }}> / ${BUDGET}M</span>
                  </div>
                </div>
                <div style={{ flex: 1, maxWidth: 200 }}>
                  <div className="progress-bar-bg">
                    <div className="progress-bar-fill" style={{ width: `${Math.min((spent / BUDGET) * 100, 100)}%`, background: remaining <= 0 ? "#e10600" : remaining < 10 ? "#f5a623" : "#0fd679" }} />
                  </div>
                </div>
                <div style={{ display: "flex", gap: 16 }}>
                  <div style={{ fontSize: 12, color: "var(--text-secondary)" }}>
                    <span style={{ color: "var(--text)", fontWeight: 700 }}>{selectedDrivers.length}</span>/{MAX_DRIVERS} Drivers
                  </div>
                  <div style={{ fontSize: 12, color: "var(--text-secondary)" }}>
                    <span style={{ color: "var(--text)", fontWeight: 700 }}>{selectedConstructors.length}</span>/2 Constructors
                  </div>
                  <div style={{ fontSize: 12, color: "#666" }}>
                    Captain: <span style={{ color: captain ? "#f5a623" : "#666", fontWeight: 700 }}>{captain ? captain.name.split(" ").pop() : "—"}</span>
                  </div>
                </div>
              </div>
              <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                <div style={{ textAlign: "right", marginRight: 4 }}>
                  <div style={{ fontSize: 9, color: "var(--text-muted)", letterSpacing: 1, textTransform: "uppercase" }}>
                    {isRoundLocked ? "LOCKED" : `R${nextRace.round} ${nextRace.name}`}
                  </div>
                  <div style={{ fontFamily: "'Barlow Condensed', sans-serif", fontWeight: 700, fontSize: 14, color: isRoundLocked ? "#e10600" : msUntilLock < 3600000 ? "#f5a623" : "#0fd679", letterSpacing: 0.5 }}>
                    {isRoundLocked ? "Teams locked" : `⏱ ${formatCountdown(msUntilLock)}`}
                  </div>
                </div>
                {!isLocked && (
                  <>
                    <button className="btn-ghost" onClick={clearTeam}>Clear</button>
                    <button className="btn-primary" disabled={selectedDrivers.length < MAX_DRIVERS || selectedConstructors.length < 2 || !captain} onClick={saveTeam}>Save Team</button>
                  </>
                )}
              </div>
            </div>
          )}
        </div>
      </div>

      {/* Main Content */}
      <main className="main-content" style={{ maxWidth: 1200, margin: "0 auto", padding: "20px 16px" }}>
        
        {/* TEAM TAB */}
        {activeTab === "team" && (
          <div style={{ display: "grid", gridTemplateColumns: isMobile ? "1fr" : "1fr 380px", gap: isMobile ? 0 : 24 }}>
            {/* Auto-lineup applied banner */}
            {autoLineupNote && (
              <div style={{ gridColumn: "1 / -1", background: "rgba(15,214,121,0.08)", border: "1px solid rgba(15,214,121,0.25)", borderRadius: 10, padding: "12px 16px", display: "flex", alignItems: "center", gap: 12, marginBottom: isMobile ? 12 : 0 }}>
                <div style={{ width: 8, height: 8, borderRadius: "50%", background: "#0fd679", flexShrink: 0 }} />
                <div style={{ flex: 1, fontSize: 13 }}>
                  <span style={{ fontWeight: 700, color: "#0fd679" }}>Auto-lineup was applied</span>
                  <span style={{ color: "var(--text-muted)" }}> — optimized from {autoLineupNote.session} data for {autoLineupNote.raceName}</span>
                </div>
                <button onClick={() => { setAutoLineupNote(null); localStorage.removeItem("autoLineupNote"); }} style={{ background: "none", border: "none", color: "var(--text-faint)", cursor: "pointer", fontSize: 16, padding: "0 4px" }}>✕</button>
              </div>
            )}

            {/* Mobile sub-tabs */}
            {isMobile && (
              <div style={{ gridColumn: "1 / -1", display: "flex", marginBottom: 14, background: "var(--bg-elevated)", borderRadius: 8, padding: 3, gap: 3 }}>
                <button
                  onClick={() => setMobileTeamView("pick")}
                  style={{ flex: 1, padding: "9px 0", borderRadius: 6, border: "none", cursor: "pointer", fontSize: 13, fontWeight: 800, letterSpacing: 1.5, textTransform: "uppercase", fontFamily: "'Barlow Condensed', sans-serif", transition: "all 0.15s",
                    background: mobileTeamView === "pick" ? "var(--bg-card)" : "transparent",
                    color: mobileTeamView === "pick" ? "var(--text)" : "var(--text-faint)",
                    boxShadow: mobileTeamView === "pick" ? "0 1px 4px rgba(0,0,0,0.3)" : "none",
                  }}
                >Pick Players</button>
                <button
                  onClick={() => setMobileTeamView("team")}
                  style={{ flex: 1, padding: "9px 0", borderRadius: 6, border: "none", cursor: "pointer", fontSize: 13, fontWeight: 800, letterSpacing: 1.5, textTransform: "uppercase", fontFamily: "'Barlow Condensed', sans-serif", transition: "all 0.15s",
                    background: mobileTeamView === "team" ? "var(--bg-card)" : "transparent",
                    color: mobileTeamView === "team" ? "var(--text)" : "var(--text-faint)",
                    boxShadow: mobileTeamView === "team" ? "0 1px 4px rgba(0,0,0,0.3)" : "none",
                  }}
                >My Team {selectedDrivers.length > 0 || selectedConstructors.length > 0 ? `(${selectedDrivers.length + selectedConstructors.length})` : ""}</button>
              </div>
            )}

            {/* Left: Player Pool */}
            <div style={{ display: isMobile && mobileTeamView !== "pick" ? "none" : undefined }}>
              {/* Toggle Drivers / Constructors */}
              <div style={{ display: "flex", gap: 8, marginBottom: 16 }}>
                <button className={`btn-ghost ${driverView === "drivers" ? "active" : ""}`} onClick={() => setDriverView("drivers")}>Drivers</button>
                <button className={`btn-ghost ${driverView === "constructors" ? "active" : ""}`} onClick={() => setDriverView("constructors")}>Constructors</button>
              </div>

              {driverView === "drivers" && (
                <>
                  {/* Filters */}
                  <div style={{ display: "flex", gap: 8, marginBottom: 10, alignItems: "center" }}>
                    <input type="text" placeholder="Search drivers..." value={searchQuery} onChange={e => setSearchQuery(e.target.value)} style={{ flex: 1, minWidth: 0, fontSize: 16, padding: "12px 14px" }} />
                    <select value={sortBy} onChange={e => setSortBy(e.target.value)} style={{ width: 110 }}>
                      <option value="price">Price ↓</option>
                      <option value="points">Points ↓</option>
                    </select>
                  </div>

                  {/* Team filter strip */}
                  {isMobile ? (
                    // Mobile: wrapping grid of color dots — no scroll needed
                    <div style={{ display: "flex", flexWrap: "wrap", gap: 6, marginBottom: 14 }}>
                      <button
                        onClick={() => setFilterTeam("All")}
                        style={{
                          padding: "5px 10px", borderRadius: 4,
                          background: filterTeam === "All" ? "#e10600" : "var(--bg-elevated)",
                          border: `1px solid ${filterTeam === "All" ? "#e10600" : "var(--border-strong)"}`,
                          color: filterTeam === "All" ? "#fff" : "var(--text-muted)",
                          fontSize: 10, fontWeight: 800, letterSpacing: 1, textTransform: "uppercase",
                          cursor: "pointer", fontFamily: "'Barlow Condensed', sans-serif"
                        }}
                      >ALL</button>
                      {CONSTRUCTORS.map(c => (
                        <button
                          key={c.id}
                          onClick={() => setFilterTeam(filterTeam === c.name ? "All" : c.name)}
                          title={c.name}
                          style={{
                            display: "flex", alignItems: "center", gap: 4,
                            padding: "5px 8px", borderRadius: 4,
                            background: filterTeam === c.name ? c.color + "22" : "var(--bg-elevated)",
                            border: `1px solid ${filterTeam === c.name ? c.color : "var(--border-strong)"}`,
                            cursor: "pointer",
                          }}
                        >
                          <div style={{ width: 8, height: 8, borderRadius: "50%", background: c.color }} />
                          <span style={{ fontSize: 10, fontWeight: 800, letterSpacing: 0.8, textTransform: "uppercase", color: filterTeam === c.name ? c.color : "var(--text-muted)", fontFamily: "'Barlow Condensed', sans-serif" }}>{TEAM_ABBR[c.name]}</span>
                        </button>
                      ))}
                    </div>
                  ) : (
                    // Desktop: horizontal scroll strip
                    <div style={{ overflowX: "auto", overflowY: "visible", WebkitOverflowScrolling: "touch", scrollbarWidth: "none", marginBottom: 14, paddingBottom: 4, width: "100%" }}>
                    <div style={{ display: "flex", gap: 6, width: "max-content" }}>
                      <button
                        onClick={() => setFilterTeam("All")}
                        style={{
                          flexShrink: 0, padding: "8px 10px", borderRadius: 4,
                          background: filterTeam === "All" ? "#e10600" : "var(--bg-elevated)",
                          border: `1px solid ${filterTeam === "All" ? "#e10600" : "var(--border-strong)"}`,
                          color: filterTeam === "All" ? "#fff" : "var(--text-muted)",
                          fontSize: 10, fontWeight: 800, letterSpacing: 1, textTransform: "uppercase",
                          cursor: "pointer", transition: "all 0.15s", fontFamily: "'Barlow Condensed', sans-serif"
                        }}
                      >ALL</button>
                      {CONSTRUCTORS.map(c => (
                        <button
                          key={c.id}
                          onClick={() => setFilterTeam(filterTeam === c.name ? "All" : c.name)}
                          title={c.name}
                          style={{
                            flexShrink: 0, display: "flex", alignItems: "center", gap: 5,
                            padding: "8px 8px", borderRadius: 4,
                            background: filterTeam === c.name ? c.color + "22" : "var(--bg-elevated)",
                            border: `1px solid ${filterTeam === c.name ? c.color : "var(--border-strong)"}`,
                            cursor: "pointer", transition: "all 0.15s",
                          }}
                        >
                          <div style={{ width: 8, height: 8, borderRadius: "50%", background: c.color, flexShrink: 0 }} />
                          <span style={{ fontSize: 10, fontWeight: 800, letterSpacing: 0.8, textTransform: "uppercase", color: filterTeam === c.name ? c.color : "var(--text-muted)", fontFamily: "'Barlow Condensed', sans-serif" }}>{TEAM_ABBR[c.name]}</span>
                        </button>
                      ))}
                    </div>
                    </div>
                  )}

                  {/* Column headers */}
                  {!isMobile && (
                    <div style={{ display: "flex", alignItems: "center", padding: "0 12px 6px 12px", gap: 0 }}>
                      <div style={{ width: 4, flexShrink: 0 }} />
                      <div style={{ width: 68, flexShrink: 0 }} />
                      <div style={{ flex: 1, fontSize: 10, color: "var(--text-faint)", letterSpacing: 1, textTransform: "uppercase", fontWeight: 700, paddingLeft: 12 }}>Driver</div>
                      <div style={{ width: 1, height: 12, background: "var(--border)", flexShrink: 0 }} />
                      <div style={{ width: 44, fontSize: 10, color: "var(--text-faint)", letterSpacing: 1, textTransform: "uppercase", textAlign: "center", flexShrink: 0 }}>Pts</div>
                      <div style={{ width: 1, height: 12, background: "var(--border)", flexShrink: 0 }} />
                      <div style={{ width: 54, fontSize: 10, color: "var(--text-faint)", letterSpacing: 1, textTransform: "uppercase", textAlign: "center", flexShrink: 0 }}>Price</div>
                      <div style={{ width: 1, height: 12, background: "var(--border)", flexShrink: 0 }} />
                      <div style={{ width: 44, flexShrink: 0 }} />
                    </div>
                  )}

                  <div style={{ display: "flex", flexDirection: "column", gap: 6, ...(isMobile ? {} : { maxHeight: 580, overflowY: "auto", paddingRight: 4 }), WebkitOverflowScrolling: "touch" }}>
                    {filtered.map(driver => {
                      const selected = isDriverSelected(driver);
                      const atMax = selectedDrivers.length >= MAX_DRIVERS && !selected;
                      const disabled = (!selected && (atMax || !canAddDriver(driver)));
                      return (
                        <div
                          key={driver.id}
                          className={`driver-card ${disabled ? "disabled" : ""}`}
                          onClick={() => !disabled && toggleDriver(driver)}
                          style={{
                            borderColor: selected ? driver.teamColor + "70" : "var(--border)",
                            background: selected ? driver.teamColor + "0c" : "var(--bg-card)",
                            boxShadow: selected ? `0 0 0 1px ${driver.teamColor}22, 0 4px 20px ${driver.teamColor}14` : "none",
                          }}
                        >
                          {/* Full-height team stripe */}
                          <div style={{
                            width: 4,
                            alignSelf: "stretch",
                            background: driver.teamColor,
                            flexShrink: 0,
                            borderRadius: "10px 0 0 10px",
                            boxShadow: selected ? `3px 0 12px ${driver.teamColor}50` : "none",
                            transition: "box-shadow 0.2s",
                          }} />

                          {/* Portrait zone */}
                          <div style={{
                            position: "relative",
                            width: 68,
                            flexShrink: 0,
                            background: driver.teamColor + "08",
                            borderRight: "1px solid var(--border-sub)",
                            display: "flex", alignItems: "center", justifyContent: "center",
                            overflow: "hidden",
                          }}>
                            {/* Ghost driver number */}
                            <div style={{
                              position: "absolute", right: -4, bottom: -10,
                              fontFamily: "'Barlow Condensed', sans-serif",
                              fontWeight: 900, fontSize: 44,
                              color: driver.teamColor + (selected ? "30" : "1a"),
                              lineHeight: 1, userSelect: "none",
                              letterSpacing: -2, pointerEvents: "none",
                              transition: "color 0.2s",
                            }}>{driver.number}</div>
                            <img
                              src={`/drivers/driver-${driver.id}.png`}
                              alt={driver.name}
                              style={{ width: 56, height: 56, objectFit: "cover", objectPosition: "top center", position: "relative", zIndex: 1 }}
                            />
                          </div>

                          {/* Driver info */}
                          <div style={{ flex: 1, minWidth: 0, padding: "10px 10px 10px 12px" }}>
                            <div style={{ fontSize: 9.5, color: "#666", fontWeight: 600, letterSpacing: 0.3, lineHeight: 1.2 }}>
                              {FLAG_MAP[driver.country]} {driver.name.split(" ")[0]}
                            </div>
                            <div style={{
                              fontFamily: "'Barlow Condensed', sans-serif", fontWeight: 900, fontSize: 17,
                              letterSpacing: 0.5, lineHeight: 1.1, textTransform: "uppercase",
                              whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis",
                            }}>
                              {driver.name.split(" ").slice(1).join(" ")}
                            </div>
                            <div style={{ marginTop: 4, display: "inline-flex", alignItems: "center", gap: 5 }}>
                              <div style={{ width: 6, height: 6, borderRadius: "50%", background: driver.teamColor, flexShrink: 0 }} />
                              <span style={{ fontSize: 9, fontWeight: 800, letterSpacing: 1, textTransform: "uppercase", color: "#555", fontFamily: "'Barlow Condensed', sans-serif" }}>
                                {TEAM_ABBR[driver.team]}
                              </span>
                            </div>
                          </div>

                          {/* Stats columns */}
                          <div style={{ display: "flex", alignItems: "center", flexShrink: 0, borderLeft: "1px solid var(--border)" }}>
                            <div style={{ width: 44, textAlign: "center", padding: "0 6px", borderRight: "1px solid var(--border-sub)" }}>
                              <div style={{ fontSize: 8, color: "var(--text-faint)", letterSpacing: 0.8, textTransform: "uppercase", fontWeight: 700 }}>PTS</div>
                              <div style={{ fontFamily: "'Barlow Condensed', sans-serif", fontWeight: 700, fontSize: 16, color: selected ? "var(--text)" : "var(--text-secondary)", lineHeight: 1.2, marginTop: 1 }}>{driver.fantasyPoints}</div>
                            </div>
                            <div style={{ width: 54, textAlign: "center", padding: "0 6px", borderRight: "1px solid var(--border-sub)" }}>
                              <div style={{ fontSize: 8, color: "var(--text-faint)", letterSpacing: 0.8, textTransform: "uppercase", fontWeight: 700 }}>PRICE</div>
                              <div style={{ fontFamily: "'Barlow Condensed', sans-serif", fontWeight: 700, fontSize: 16, color: "#0fd679", lineHeight: 1.2, marginTop: 1 }}>${driver.price}m</div>
                            </div>
                          </div>

                          {/* Select button */}
                          <div style={{ width: 44, flexShrink: 0, display: "flex", alignItems: "center", justifyContent: "center" }}>
                            <div style={{
                              width: 28, height: 28, borderRadius: "50%",
                              background: selected ? driver.teamColor : "transparent",
                              border: `2px solid ${selected ? driver.teamColor : "#282828"}`,
                              display: "flex", alignItems: "center", justifyContent: "center",
                              fontSize: 12, transition: "all 0.15s", fontWeight: 800,
                              color: selected ? "#fff" : "var(--text-faint)",
                              boxShadow: selected ? `0 0 12px ${driver.teamColor}55` : "none",
                            }}>
                              {selected ? "✓" : "+"}
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </>
              )}

              {driverView === "constructors" && (
                <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
                  <div style={{ display: "flex", alignItems: "center", padding: "0 12px 6px 16px", gap: 0 }}>
                    <div style={{ flex: 1, fontSize: 10, color: "var(--text-faint)", letterSpacing: 1, textTransform: "uppercase", fontWeight: 700 }}>Constructor</div>
                    <div style={{ width: 1, height: 12, background: "var(--border)", flexShrink: 0 }} />
                    <div style={{ width: 64, fontSize: 10, color: "var(--text-faint)", letterSpacing: 1, textTransform: "uppercase", textAlign: "center" }}>Pts</div>
                    <div style={{ width: 1, height: 12, background: "var(--border)", flexShrink: 0 }} />
                    <div style={{ width: 70, fontSize: 10, color: "var(--text-faint)", letterSpacing: 1, textTransform: "uppercase", textAlign: "center" }}>Price</div>
                    <div style={{ width: 1, height: 12, background: "var(--border)", flexShrink: 0 }} />
                    <div style={{ width: 50, flexShrink: 0 }} />
                  </div>
                  {constructors.map(c => {
                    const selected = selectedConstructors.some(sc => sc.id === c.id);
                    const canSelect = selected || canAddConstructor(c);
                    return (
                      <div
                        key={c.id}
                        className={`driver-card ${!canSelect && !selected ? "disabled" : ""}`}
                        onClick={() => canSelect && toggleConstructor(c)}
                        style={{
                          borderColor: selected ? c.color + "70" : "var(--border)",
                          background: selected ? c.color + "0c" : "var(--bg-card)",
                          boxShadow: selected ? `0 0 0 1px ${c.color}22, 0 4px 20px ${c.color}14` : "none",
                        }}
                      >
                        {/* Left color stripe */}
                        <div style={{ width: 4, alignSelf: "stretch", background: c.color, flexShrink: 0, borderRadius: "10px 0 0 10px", boxShadow: selected ? `3px 0 12px ${c.color}50` : "none", transition: "box-shadow 0.2s" }} />

                        {/* Logo zone */}
                        <div style={{ width: 68, flexShrink: 0, background: c.color + "08", borderRight: "1px solid var(--border-sub)", display: "flex", alignItems: "center", justifyContent: "center" }}>
                          <TeamLogo team={c.name} size={38} />
                        </div>

                        {/* Name */}
                        <div style={{ flex: 1, minWidth: 0, padding: "10px 10px 10px 14px" }}>
                          <div style={{ fontFamily: "'Barlow Condensed', sans-serif", fontWeight: 900, fontSize: 17, letterSpacing: 0.5, textTransform: "uppercase", lineHeight: 1.1, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                            {c.name}
                          </div>
                          <div style={{ marginTop: 4, display: "inline-flex", alignItems: "center", gap: 5 }}>
                            <div style={{ width: 6, height: 6, borderRadius: "50%", background: c.color }} />
                            <span style={{ fontSize: 9, fontWeight: 800, letterSpacing: 1, textTransform: "uppercase", color: "var(--text-muted)", fontFamily: "'Barlow Condensed', sans-serif" }}>Constructor</span>
                          </div>
                        </div>

                        {/* Stats */}
                        <div style={{ display: "flex", alignItems: "center", flexShrink: 0, borderLeft: "1px solid var(--border)" }}>
                          <div style={{ width: 64, textAlign: "center", padding: "0 6px", borderRight: "1px solid var(--border-sub)" }}>
                            <div style={{ fontSize: 8, color: "var(--text-faint)", letterSpacing: 0.8, textTransform: "uppercase", fontWeight: 700 }}>PTS</div>
                            <div style={{ fontFamily: "'Barlow Condensed', sans-serif", fontWeight: 700, fontSize: 16, color: selected ? "var(--text)" : "var(--text-secondary)", lineHeight: 1.2, marginTop: 1 }}>{c.points}</div>
                          </div>
                          <div style={{ width: 70, textAlign: "center", padding: "0 6px", borderRight: "1px solid var(--border-sub)" }}>
                            <div style={{ fontSize: 8, color: "var(--text-faint)", letterSpacing: 0.8, textTransform: "uppercase", fontWeight: 700 }}>PRICE</div>
                            <div style={{ fontFamily: "'Barlow Condensed', sans-serif", fontWeight: 700, fontSize: 16, color: "#0fd679", lineHeight: 1.2, marginTop: 1 }}>${c.price}m</div>
                          </div>
                        </div>

                        {/* Select */}
                        <div style={{ width: 50, flexShrink: 0, display: "flex", alignItems: "center", justifyContent: "center" }}>
                          <div style={{ width: 28, height: 28, borderRadius: "50%", background: selected ? c.color : "transparent", border: `2px solid ${selected ? c.color : "#282828"}`, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 12, transition: "all 0.15s", fontWeight: 800, color: selected ? "#fff" : "#3a3a3a", boxShadow: selected ? `0 0 12px ${c.color}55` : "none" }}>
                            {selected ? "✓" : "+"}
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              )}
            </div>

            {/* Right: My Team */}
            <div style={{ display: isMobile && mobileTeamView !== "team" ? "none" : undefined }}>
              <div style={{ position: isMobile ? "static" : "sticky", top: 120 }}>
                <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 16 }}>
                  <h2 style={{ fontFamily: "'Barlow Condensed', sans-serif", fontWeight: 800, fontSize: 20, letterSpacing: 1, textTransform: "uppercase" }}>My Team</h2>
                  {selectedDrivers.length === MAX_DRIVERS && selectedConstructors.length === 2 && !captain && (
                    <button className="btn-primary" style={{ fontSize: 12, padding: "6px 14px" }} onClick={() => setShowCaptainModal(true)}>
                      ⭐ Pick Captain
                    </button>
                  )}
                </div>

                {/* Circuit track-style layout */}
                <div className="grid-checker" style={{ background: "var(--bg-card)", borderRadius: 12, padding: 16, border: "1px solid var(--border)" }}>
                  
                  {/* Driver slots */}
                  <div style={{ marginBottom: 12 }}>
                    <div style={{ fontSize: 11, color: "var(--text-faint)", letterSpacing: 1.5, textTransform: "uppercase", marginBottom: 8, fontWeight: 700 }}>Drivers</div>
                    <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
                      {Array.from({ length: MAX_DRIVERS }).map((_, i) => {
                        const d = selectedDrivers[i];
                        const liveD = d ? (drivers.find(ld => ld.id === d.id) || d) : d;
                        const isCap = d && captain?.id === d.id;
                        return (
                          <div key={i} className={`team-slot ${d ? "filled" : ""} ${isCap ? "captain-slot" : ""}`}
                            onClick={!d && isMobile && !isLocked ? () => { setDriverView("drivers"); setMobileTeamView("pick"); } : undefined}
                            style={{
                              minHeight: 64,
                              borderColor: d ? (isCap ? undefined : (d.teamColor + "45")) : "var(--border)",
                              cursor: !d && isMobile && !isLocked ? "pointer" : undefined,
                            }}>
                            {d ? (
                              <div style={{ display: "flex", alignItems: "stretch", width: "100%" }}>
                                {/* Color stripe */}
                                <div style={{ width: 3, alignSelf: "stretch", background: isCap ? "#f5a623" : d.teamColor, borderRadius: "10px 0 0 10px", flexShrink: 0, boxShadow: isCap ? "3px 0 10px rgba(245,166,35,0.4)" : `3px 0 10px ${d.teamColor}40` }} />
                                {/* Portrait */}
                                <div style={{ width: 56, flexShrink: 0, background: (isCap ? "rgba(245,166,35,0.06)" : d.teamColor + "08"), display: "flex", alignItems: "center", justifyContent: "center", borderRight: "1px solid var(--border-sub)", position: "relative", overflow: "hidden" }}>
                                  <div style={{ position: "absolute", right: -2, bottom: -8, fontFamily: "'Barlow Condensed', sans-serif", fontWeight: 900, fontSize: 34, color: (isCap ? "rgba(245,166,35,0.15)" : d.teamColor + "18"), lineHeight: 1, userSelect: "none", pointerEvents: "none" }}>{d.number}</div>
                                  <img src={`/drivers/driver-${d.id}.png`} alt={d.name} style={{ width: 44, height: 44, objectFit: "cover", objectPosition: "top center", position: "relative", zIndex: 1 }} />
                                </div>
                                {/* Info */}
                                <div style={{ flex: 1, padding: "8px 10px", minWidth: 0 }}>
                                  <div style={{ display: "flex", alignItems: "center", gap: 6, flexWrap: "wrap" }}>
                                    <span style={{ fontFamily: "'Barlow Condensed', sans-serif", fontWeight: 800, fontSize: 15, lineHeight: 1.1, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", textTransform: "uppercase" }}>
                                      {FLAG_MAP[d.country]} {d.name.split(" ").slice(1).join(" ")}
                                    </span>
                                    {isCap && (
                                      <span style={{ fontSize: 9, background: "#f5a623", color: "#0a0a0a", padding: "2px 7px", borderRadius: 3, fontWeight: 900, letterSpacing: 1.5, textTransform: "uppercase", fontFamily: "'Barlow Condensed', sans-serif", flexShrink: 0 }}>
                                        ✦ CAPTAIN ×2
                                      </span>
                                    )}
                                  </div>
                                  <div style={{ display: "flex", gap: 10, marginTop: 3, alignItems: "center" }}>
                                    <span style={{ fontSize: 10, color: "var(--text-muted)" }}>{d.team}</span>
                                    {qualiPositions[d.id] && (
                                      <span style={{ fontSize: 10, color: "var(--text-muted)", fontFamily: "'Barlow Condensed', sans-serif", fontWeight: 700 }}>P{qualiPositions[d.id]}</span>
                                    )}
                                    <span style={{ fontSize: 11, color: isCap ? "#f5a623" : "#e10600", fontWeight: 700, fontFamily: "'Barlow Condensed', sans-serif" }}>
                                      {isCap ? liveD.fantasyPoints * 2 : liveD.fantasyPoints} pts
                                    </span>
                                  </div>
                                </div>
                                {/* Actions */}
                                <div style={{ display: "flex", gap: 4, alignItems: "center", padding: "0 10px", flexShrink: 0 }}>
                                  {!isCap && !isLocked && (
                                    <button onClick={(e) => { e.stopPropagation(); setCaptain(d); }} style={{ background: "transparent", border: "1px solid var(--border-strong)", borderRadius: 6, padding: "5px 7px", cursor: "pointer", fontSize: 13, color: "#555", transition: "all 0.15s", lineHeight: 1 }} title="Make captain">⭐</button>
                                  )}
                                  {!isLocked && <button onClick={(e) => { e.stopPropagation(); toggleDriver(d); }} style={{ background: "transparent", border: "1px solid var(--border-strong)", borderRadius: 6, padding: "5px 7px", cursor: "pointer", fontSize: 12, color: "#444", transition: "all 0.15s", lineHeight: 1 }}>✕</button>}
                                </div>
                              </div>
                            ) : (
                              <div style={{ display: "flex", alignItems: "center", gap: 12, padding: "0 14px", width: "100%" }}>
                                <div style={{ width: 28, height: 28, borderRadius: "50%", border: "1px dashed var(--border-strong)", display: "flex", alignItems: "center", justifyContent: "center", fontSize: isMobile ? 16 : 11, color: "var(--text-faint)", fontWeight: 800, fontFamily: "'Barlow Condensed', sans-serif", flexShrink: 0 }}>
                                  {isMobile ? "+" : i + 1}
                                </div>
                                <div style={{ color: "var(--text-faint)", fontSize: 11, fontWeight: 700, letterSpacing: 2, textTransform: "uppercase" }}>
                                  Add Driver
                                </div>
                              </div>
                            )}
                          </div>
                        );
                      })}
                    </div>
                  </div>

                  {/* Constructor slots */}
                  <div>
                    <div style={{ fontSize: 11, color: "var(--text-faint)", letterSpacing: 1.5, textTransform: "uppercase", marginBottom: 8, fontWeight: 700 }}>Constructors</div>
                    <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
                      {[0, 1].map(slot => {
                        const sc = selectedConstructors[slot];
                        return (
                          <div key={slot} className={`team-slot ${sc ? "filled" : ""}`}
                            onClick={!sc && isMobile && !isLocked ? () => { setDriverView("constructors"); setMobileTeamView("pick"); } : undefined}
                            style={{ minHeight: 64, borderColor: sc ? (sc.color + "45") : "var(--border)", cursor: !sc && isMobile && !isLocked ? "pointer" : undefined }}>
                            {sc ? (
                              <div style={{ display: "flex", alignItems: "stretch", width: "100%" }}>
                                <div style={{ width: 3, alignSelf: "stretch", background: sc.color, borderRadius: "10px 0 0 10px", flexShrink: 0, boxShadow: `3px 0 10px ${sc.color}40` }} />
                                <div style={{ width: 56, flexShrink: 0, background: sc.color + "08", display: "flex", alignItems: "center", justifyContent: "center", borderRight: "1px solid var(--border-sub)" }}>
                                  <TeamLogo team={sc.name} size={36} />
                                </div>
                                <div style={{ flex: 1, padding: "8px 12px" }}>
                                  <div style={{ fontFamily: "'Barlow Condensed', sans-serif", fontWeight: 800, fontSize: 15, textTransform: "uppercase", lineHeight: 1.1 }}>{sc.name}</div>
                                  <div style={{ display: "flex", gap: 10, marginTop: 3, alignItems: "center" }}>
                                    <span style={{ fontSize: 10, color: "var(--text-muted)" }}>Constructor</span>
                                    <span style={{ fontSize: 11, color: "#e10600", fontWeight: 700, fontFamily: "'Barlow Condensed', sans-serif" }}>{(constructors.find(c => c.id === sc.id)?.points || 0)} pts</span>
                                  </div>
                                </div>
                                {!isLocked && (
                                  <div style={{ display: "flex", alignItems: "center", padding: "0 10px", flexShrink: 0 }}>
                                    <button onClick={() => setSelectedConstructors(prev => prev.filter(x => x.id !== sc.id))} style={{ background: "transparent", border: "1px solid var(--border-strong)", borderRadius: 6, padding: "5px 7px", cursor: "pointer", fontSize: 12, color: "#444" }}>✕</button>
                                  </div>
                                )}
                              </div>
                            ) : (
                              <div style={{ display: "flex", alignItems: "center", gap: 12, padding: "0 14px", width: "100%" }}>
                                <div style={{ width: 28, height: 28, borderRadius: "50%", border: "1px dashed var(--border-strong)", display: "flex", alignItems: "center", justifyContent: "center", fontSize: isMobile ? 16 : 13, color: "var(--text-faint)", flexShrink: 0 }}>{isMobile ? "+" : "⚙"}</div>
                                <div style={{ color: "var(--text-faint)", fontSize: 11, fontWeight: 700, letterSpacing: 2, textTransform: "uppercase" }}>Add Constructor {slot + 1}</div>
                              </div>
                            )}
                          </div>
                        );
                      })}
                    </div>
                  </div>

                  {/* Points summary */}
                  {(selectedDrivers.length > 0 || selectedConstructors.length > 0) && (
                    <div style={{ marginTop: 16, background: "var(--bg-elevated)", borderRadius: 10, border: "1px solid var(--border)", overflow: "hidden" }}>
                      <div style={{ display: "flex" }}>
                        <div style={{ flex: 1, padding: "12px 16px", borderRight: "1px solid var(--border-sub)" }}>
                          <div style={{ fontSize: 9, color: "var(--text-faint)", textTransform: "uppercase", letterSpacing: 1.5, fontWeight: 700 }}>Projected Pts</div>
                          <div style={{ fontFamily: "'Barlow Condensed', sans-serif", fontWeight: 900, fontSize: 28, color: "#e10600", lineHeight: 1.1, marginTop: 2 }}>{displayPoints.toLocaleString()}</div>
                        </div>
                        <div style={{ flex: 1, padding: "12px 16px" }}>
                          <div style={{ fontSize: 9, color: "var(--text-faint)", textTransform: "uppercase", letterSpacing: 1.5, fontWeight: 700 }}>Team Value</div>
                          <div style={{ fontFamily: "'Barlow Condensed', sans-serif", fontWeight: 900, fontSize: 28, color: "#0fd679", lineHeight: 1.1, marginTop: 2 }}>${spent.toFixed(1)}m</div>
                        </div>
                      </div>
                      {captain && (
                        <div style={{ padding: "8px 16px", borderTop: "1px solid var(--border-sub)", display: "flex", alignItems: "center", gap: 8 }}>
                          <span style={{ fontSize: 10, color: "var(--text-muted)", textTransform: "uppercase", letterSpacing: 1 }}>Captain</span>
                          <span style={{ fontFamily: "'Barlow Condensed', sans-serif", fontSize: 12, fontWeight: 700, color: "#f5a623" }}>⭐ {captain.name}</span>
                          <span style={{ fontSize: 10, color: "var(--text-muted)", marginLeft: "auto" }}>×2 pts</span>
                        </div>
                      )}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        )}

        {/* RACES TAB */}
        {activeTab === "races" && (
          <div>
            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 20 }}>
              <div>
                <h2 style={{ fontFamily: "'Barlow Condensed', sans-serif", fontWeight: 800, fontSize: 24, letterSpacing: 1, textTransform: "uppercase" }}>
                  2026 Race Calendar
                </h2>
                <div style={{ fontSize: 12, color: "var(--text-muted)", marginTop: 2 }}>Click any race to view session results</div>
              </div>
              {user?.email === SUPER_ADMIN_EMAIL && (
                <button
                  className="btn-primary"
                  onClick={() => syncResults(false)}
                  disabled={syncStatus === "loading"}
                  style={{ display: "flex", alignItems: "center", gap: 8, minWidth: 140, justifyContent: "center", fontSize: 13 }}
                >
                  {syncStatus === "loading" ? "Syncing…" : syncStatus === "success" ? "Updated!" : syncStatus === "error" ? "Sync failed" : "Sync Points"}
                </button>
              )}
            </div>

            <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
              {RACES.map(race => {
                const raceEnd = new Date(race.raceDate);
                const qualiStart = new Date(race.qualiDate);
                const isCompleted = now > new Date(raceEnd.getTime() + 3 * 3600000);
                const isNext = race.round === nextRace.round;
                const raceLocked = now >= qualiStart;
                const isExpanded = selectedRaceRound === race.round;
                const roundData = raceResults[race.round];
                const hasLive = roundData?.sessions?.some(s => s.isLive);
                const isCancelled = !!race.cancelled;

                return (
                  <div key={race.round} style={{ borderRadius: 10, border: `1px solid ${isCancelled ? "var(--border)" : isNext ? "#e1060044" : isExpanded ? "var(--border-strong)" : "var(--border)"}`, overflow: "hidden", transition: "border-color 0.2s", opacity: isCancelled ? 0.5 : 1 }}>
                    {/* Row header */}
                    <div
                      className="race-row"
                      onClick={() => {
                        if (isCancelled) return;
                        const next = isExpanded ? null : race.round;
                        setSelectedRaceRound(next);
                        if (next && !raceResults[race.round]?.loaded) loadRaceWeekend(race);
                      }}
                      style={{ display: "grid", gridTemplateColumns: "40px 1fr auto auto", gap: 12, alignItems: "center", padding: "14px 18px", background: isNext ? "rgba(225,6,0,0.05)" : isExpanded ? "var(--bg-elevated)" : "var(--bg-card)", cursor: isCancelled ? "default" : "pointer", userSelect: "none" }}
                    >
                      <div style={{ fontFamily: "'Barlow Condensed', sans-serif", fontWeight: 800, fontSize: 18, color: isCancelled ? "var(--text-faint)" : isCompleted ? "#0fd679" : isNext ? "#e10600" : "var(--text-faint)" }}>
                        {String(race.round).padStart(2, "0")}
                      </div>
                      <div>
                        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                          <span style={{ fontFamily: "'Barlow Condensed', sans-serif", fontWeight: 700, fontSize: 16, textDecoration: isCancelled ? "line-through" : "none" }}>{race.name}</span>
                          {!isCancelled && hasLive && <span className="pulse" style={{ fontSize: 9, fontWeight: 800, letterSpacing: 1, textTransform: "uppercase", color: "#e10600", background: "#e1060018", padding: "2px 7px", borderRadius: 3 }}>● LIVE</span>}
                          {!isCancelled && race.sprint && <span style={{ fontSize: 9, fontWeight: 800, color: "#6692ff", background: "#6692ff18", padding: "2px 6px", borderRadius: 3, letterSpacing: 1, textTransform: "uppercase" }}>Sprint</span>}
                        </div>
                        <div style={{ fontSize: 11, color: "var(--text-muted)", marginTop: 1, textDecoration: isCancelled ? "line-through" : "none" }}>{race.circuit} · {race.date}</div>
                      </div>
                      <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-end", gap: 3 }}>
                        <span className="tag" style={{
                          background: isCancelled ? "rgba(128,128,128,0.12)" : isCompleted ? "#0fd67922" : isNext ? "#e1060022" : "var(--bg-elevated)",
                          color: isCancelled ? "var(--text-muted)" : isCompleted ? "#0fd679" : isNext ? "#e10600" : "var(--text-muted)"
                        }}>
                          {isCancelled ? "Cancelled" : isCompleted ? "Done" : isNext ? (raceLocked ? "Locked" : "Next") : "Upcoming"}
                        </span>
                        {!isCancelled && !raceLocked && !isCompleted && (
                          <div style={{ fontSize: 10, color: "var(--text-faint)" }}>
                            Lock {qualiStart.toLocaleDateString(undefined, { month: "short", day: "numeric" })}
                          </div>
                        )}
                      </div>
                      <div style={{ color: "var(--text-faint)", fontSize: 16, width: 20, textAlign: "center" }}>
                        {isExpanded ? "▲" : "▼"}
                      </div>
                    </div>

                    {/* Expanded session results */}
                    {isExpanded && (
                      <div style={{ borderTop: "1px solid var(--border)", background: "var(--bg-elevated)", padding: 16 }}>
                        {loadingRaceKey === race.round && (
                          <div style={{ textAlign: "center", padding: "24px 0", color: "var(--text-muted)", fontSize: 13 }}>
                            <span className="pulse">Loading session data from OpenF1…</span>
                          </div>
                        )}
                        {roundData?.noData && (
                          <div style={{ textAlign: "center", padding: "20px 0", color: "var(--text-muted)", fontSize: 13 }}>
                            No session data available yet for this race.
                          </div>
                        )}
                        {roundData?.sessions && roundData.sessions.length > 0 && (
                          <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
                            {roundData.sessions.map(({ session, positions, pts, constructorPts, fastestLapNum, isCompleted: sDone, isLive: sLive, isUpcoming: sUpcoming }) => {
                              const scored = ["Qualifying", "Sprint Qualifying", "Sprint", "Race"].includes(session.session_name);
                              const totalFantasyPts = Object.values(pts).reduce((a, b) => a + b, 0);
                              return (
                                <div key={session.session_key} style={{ background: "var(--bg-card)", borderRadius: 8, border: `1px solid ${sLive ? "#e1060044" : "var(--border)"}`, overflow: "hidden" }}>
                                  {/* Session header */}
                                  <div style={{ display: "flex", alignItems: "center", gap: 10, padding: "10px 14px", borderBottom: positions.length ? "1px solid var(--border)" : "none" }}>
                                    <div style={{ fontFamily: "'Barlow Condensed', sans-serif", fontWeight: 800, fontSize: 14, textTransform: "uppercase", letterSpacing: 0.5 }}>
                                      {session.session_name}
                                    </div>
                                    {sLive && (
                                      <span className="pulse" style={{ fontSize: 9, fontWeight: 800, color: "#e10600", background: "#e1060018", padding: "2px 7px", borderRadius: 3, letterSpacing: 1, textTransform: "uppercase" }}>● LIVE</span>
                                    )}
                                    {sUpcoming && (
                                      <span style={{ fontSize: 11, color: "var(--text-faint)" }}>
                                        {new Date(session.date_start).toLocaleString(undefined, { weekday: "short", hour: "2-digit", minute: "2-digit" })}
                                      </span>
                                    )}
                                    {sDone && scored && (
                                      <span style={{ fontSize: 11, color: "var(--text-muted)", marginLeft: "auto" }}>{totalFantasyPts} fantasy pts</span>
                                    )}
                                    {sDone && !scored && (
                                      <span style={{ fontSize: 11, color: "var(--text-faint)", marginLeft: "auto" }}>Practice — no fantasy pts</span>
                                    )}
                                  </div>

                                  {/* Results grid */}
                                  {positions.length > 0 && (
                                    <div style={{ padding: "6px 0" }}>
                                      {positions.map((p, idx) => {
                                        const driver = DRIVERS.find(d => d.number === p.driver_number);
                                        const earned = pts[driver?.id] || 0;
                                        const isMyDriver = driver && selectedDrivers.find(sd => sd.id === driver.id);
                                        const isCap = driver && captain?.id === driver.id;
                                        const isFastestLap = fastestLapNum === p.driver_number;
                                        const isDNF = scored && driver && pts[driver.id] < 0 && !RACE_POINTS.concat(QUALI_POINTS).includes(pts[driver.id]);
                                        return (
                                          <div key={p.driver_number} style={{
                                            display: "grid", gridTemplateColumns: "36px 10px 1fr auto auto",
                                            alignItems: "center", gap: 8, padding: "5px 14px",
                                            background: isMyDriver ? (driver.teamColor + "0a") : "transparent",
                                            borderLeft: isMyDriver ? `3px solid ${driver.teamColor}` : "3px solid transparent",
                                          }}>
                                            <div style={{ fontFamily: "'Barlow Condensed', sans-serif", fontWeight: 800, fontSize: 15, color: idx < 3 ? ["#f5a623","#aaa","#cd7f32"][idx] : "var(--text-faint)", textAlign: "right" }}>
                                              P{p.position}
                                            </div>
                                            <div style={{ width: 3, height: 18, background: driver?.teamColor || "var(--border)", borderRadius: 2, flexShrink: 0 }} />
                                            <div style={{ minWidth: 0, display: "flex", alignItems: "center", gap: 6 }}>
                                              <div style={{ fontFamily: "'Barlow Condensed', sans-serif", fontWeight: 700, fontSize: 14, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                                                {FLAG_MAP[driver?.country]} {driver ? driver.name.split(" ").slice(1).join(" ") : `#${p.driver_number}`}
                                                {isCap && <span style={{ fontSize: 9, color: "#f5a623", marginLeft: 5, fontWeight: 900 }}>CAP</span>}
                                              </div>
                                              {isFastestLap && <span style={{ fontSize: 9, fontWeight: 800, color: "#b366ff", background: "rgba(179,102,255,0.15)", padding: "1px 5px", borderRadius: 3, letterSpacing: 0.5, flexShrink: 0 }}>FL</span>}
                                            </div>
                                            <div style={{ fontSize: 11, color: "var(--text-muted)" }}>
                                              {driver ? TEAM_ABBR[driver.team] : ""}
                                            </div>
                                            <div style={{ textAlign: "right", minWidth: 44 }}>
                                              {scored ? (
                                                earned < 0 ? (
                                                  <span style={{ fontFamily: "'Barlow Condensed', sans-serif", fontWeight: 800, fontSize: 14, color: "#e10600" }}>{earned}</span>
                                                ) : earned > 0 ? (
                                                  <span style={{ fontFamily: "'Barlow Condensed', sans-serif", fontWeight: 800, fontSize: 14, color: isMyDriver ? "#e10600" : "var(--text-secondary)" }}>
                                                    +{isCap ? earned * 2 : earned}
                                                    {isCap && <span style={{ fontSize: 9, color: "#f5a623" }}> ×2</span>}
                                                  </span>
                                                ) : <span style={{ color: "var(--text-faint)", fontSize: 12 }}>—</span>
                                              ) : <span style={{ color: "var(--text-faint)", fontSize: 12 }}>—</span>}
                                            </div>
                                          </div>
                                        );
                                      })}
                                    </div>
                                  )}
                                  {/* Constructor bonuses */}
                                  {sDone && scored && constructorPts && Object.keys(constructorPts).length > 0 && (
                                    <div style={{ borderTop: "1px solid var(--border)", padding: "8px 14px 6px" }}>
                                      <div style={{ fontSize: 9, fontWeight: 800, letterSpacing: 1.5, textTransform: "uppercase", color: "var(--text-faint)", marginBottom: 6 }}>Constructor Points</div>
                                      <div style={{ display: "flex", flexDirection: "column", gap: 3 }}>
                                        {CONSTRUCTORS.map(c => {
                                          const cp = constructorPts[c.name];
                                          if (!cp) return null;
                                          const isMyConstructor = selectedConstructors.some(sc => sc.name === c.name);
                                          return (
                                            <div key={c.name} style={{ display: "flex", alignItems: "center", gap: 8, padding: "3px 0", borderLeft: isMyConstructor ? `3px solid ${c.color}` : "3px solid transparent", paddingLeft: isMyConstructor ? 8 : 0 }}>
                                              <div style={{ width: 6, height: 6, borderRadius: "50%", background: c.color, flexShrink: 0 }} />
                                              <span style={{ fontSize: 12, fontFamily: "'Barlow Condensed', sans-serif", fontWeight: 700, flex: 1 }}>{c.name}</span>
                                              {cp.bonus !== undefined && cp.bonus !== 0 && (
                                                <span style={{ fontSize: 10, color: cp.bonus > 0 ? "#0fd679" : "#e10600", background: cp.bonus > 0 ? "rgba(15,214,121,0.1)" : "rgba(225,6,0,0.1)", padding: "1px 5px", borderRadius: 3 }}>
                                                  {cp.bonus > 0 ? `+${cp.bonus}` : cp.bonus} bonus
                                                </span>
                                              )}
                                              {cp.bestPit !== undefined && cp.bestPit !== null && (
                                                <span style={{ fontSize: 10, color: "var(--text-muted)" }}>{cp.bestPit.toFixed(2)}s pit</span>
                                              )}
                                              <span style={{ fontFamily: "'Barlow Condensed', sans-serif", fontWeight: 800, fontSize: 13, color: isMyConstructor ? "#e10600" : "var(--text-secondary)", minWidth: 36, textAlign: "right" }}>
                                                {cp.total > 0 ? `+${cp.total}` : cp.total}
                                              </span>
                                            </div>
                                          );
                                        })}
                                      </div>
                                    </div>
                                  )}
                                  {sUpcoming && (
                                    <div style={{ padding: "12px 14px", color: "var(--text-faint)", fontSize: 12 }}>
                                      Starts {new Date(session.date_start).toLocaleString(undefined, { weekday: "long", month: "short", day: "numeric", hour: "2-digit", minute: "2-digit" })}
                                    </div>
                                  )}
                                </div>
                              );
                            })}
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        )}

        {/* LEAGUES TAB */}
        {activeTab === "leagues" && (
          <div style={{ maxWidth: 700 }}>
            {selectedLeague ? (
              /* ── LEAGUE BREAKDOWN VIEW ── */
              (() => {
                const members = leagueMembers.filter(m => m.league_id === selectedLeague.id);
                const ranked = [...members].map(member => {
                  const mTeam = memberTeams[member.user_id];
                  return { ...member, _pts: member.total_points || 0, _team: mTeam };
                }).sort((a, b) => b._pts - a._pts);

                return (
                  <div>
                    {/* Header */}
                    <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 24 }}>
                      <button onClick={() => { setSelectedLeague(null); setExpandedMember(null); }} style={{ background: "none", border: "1px solid var(--border-strong)", borderRadius: 8, padding: "6px 12px", cursor: "pointer", color: "var(--text-secondary)", fontSize: 13, display: "flex", alignItems: "center", gap: 6 }}>
                        ← Back
                      </button>
                      <div>
                        <h2 style={{ fontFamily: "'Barlow Condensed', sans-serif", fontWeight: 800, fontSize: 22, letterSpacing: 1, textTransform: "uppercase", margin: 0 }}>{selectedLeague.name}</h2>
                        <div style={{ fontSize: 12, color: "var(--text-muted)", marginTop: 2 }}>{members.length} {members.length === 1 ? "member" : "members"}</div>
                      </div>
                    </div>

                    {/* Leaderboard with breakdown */}
                    <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
                      {ranked.map((member, idx) => {
                        const isMe = member.user_id === user.id;
                        const memberName = member.display_name || (member.user_email ? member.user_email.split("@")[0] : "Unknown");
                        const isExpanded = expandedMember === member.user_id;
                        const mTeam = member._team;
                        const medal = idx === 0 ? "🥇" : idx === 1 ? "🥈" : idx === 2 ? "🥉" : null;

                        // Ensure team and round results are loaded when expanding
                        const handleExpand = () => {
                          if (isExpanded) { setExpandedMember(null); return; }
                          setExpandedMember(member.user_id);
                          if (!isMe && !memberTeams[member.user_id]) {
                            supabase.from('teams').select('*').eq('user_id', member.user_id).single()
                              .then(({ data }) => setMemberTeams(prev => ({ ...prev, [member.user_id]: data || {} })));
                          }
                          if (!memberRoundResults[member.user_id]) {
                            supabase.from('round_results').select('round, meeting_name, total_points, driver_points, constructor_points')
                              .eq('user_id', member.user_id).order('round', { ascending: true })
                              .then(({ data }) => setMemberRoundResults(prev => ({ ...prev, [member.user_id]: data || [] })));
                          }
                        };

                        // Compute per-driver and per-constructor pts for breakdown
                        const captainId = mTeam?.captain_id ? String(mTeam.captain_id) : null;
                        const teamDrivers = mTeam?.driver_ids ? DRIVERS.filter(d => mTeam.driver_ids.map(String).includes(String(d.id))) : [];
                        const teamConstructors = mTeam?.constructor_ids ? CONSTRUCTORS.filter(c => mTeam.constructor_ids.map(String).includes(String(c.id))) : [];

                        return (
                          <div key={member.id} style={{ background: "var(--bg-card)", border: isMe ? "1px solid #e1060033" : "1px solid var(--border)", borderRadius: 10, overflow: "hidden" }}>
                            {/* Row */}
                            <div onClick={handleExpand} style={{ display: "flex", alignItems: "center", gap: 12, padding: "14px 16px", cursor: "pointer" }}>
                              <div style={{ width: 28, textAlign: "center" }}>
                                {medal
                                  ? <span style={{ fontSize: 18 }}>{medal}</span>
                                  : <span style={{ fontFamily: "'Barlow Condensed', sans-serif", fontWeight: 800, fontSize: 16, color: "var(--text-faint)" }}>{idx + 1}</span>
                                }
                              </div>
                              <div style={{ flex: 1 }}>
                                <span style={{ fontWeight: isMe ? 700 : 500, fontSize: 15 }}>{memberName}</span>
                                {isMe && <span style={{ fontSize: 9, color: "#e10600", fontWeight: 700, letterSpacing: 1, textTransform: "uppercase", marginLeft: 6, verticalAlign: "middle" }}>YOU</span>}
                              </div>
                              <div style={{ fontFamily: "'Barlow Condensed', sans-serif", fontWeight: 800, fontSize: 20, color: isMe ? "#e10600" : "var(--text)" }}>{member._pts}</div>
                              <div style={{ fontSize: 11, color: "var(--text-muted)", marginRight: 4 }}>pts</div>
                              <div style={{ fontSize: 11, color: "var(--text-faint)" }}>{isExpanded ? "▲" : "▼"}</div>
                            </div>

                            {/* Breakdown */}
                            {isExpanded && (() => {
                              const rounds = memberRoundResults[member.user_id];
                              if (!rounds) return <div style={{ borderTop: "1px solid var(--border-sub)", padding: "12px 16px 16px 56px", fontSize: 12, color: "var(--text-faint)" }}>Loading…</div>;
                              if (rounds.length === 0) return <div style={{ borderTop: "1px solid var(--border-sub)", padding: "12px 16px 16px 56px", fontSize: 12, color: "var(--text-faint)", fontStyle: "italic" }}>No rounds scored yet</div>;
                              // Sum driver_points and constructor_points across all rounds
                              const driverTotals = {};
                              const conTotals = {};
                              rounds.forEach(r => {
                                Object.entries(r.driver_points || {}).forEach(([id, pts]) => { driverTotals[id] = (driverTotals[id] || 0) + pts; });
                                Object.entries(r.constructor_points || {}).forEach(([id, pts]) => { conTotals[id] = (conTotals[id] || 0) + pts; });
                              });
                              const driverEntries = Object.entries(driverTotals).map(([id, pts]) => ({ driver: DRIVERS.find(d => String(d.id) === String(id)), pts })).filter(e => e.driver).sort((a, b) => b.pts - a.pts);
                              const conEntries = Object.entries(conTotals).map(([id, pts]) => ({ con: CONSTRUCTORS.find(c => String(c.id) === String(id)), pts })).filter(e => e.con).sort((a, b) => b.pts - a.pts);
                              return (
                                <div style={{ borderTop: "1px solid var(--border-sub)", padding: "12px 16px 16px 56px" }}>
                                  <div style={{ display: "flex", flexDirection: "column", gap: 5 }}>
                                    {driverEntries.map(({ driver: d, pts }) => (
                                      <div key={d.id} style={{ display: "flex", alignItems: "center", gap: 8 }}>
                                        <div style={{ width: 3, height: 16, borderRadius: 2, background: d.teamColor, flexShrink: 0 }} />
                                        <span style={{ fontSize: 13, fontFamily: "'Barlow Condensed', sans-serif", fontWeight: 600, textTransform: "uppercase", flex: 1 }}>{d.name.split(" ").slice(1).join(" ")}</span>
                                        <span style={{ fontSize: 13, fontFamily: "'Barlow Condensed', sans-serif", fontWeight: 700, color: pts >= 0 ? "var(--text)" : "#e10600", minWidth: 36, textAlign: "right" }}>{pts > 0 ? "+" : ""}{pts}</span>
                                      </div>
                                    ))}
                                    {conEntries.map(({ con: c, pts }) => (
                                      <div key={c.id} style={{ display: "flex", alignItems: "center", gap: 8 }}>
                                        <div style={{ width: 3, height: 16, borderRadius: 2, background: c.color, flexShrink: 0 }} />
                                        <span style={{ fontSize: 13, fontFamily: "'Barlow Condensed', sans-serif", fontWeight: 600, textTransform: "uppercase", flex: 1, color: "var(--text-secondary)" }}>{c.name}</span>
                                        <span style={{ fontSize: 13, fontFamily: "'Barlow Condensed', sans-serif", fontWeight: 700, color: pts >= 0 ? "var(--text)" : "#e10600", minWidth: 36, textAlign: "right" }}>{pts > 0 ? "+" : ""}{pts}</span>
                                      </div>
                                    ))}
                                    <div style={{ borderTop: "1px solid var(--border-sub)", marginTop: 4, paddingTop: 8, display: "flex", alignItems: "center", justifyContent: "flex-end", gap: 6 }}>
                                      <span style={{ fontSize: 12, color: "var(--text-muted)" }}>Total</span>
                                      <span style={{ fontSize: 14, fontFamily: "'Barlow Condensed', sans-serif", fontWeight: 800, color: member._pts >= 0 ? "var(--text)" : "#e10600" }}>{member._pts} pts</span>
                                    </div>
                                  </div>
                                </div>
                              );
                            })()}
                          </div>
                        );
                      })}
                    </div>
                  </div>
                );
              })()
            ) : (
              /* ── LEAGUE LIST VIEW ── */
              <>
            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 24 }}>
              <h2 style={{ fontFamily: "'Barlow Condensed', sans-serif", fontWeight: 800, fontSize: 24, letterSpacing: 1, textTransform: "uppercase" }}>My Leagues</h2>
              <button className="btn-primary" onClick={() => setShowCreateLeague(true)}>+ Create League</button>
            </div>

            {leagueError && (
              <div style={{ background: "rgba(225,6,0,0.1)", border: "1px solid rgba(225,6,0,0.4)", borderRadius: 8, padding: "10px 14px", marginBottom: 16, fontSize: 13, color: "#e10600" }}>
                {leagueError}
              </div>
            )}

            {/* Create League Modal */}
            {showCreateLeague && (
              <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.85)", zIndex: 1000, display: "flex", alignItems: "center", justifyContent: "center", padding: 20 }} onClick={() => { setShowCreateLeague(false); setNewLeagueName(""); setLeagueError(""); }}>
                <div style={{ background: "var(--bg-card)", border: "1px solid var(--border)", borderRadius: 14, padding: 28, width: "100%", maxWidth: 400 }} onClick={e => e.stopPropagation()}>
                  <h3 style={{ fontFamily: "'Barlow Condensed', sans-serif", fontWeight: 800, fontSize: 22, textTransform: "uppercase", marginBottom: 20 }}>Create a League</h3>
                  <div style={{ marginBottom: 16 }}>
                    <label style={{ fontSize: 11, color: "var(--text-muted)", textTransform: "uppercase", letterSpacing: 1, fontWeight: 700, marginBottom: 6, display: "block" }}>League Name</label>
                    <input
                      type="text"
                      value={newLeagueName}
                      onChange={e => setNewLeagueName(e.target.value)}
                      placeholder="e.g. Race Day Boys"
                      style={{ width: "100%", padding: "12px 14px", fontSize: 16, background: "var(--bg-input)", border: "1px solid var(--border-strong)", borderRadius: 8, color: "var(--text)", outline: "none", boxSizing: "border-box" }}
                      autoFocus
                      onKeyDown={e => { if (e.key === "Enter") createLeague(); }}
                    />
                  </div>
                  <div style={{ display: "flex", gap: 10 }}>
                    <button onClick={() => { setShowCreateLeague(false); setNewLeagueName(""); setLeagueError(""); }} style={{ flex: 1, padding: "12px 20px", background: "var(--bg-elevated)", border: "1px solid var(--border-strong)", borderRadius: 8, color: "var(--text-secondary)", fontWeight: 700, fontSize: 14, cursor: "pointer" }}>Cancel</button>
                    <button className="btn-primary" onClick={createLeague} style={{ flex: 1, padding: "12px 20px" }}>Create</button>
                  </div>
                </div>
              </div>
            )}

            {/* League cards */}
            {leagues.length === 0 && (
              <div style={{ textAlign: "center", padding: "40px 20px" }}>
                <div style={{ marginBottom: 12, opacity: 0.2 }}><svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round"><path d="M8 21h8m-4-4v4M7 3h10l-1.5 8a4.5 4.5 0 01-7 0L7 3z"/><path d="M7 5H4a1 1 0 00-1 1v1a4 4 0 004 4M17 5h3a1 1 0 011 1v1a4 4 0 01-4 4"/></svg></div>
                <div style={{ fontFamily: "'Barlow Condensed', sans-serif", fontWeight: 700, fontSize: 18, color: "var(--text-muted)", marginBottom: 8 }}>No leagues yet</div>
                <div style={{ fontSize: 13, color: "var(--text-faint)" }}>Create a league and invite your friends, or join one with an invite code below.</div>
              </div>
            )}

            {leagues.map(league => {
              const members = leagueMembers.filter(m => m.league_id === league.id);
              const isCreator = league.created_by === user.id;
              return (
                <div key={league.id} style={{ background: "var(--bg-card)", border: "1px solid var(--border)", borderRadius: 10, padding: 20, marginBottom: 12 }}>
                  <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 16 }}>
                    <div>
                      <div onClick={() => { setSelectedLeague(league); setExpandedMember(null); }} style={{ fontFamily: "'Barlow Condensed', sans-serif", fontWeight: 800, fontSize: 18, cursor: "pointer", display: "flex", alignItems: "center", gap: 6 }}>{league.name} <span style={{ fontSize: 12, color: "var(--text-faint)" }}>›</span></div>
                      <div style={{ fontSize: 12, color: "var(--text-muted)", marginTop: 2 }}>
                        Code: <span style={{ color: "#e10600", fontWeight: 700, fontFamily: "monospace", letterSpacing: 2 }}>{league.code}</span>
                        <button onClick={() => { navigator.clipboard.writeText(league.code); }} style={{ marginLeft: 8, background: "none", border: "none", color: "var(--text-muted)", cursor: "pointer", padding: "2px 4px", lineHeight: 0 }} title="Copy code"><svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><rect x="9" y="9" width="13" height="13" rx="2"/><path d="M5 15H4a2 2 0 01-2-2V4a2 2 0 012-2h9a2 2 0 012 2v1"/></svg></button>
                      </div>
                      <div style={{ fontSize: 12, color: "var(--text-muted)", marginTop: 4 }}>
                        <span style={{ color: "var(--text-faint)" }}>Invite: </span>
                        <span style={{ color: "var(--text-secondary)", fontFamily: "monospace", fontSize: 11 }}>robsf1app.com/api/invite?code={league.code}</span>
                        <button onClick={() => { navigator.clipboard.writeText(`https://robsf1app.com/api/invite?code=${league.code}`); }} style={{ marginLeft: 8, background: "none", border: "none", color: "var(--text-muted)", cursor: "pointer", padding: "2px 4px", lineHeight: 0 }} title="Copy link"><svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><path d="M10 13a5 5 0 007.54.54l3-3a5 5 0 00-7.07-7.07l-1.72 1.71"/><path d="M14 11a5 5 0 00-7.54-.54l-3 3a5 5 0 007.07 7.07l1.71-1.71"/></svg></button>
                      </div>
                    </div>
                    <div style={{ textAlign: "right" }}>
                      <div style={{ fontFamily: "'Barlow Condensed', sans-serif", fontWeight: 800, fontSize: 28, color: "#e10600" }}>{members.length}</div>
                      <div style={{ fontSize: 11, color: "var(--text-muted)" }}>{members.length === 1 ? "member" : "members"}</div>
                    </div>
                  </div>

                  {/* Member leaderboard */}
                  <div style={{ display: "flex", flexDirection: "column", gap: 0 }}>
                    {[...members].map(member => {
                      return { ...member, _pts: member.total_points || 0 };
                    }).sort((a, b) => b._pts - a._pts).map((member, idx) => {
                      const isMe = member.user_id === user.id;
                      const memberName = member.display_name || (member.user_email ? member.user_email.split("@")[0] : "Unknown");
                      const pts = member._pts;
                      const isExpanded = expandedMember === member.user_id;
                      // For own row use already-loaded local state, else use fetched data
                      const mTeam = isMe
                        ? { driver_ids: selectedDrivers.map(d => String(d.id)), constructor_ids: selectedConstructors.map(c => String(c.id)), captain_id: captain ? String(captain.id) : null }
                        : memberTeams[member.user_id];
                      return (
                        <div key={member.id}>
                          <div
                            onClick={() => {
                              if (!isMe && !isLocked) return;
                              if (isExpanded) { setExpandedMember(null); return; }
                              setExpandedMember(member.user_id);
                              if (!isMe && !memberTeams[member.user_id]) {
                                supabase.from('teams').select('*').eq('user_id', member.user_id).single()
                                  .then(({ data }) => {
                                    setMemberTeams(prev => ({ ...prev, [member.user_id]: data || {} }));
                                  });
                              }
                              if (!memberRoundResults[member.user_id]) {
                                supabase.from('round_results').select('round, meeting_name, total_points, driver_points, constructor_points')
                                  .eq('user_id', member.user_id).order('round', { ascending: true })
                                  .then(({ data }) => setMemberRoundResults(prev => ({ ...prev, [member.user_id]: data || [] })));
                              }
                            }}
                            style={{ display: "flex", alignItems: "center", gap: 12, padding: "10px 12px", borderRadius: isMe ? 6 : 0, background: isMe ? "rgba(225,6,0,0.06)" : "transparent", border: isMe ? "1px solid #e1060022" : "none", cursor: isMe || isLocked ? "pointer" : "default" }}
                          >
                            <div style={{ width: 24, fontFamily: "'Barlow Condensed', sans-serif", fontWeight: 800, fontSize: 16, color: idx === 0 ? "#f5a623" : "var(--text-faint)", textAlign: "center" }}>
                              {idx + 1}
                            </div>
                            <div style={{ flex: 1, fontWeight: isMe ? 700 : 400, fontSize: 14 }}>
                              {memberName}{isMe ? <span style={{ fontSize: 9, color: "#e10600", fontWeight: 700, letterSpacing: 1, textTransform: "uppercase", marginLeft: 6, verticalAlign: "middle" }}>YOU</span> : ""}
                            </div>
                            <div style={{ fontFamily: "'Barlow Condensed', sans-serif", fontWeight: 700, fontSize: 14, color: isMe ? "#e10600" : "var(--text-secondary)" }}>
                              {pts} pts
                            </div>
                            {isMe || isLocked
                              ? <div style={{ fontSize: 10, color: "var(--text-faint)", width: 14, textAlign: "center" }}>{isExpanded ? "▲" : "▼"}</div>
                              : <div style={{ fontSize: 9, color: "var(--text-faint)", letterSpacing: 0.5, textTransform: "uppercase", fontWeight: 700 }}>🔒</div>
                            }
                          </div>
                          {isExpanded && (() => {
                            const rounds = memberRoundResults[member.user_id];
                            if (!rounds) return <div style={{ padding: "10px 12px 14px 50px", borderTop: "1px solid var(--border-sub)", fontSize: 12, color: "var(--text-faint)" }}>Loading…</div>;
                            if (rounds.length === 0) return <div style={{ padding: "10px 12px 14px 50px", borderTop: "1px solid var(--border-sub)", fontSize: 12, color: "var(--text-faint)", fontStyle: "italic" }}>No rounds scored yet</div>;
                            const driverTotals = {};
                            const conTotals = {};
                            rounds.forEach(r => {
                              Object.entries(r.driver_points || {}).forEach(([id, p]) => { driverTotals[id] = (driverTotals[id] || 0) + p; });
                              Object.entries(r.constructor_points || {}).forEach(([id, p]) => { conTotals[id] = (conTotals[id] || 0) + p; });
                            });
                            const driverEntries = Object.entries(driverTotals).map(([id, p]) => ({ driver: DRIVERS.find(d => String(d.id) === String(id)), pts: p })).filter(e => e.driver).sort((a, b) => b.pts - a.pts);
                            const conEntries = Object.entries(conTotals).map(([id, p]) => ({ con: CONSTRUCTORS.find(c => String(c.id) === String(id)), pts: p })).filter(e => e.con).sort((a, b) => b.pts - a.pts);
                            return (
                              <div style={{ padding: "10px 12px 14px 50px", borderTop: "1px solid var(--border-sub)" }}>
                                <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
                                  {driverEntries.map(({ driver: d, pts: p }) => (
                                    <div key={d.id} style={{ display: "flex", alignItems: "center", gap: 8 }}>
                                      <div style={{ width: 3, height: 14, borderRadius: 2, background: d.teamColor, flexShrink: 0 }} />
                                      <span style={{ fontSize: 12, fontFamily: "'Barlow Condensed', sans-serif", fontWeight: 600, textTransform: "uppercase", flex: 1 }}>{d.name.split(" ").slice(1).join(" ")}</span>
                                      <span style={{ fontSize: 12, fontFamily: "'Barlow Condensed', sans-serif", fontWeight: 700, color: p >= 0 ? "var(--text)" : "#e10600" }}>{p > 0 ? "+" : ""}{p}</span>
                                    </div>
                                  ))}
                                  {conEntries.map(({ con: c, pts: p }) => (
                                    <div key={c.id} style={{ display: "flex", alignItems: "center", gap: 8 }}>
                                      <div style={{ width: 3, height: 14, borderRadius: 2, background: c.color, flexShrink: 0 }} />
                                      <span style={{ fontSize: 12, fontFamily: "'Barlow Condensed', sans-serif", fontWeight: 600, textTransform: "uppercase", flex: 1, color: "var(--text-secondary)" }}>{c.name}</span>
                                      <span style={{ fontSize: 12, fontFamily: "'Barlow Condensed', sans-serif", fontWeight: 700, color: p >= 0 ? "var(--text)" : "#e10600" }}>{p > 0 ? "+" : ""}{p}</span>
                                    </div>
                                  ))}
                                  <div style={{ borderTop: "1px solid var(--border-sub)", marginTop: 4, paddingTop: 6, display: "flex", alignItems: "center", justifyContent: "flex-end", gap: 6 }}>
                                    <span style={{ fontSize: 11, color: "var(--text-muted)" }}>Total</span>
                                    <span style={{ fontSize: 13, fontFamily: "'Barlow Condensed', sans-serif", fontWeight: 800, color: pts >= 0 ? "var(--text)" : "#e10600" }}>{pts} pts</span>
                                  </div>
                                </div>
                              </div>
                            );
                          })()}
                        </div>
                      );
                    })}
                  </div>

                  {/* Leave / Delete button */}
                  <div style={{ marginTop: 12, paddingTop: 12, borderTop: "1px solid var(--border-sub)", display: "flex", justifyContent: "space-between", alignItems: "center", gap: 10 }}>
                    {user.email === SUPER_ADMIN_EMAIL && (
                      <div style={{ flex: 1 }}>
                        {addMemberLeagueId === league.id ? (
                          <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
                            <div style={{ display: "flex", gap: 8 }}>
                              <div style={{ flex: 1 }}>
                                <input
                                  type="text"
                                  list={`suggestions-${league.id}`}
                                  placeholder="Member email..."
                                  value={addMemberEmail}
                                  onChange={e => searchMembers(e.target.value, league.id)}
                                  onKeyDown={e => { if (e.key === "Enter") addMemberToLeague(league.id); if (e.key === "Escape") { setAddMemberLeagueId(null); setAddMemberEmail(""); setAddMemberError(""); setAddMemberSuggestions([]); } }}
                                  autoFocus
                                  style={{ width: "100%", padding: "6px 10px", fontSize: 13, background: "var(--bg-input)", border: "1px solid var(--border-strong)", borderRadius: 6, color: "var(--text)", outline: "none", boxSizing: "border-box" }}
                                />
                                <datalist id={`suggestions-${league.id}`}>
                                  {addMemberSuggestions.map(s => (
                                    <option key={s.email} value={s.email}>{s.display_name || s.email.split("@")[0]}</option>
                                  ))}
                                </datalist>
                              </div>
                              <button onClick={() => addMemberToLeague(league.id)} className="btn-primary" style={{ fontSize: 12, padding: "6px 12px" }}>Add</button>
                              <button onClick={() => { setAddMemberLeagueId(null); setAddMemberEmail(""); setAddMemberError(""); setAddMemberSuggestions([]); }} style={{ background: "none", border: "1px solid var(--border-strong)", borderRadius: 6, padding: "6px 10px", fontSize: 12, color: "var(--text-secondary)", cursor: "pointer" }}>Cancel</button>
                            </div>
                            {addMemberError && <div style={{ fontSize: 12, color: "#e10600" }}>{addMemberError}</div>}
                          </div>
                        ) : (
                          <button onClick={() => { setAddMemberLeagueId(league.id); setAddMemberError(""); }} style={{ background: "none", border: "1px solid #1a2a1a", borderRadius: 6, padding: "6px 14px", fontSize: 12, color: "#0fd679", cursor: "pointer", fontWeight: 600 }}>
                            + Add Member
                          </button>
                        )}
                      </div>
                    )}
                    <button
                      onClick={() => leaveLeague(league.id)}
                      style={{ background: "none", border: "1px solid #2a1a1a", borderRadius: 6, padding: "6px 14px", fontSize: 12, color: "#e10600", cursor: "pointer", fontWeight: 600 }}
                    >
                      {isCreator ? "Delete League" : "Leave League"}
                    </button>
                  </div>
                </div>
              );
            })}

            {/* Join a league */}
            <div style={{ marginTop: 20, padding: 20, background: "var(--bg-card)", border: "1px dashed var(--border-strong)", borderRadius: 10, textAlign: "center" }}>
              <div style={{ fontSize: 13, color: "var(--text-faint)", marginBottom: 12 }}>Join a league with an invite code</div>
              <div style={{ display: "flex", gap: 10, justifyContent: "center" }}>
                <input
                  type="text"
                  placeholder="Enter league code..."
                  value={joinCode}
                  onChange={e => setJoinCode(e.target.value.toUpperCase())}
                  onKeyDown={e => { if (e.key === "Enter") joinLeague(); }}
                  style={{ width: 200, padding: "12px 14px", fontSize: 16, background: "var(--bg-input)", border: "1px solid var(--border-strong)", borderRadius: 8, color: "var(--text)", textAlign: "center", fontFamily: "monospace", letterSpacing: 3, textTransform: "uppercase" }}
                />
                <button className="btn-primary" onClick={joinLeague}>Join</button>
              </div>
            </div>
            </>
            )}
          </div>
        )}

        {/* STATS TAB */}
        {activeTab === "stats" && (
          <div>
            <h2 style={{ fontFamily: "'Barlow Condensed', sans-serif", fontWeight: 800, fontSize: 24, letterSpacing: 1, textTransform: "uppercase", marginBottom: 20 }}>
              Driver Stats
            </h2>
            <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(240px, 1fr))", gap: 10 }}>
              {[...drivers].sort((a, b) => b.fantasyPoints - a.fantasyPoints).map((d, i) => (
                <div key={d.id} onClick={() => setSelectedStatsDriver(d)} style={{ background: "var(--bg-card)", border: "1px solid var(--border)", borderRadius: 10, overflow: "hidden", display: "flex", cursor: "pointer" }}>
                  {/* Color stripe */}
                  <div style={{ width: 4, background: d.teamColor, flexShrink: 0, borderRadius: "10px 0 0 10px" }} />
                  {/* Portrait */}
                  <div style={{ width: 72, flexShrink: 0, background: d.teamColor + "08", borderRight: "1px solid var(--border-sub)", display: "flex", alignItems: "center", justifyContent: "center", position: "relative", overflow: "hidden" }}>
                    <div style={{ position: "absolute", right: -4, bottom: -10, fontFamily: "'Barlow Condensed', sans-serif", fontWeight: 900, fontSize: 44, color: d.teamColor + "1e", lineHeight: 1, userSelect: "none" }}>{d.number}</div>
                    <img src={`/drivers/driver-${d.id}.png`} alt={d.name} style={{ width: 56, height: 56, objectFit: "cover", objectPosition: "top center", position: "relative", zIndex: 1 }} />
                  </div>
                  {/* Info */}
                  <div style={{ flex: 1, padding: "12px 14px", minWidth: 0 }}>
                    <div style={{ display: "flex", alignItems: "flex-start", justifyContent: "space-between", gap: 4, marginBottom: 2 }}>
                      <div>
                        <div style={{ fontSize: 9, color: "var(--text-muted)", marginBottom: 1 }}>{FLAG_MAP[d.country]} {d.name.split(" ")[0]}</div>
                        <div style={{ fontFamily: "'Barlow Condensed', sans-serif", fontWeight: 900, fontSize: 17, textTransform: "uppercase", lineHeight: 1.1, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                          {d.name.split(" ").slice(1).join(" ")}
                        </div>
                        <div style={{ marginTop: 3, display: "inline-flex", alignItems: "center", gap: 4 }}>
                          <div style={{ width: 5, height: 5, borderRadius: "50%", background: d.teamColor }} />
                          <span style={{ fontSize: 9, color: "var(--text-faint)", fontWeight: 800, textTransform: "uppercase", letterSpacing: 1, fontFamily: "'Barlow Condensed', sans-serif" }}>{TEAM_ABBR[d.team]}</span>
                        </div>
                      </div>
                      <div style={{ fontFamily: "'Barlow Condensed', sans-serif", fontSize: 13, color: "var(--text-faint)", fontWeight: 900, flexShrink: 0, marginTop: 2 }}>#{i + 1}</div>
                    </div>
                    <div style={{ display: "flex", gap: 0, marginTop: 10, borderTop: "1px solid var(--border-sub)", paddingTop: 8 }}>
                      <div style={{ flex: 1 }}>
                        <div style={{ fontSize: 8, color: "var(--text-faint)", textTransform: "uppercase", letterSpacing: 1, fontWeight: 700 }}>PTS</div>
                        <div style={{ fontFamily: "'Barlow Condensed', sans-serif", fontWeight: 800, fontSize: 20, color: "#e10600", lineHeight: 1.1 }}>{d.fantasyPoints}</div>
                      </div>
                      <div style={{ flex: 1, textAlign: "right" }}>
                        <div style={{ fontSize: 8, color: "var(--text-faint)", textTransform: "uppercase", letterSpacing: 1, fontWeight: 700 }}>PRICE</div>
                        <div style={{ fontFamily: "'Barlow Condensed', sans-serif", fontWeight: 800, fontSize: 20, color: "#0fd679", lineHeight: 1.1 }}>${d.price}m</div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* RULES TAB */}
        {activeTab === "rules" && (() => {
          const Pts = ({ v }) => (
            <span style={{
              fontFamily: "'Barlow Condensed', sans-serif", fontWeight: 800, fontSize: 13,
              color: v > 0 ? "#0fd679" : v < 0 ? "#e10600" : "var(--text-muted)",
              background: v > 0 ? "rgba(15,214,121,0.1)" : v < 0 ? "rgba(225,6,0,0.1)" : "var(--bg-elevated)",
              padding: "2px 8px", borderRadius: 4, whiteSpace: "nowrap",
            }}>
              {v > 0 ? `+${v}` : v} pts
            </span>
          );
          const Row = ({ label, pts, note }) => (
            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "8px 0", borderBottom: "1px solid var(--border-sub)", gap: 12 }}>
              <span style={{ fontSize: 13, color: "var(--text-secondary)", flex: 1 }}>{label}{note && <span style={{ fontSize: 10, color: "var(--text-faint)", marginLeft: 4 }}>*</span>}</span>
              <Pts v={pts} />
            </div>
          );
          const Section = ({ title, color = "#e10600", children }) => (
            <div style={{ background: "var(--bg-card)", border: "1px solid var(--border)", borderRadius: 12, overflow: "hidden", marginBottom: 16 }}>
              <div style={{ padding: "14px 20px", borderBottom: "1px solid var(--border)", display: "flex", alignItems: "center", gap: 10 }}>
                <div style={{ width: 3, height: 20, background: color, borderRadius: 2, flexShrink: 0 }} />
                <div style={{ fontFamily: "'Barlow Condensed', sans-serif", fontWeight: 800, fontSize: 18, textTransform: "uppercase", letterSpacing: 1 }}>{title}</div>
              </div>
              <div style={{ padding: "4px 20px 16px" }}>{children}</div>
            </div>
          );
          const Sub = ({ label }) => (
            <div style={{ fontSize: 10, fontWeight: 800, letterSpacing: 1.5, textTransform: "uppercase", color: "var(--text-faint)", marginTop: 16, marginBottom: 4 }}>{label}</div>
          );
          return (
            <div style={{ maxWidth: 680 }}>
              <h2 style={{ fontFamily: "'Barlow Condensed', sans-serif", fontWeight: 800, fontSize: 24, letterSpacing: 1, textTransform: "uppercase", marginBottom: 4 }}>Scoring Rules</h2>
              <p style={{ fontSize: 13, color: "var(--text-muted)", marginBottom: 20 }}>How fantasy points are calculated each race weekend.</p>

              {/* What's New */}
              <div style={{ background: "rgba(245,166,35,0.08)", border: "1px solid rgba(245,166,35,0.3)", borderRadius: 10, padding: "12px 16px", marginBottom: 20, display: "flex", gap: 10, alignItems: "flex-start" }}>
                <div style={{ fontSize: 9, fontWeight: 800, letterSpacing: 1, color: "#f5a623", background: "rgba(245,166,35,0.2)", padding: "3px 8px", borderRadius: 3, textTransform: "uppercase", flexShrink: 0, marginTop: 1 }}>2026</div>
                <div>
                  <div style={{ fontSize: 13, fontWeight: 700, color: "var(--text)", marginBottom: 2 }}>What's new this season</div>
                  <div style={{ fontSize: 12, color: "var(--text-secondary)" }}>Sprint DNF/DSQ penalties reduced from −20 to <strong style={{ color: "#e10600" }}>−10 pts</strong>. Positions lost in the Race no longer deduct points.</div>
                </div>
              </div>

              {/* Qualifying */}
              <Section title="Qualifying" color="#6692ff">
                <Sub label="Driver — Qualifying Result" />
                {[[1,"Pole position",10],[2,"2nd place",9],[3,"3rd place",8],[4,"4th place",7],[5,"5th place",6],[6,"6th place",5],[7,"7th place",4],[8,"8th place",3],[9,"9th place",2],[10,"10th place",1]].map(([p,l,v]) => (
                  <Row key={p} label={l} pts={v} />
                ))}
                <Row label="11th–20th place" pts={0} />
                <Row label="NC / DSQ / No time set" pts={-5} note />
                <p style={{ fontSize: 11, color: "var(--text-faint)", marginTop: 8 }}>* Includes drivers who don't set a lap in Q1.</p>

                <Sub label="Constructor Bonus" />
                <Row label="Neither driver reaches Q2" pts={-1} />
                <Row label="One driver reaches Q2" pts={1} />
                <Row label="Both drivers reach Q2" pts={3} />
                <Row label="One driver reaches Q3" pts={5} />
                <Row label="Both drivers reach Q3" pts={10} />
                <Row label="Disqualified driver" pts={-5} note />
                <p style={{ fontSize: 11, color: "var(--text-faint)", marginTop: 8 }}>* Per driver disqualified. Constructor also earns combined driver qualifying points.</p>
              </Section>

              {/* Sprint */}
              <Section title="Sprint Weekend" color="#ff87bc">
                <Sub label="Driver — Sprint Qualifying" />
                <p style={{ fontSize: 12, color: "var(--text-secondary)", marginTop: 4, marginBottom: 8 }}>Sprint Qualifying does not award fantasy points. Results are used to determine the Sprint Race grid only.</p>

                <Sub label="Driver — Sprint" />
                <Row label="1st place" pts={8} />
                <Row label="2nd place" pts={7} />
                <Row label="3rd place" pts={6} />
                <Row label="4th place" pts={5} />
                <Row label="5th place" pts={4} />
                <Row label="6th place" pts={3} />
                <Row label="7th place" pts={2} />
                <Row label="8th place" pts={1} />
                <Row label="9th–20th place" pts={0} />
                <Row label="DNF / DSQ / Not classified" pts={-10} note />
                <Row label="Positions gained vs grid" pts={1} />
                <Row label="Positions lost vs grid" pts={-1} />
                <Row label="Fastest lap" pts={5} />
                <p style={{ fontSize: 11, color: "var(--text-faint)", marginTop: 8 }}>* Penalty applies to all drivers not classified, including inactive drivers not on the starting grid.</p>

                <Sub label="Constructor" />
                <p style={{ fontSize: 12, color: "var(--text-muted)", paddingTop: 6 }}>Combined total of both drivers' sprint points. DSQ: −10 pts per driver.</p>
              </Section>

              {/* Race */}
              <Section title="Race" color="#e10600">
                <Sub label="Driver — Race Result" />
                {[[1,25],[2,18],[3,15],[4,12],[5,10],[6,8],[7,6],[8,4],[9,2],[10,1]].map(([p,v]) => (
                  <Row key={p} label={`${["1st","2nd","3rd","4th","5th","6th","7th","8th","9th","10th"][p-1]} place`} pts={v} />
                ))}
                <Row label="11th–20th place" pts={0} />
                <Row label="DNF / DSQ / Not classified" pts={-20} note />
                <Row label="Positions gained vs grid" pts={1} />
                <Row label="Fastest lap" pts={10} />
                <Row label="Driver of the Day" pts={10} />
                <p style={{ fontSize: 11, color: "var(--text-faint)", marginTop: 8 }}>* Pitlane starters treated as starting from last on grid. Unclassified drivers receive −20 instead of positions-lost penalty.</p>

                <Sub label="Constructor — Pitstop Bonus" />
                <Row label="Over 3.0s" pts={0} />
                <Row label="2.50 – 2.99s" pts={2} />
                <Row label="2.20 – 2.49s" pts={5} />
                <Row label="2.00 – 2.19s" pts={10} />
                <Row label="Under 2.0s" pts={20} />
                <Row label="Fastest pitstop of the race" pts={5} />
                <Row label="World record pitstop (sub 1.8s)" pts={15} />
                <Row label="Disqualified driver" pts={-20} note />
                <p style={{ fontSize: 11, color: "var(--text-faint)", marginTop: 8 }}>* Per driver. Constructor earns combined driver race points (Driver of the Day excluded).</p>
              </Section>

              {/* Captain */}
              <Section title="Captain" color="#f5a623">
                <p style={{ fontSize: 13, color: "var(--text-secondary)", paddingTop: 8, lineHeight: 1.6 }}>
                  Designate one driver as your Captain before qualifying locks. Your Captain scores <strong style={{ color: "#f5a623" }}>2× points</strong> for the entire race weekend — qualifying, sprint, and race combined.
                </p>
                <p style={{ fontSize: 12, color: "var(--text-muted)", marginTop: 8 }}>Choose wisely — you can change your captain any time before the qualifying lock deadline.</p>
              </Section>

              {/* Transfers */}
              <Section title="Transfers & Budget" color="#0fd679">
                <Sub label="Budget" />
                <p style={{ fontSize: 13, color: "var(--text-secondary)", paddingTop: 8, lineHeight: 1.6 }}>
                  Each team has a <strong style={{ color: "#0fd679" }}>$100M budget</strong>. Select 5 drivers and 2 constructors within that limit. Driver and constructor prices fluctuate during the season based on performance.
                </p>
                <Sub label="Free Transfers" />
                <p style={{ fontSize: 13, color: "var(--text-secondary)", paddingTop: 6, lineHeight: 1.6 }}>
                  You receive a set number of free transfers each gameweek. Additional transfers beyond your allowance each cost <strong style={{ color: "#e10600" }}>−10 pts</strong> deducted from your score.
                </p>
                <Sub label="Team Lock" />
                <p style={{ fontSize: 13, color: "var(--text-secondary)", paddingTop: 6, lineHeight: 1.6 }}>
                  Teams lock at <strong>sprint qualifying start</strong> on sprint weekends, otherwise at <strong>qualifying start</strong>. No changes can be made once locked — plan ahead.
                </p>
              </Section>

              {/* Footnotes */}
              <div style={{ padding: "12px 16px", background: "var(--bg-card)", borderRadius: 8, border: "1px solid var(--border)" }}>
                <div style={{ fontSize: 10, fontWeight: 800, letterSpacing: 1.5, textTransform: "uppercase", color: "var(--text-faint)", marginBottom: 8 }}>Notes</div>
                <div style={{ fontSize: 11, color: "var(--text-faint)", lineHeight: 1.7 }}>
                  <p>Overtakes: Valid when one driver legally passes another on track. Passing a car in the pits, suffering a failure, or going unreasonably slow does not count.</p>
                  <p style={{ marginTop: 4 }}>Driver of the Day: Based on the official F1® DOTD award voted by fans after each race.</p>
                  <p style={{ marginTop: 4 }}>All classifications are based on final decisions by the FIA and Formula 1®. Points may be revised if results are amended post-race.</p>
                </div>
              </div>
            </div>
          );
        })()}

        {/* PROFILE TAB */}
        {activeTab === "profile" && (
          <div style={{ maxWidth: 500 }}>
            <h2 style={{ fontFamily: "'Barlow Condensed', sans-serif", fontWeight: 800, fontSize: 24, letterSpacing: 1, textTransform: "uppercase", marginBottom: 24 }}>Profile</h2>

            <div style={{ background: "var(--bg-card)", border: "1px solid var(--border)", borderRadius: 12, padding: 24, marginBottom: 16 }}>
              <div style={{ fontSize: 11, color: "var(--text-muted)", textTransform: "uppercase", letterSpacing: 1, fontWeight: 700, marginBottom: 20 }}>Account</div>
              <div style={{ display: "flex", gap: 12, alignItems: "center", marginBottom: 20, paddingBottom: 20, borderBottom: "1px solid var(--border-sub)" }}>
                <div style={{ width: 48, height: 48, borderRadius: "50%", background: "var(--bg-elevated)", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 20, flexShrink: 0 }}>
                  {user.user_metadata?.avatar_url
                    ? <img src={user.user_metadata.avatar_url} alt="" style={{ width: 48, height: 48, borderRadius: "50%", objectFit: "cover" }} />
                    : "👤"}
                </div>
                <div>
                  <div style={{ fontWeight: 700, fontSize: 15 }}>{displayName}</div>
                  <div style={{ fontSize: 12, color: "var(--text-muted)", marginTop: 2 }}>{user.email}</div>
                </div>
              </div>

              <div style={{ marginBottom: 16 }}>
                <label style={{ fontSize: 11, color: "var(--text-muted)", textTransform: "uppercase", letterSpacing: 1, fontWeight: 700, marginBottom: 8, display: "block" }}>Display Name</label>
                <input
                  type="text"
                  value={displayName}
                  onChange={e => setDisplayName(e.target.value)}
                  onKeyDown={e => { if (e.key === "Enter") saveProfile(); }}
                  placeholder="Your name"
                  maxLength={30}
                  style={{ width: "100%", padding: "12px 14px", fontSize: 15, background: "var(--bg-input)", border: "1px solid var(--border-strong)", borderRadius: 8, color: "var(--text)", outline: "none", boxSizing: "border-box" }}
                />
                <div style={{ fontSize: 11, color: "var(--text-faint)", marginTop: 6 }}>This is how you appear in league leaderboards.</div>
              </div>

              <button
                className="btn-primary"
                onClick={saveProfile}
                style={{ width: "100%" }}
              >
                {profileSaved ? "Saved!" : "Save Profile"}
              </button>
            </div>

            {/* Auto Lineup Setting */}
            <div style={{ background: "var(--bg-card)", border: "1px solid var(--border)", borderRadius: 12, padding: 24, marginBottom: 16 }}>
              <div style={{ fontSize: 11, color: "var(--text-muted)", textTransform: "uppercase", letterSpacing: 1, fontWeight: 700, marginBottom: 16 }}>Auto Lineup</div>
              <div style={{ display: "flex", alignItems: "flex-start", gap: 16 }}>
                <div style={{ flex: 1 }}>
                  <div style={{ fontWeight: 700, fontSize: 14, marginBottom: 4 }}>AI-Optimized Auto Lineup</div>
                  <div style={{ fontSize: 12, color: "var(--text-muted)", lineHeight: 1.5 }}>
                    Enabled by default. If you haven't saved a team before qualifying locks, we'll automatically build an optimized lineup using the latest practice session results — so you never miss a round.
                  </div>
                  {autoLineup && (
                    <div style={{ marginTop: 10, display: "flex", alignItems: "center", gap: 6 }}>
                      <div style={{ width: 6, height: 6, borderRadius: "50%", background: "#0fd679" }} />
                      <span style={{ fontSize: 11, color: "#0fd679", fontWeight: 700 }}>Active — will trigger if no team is saved when qualifying locks</span>
                    </div>
                  )}
                </div>
                {/* Toggle switch */}
                <button
                  onClick={() => {
                    const next = !autoLineup;
                    setAutoLineup(next);
                    localStorage.setItem("autoLineup", next ? "true" : "false");
                  }}
                  style={{
                    flexShrink: 0, width: 48, height: 28, borderRadius: 14,
                    background: autoLineup ? "#0fd679" : "var(--bg-elevated)",
                    border: `1px solid ${autoLineup ? "#0fd679" : "var(--border-strong)"}`,
                    cursor: "pointer", position: "relative", transition: "background 0.2s",
                    padding: 0,
                  }}
                >
                  <div style={{
                    position: "absolute", top: 3, left: autoLineup ? 22 : 3,
                    width: 20, height: 20, borderRadius: "50%",
                    background: "#fff", transition: "left 0.2s",
                    boxShadow: "0 1px 4px rgba(0,0,0,0.3)",
                  }} />
                </button>
              </div>
            </div>

            <div style={{ background: "var(--bg-card)", border: "1px solid var(--border)", borderRadius: 12, padding: 24 }}>
              <div style={{ fontSize: 11, color: "var(--text-muted)", textTransform: "uppercase", letterSpacing: 1, fontWeight: 700, marginBottom: 16 }}>Account Actions</div>
              <button
                onClick={() => supabase.auth.signOut()}
                style={{ background: "none", border: "1px solid rgba(225,6,0,0.3)", borderRadius: 8, padding: "12px 20px", fontSize: 14, color: "#e10600", cursor: "pointer", fontWeight: 600, width: "100%" }}
              >
                Sign Out
              </button>
            </div>
          </div>
        )}

        {/* TRANSFERS TAB */}
        {activeTab === "transfers" && (
  <div style={{ maxWidth: 480, margin: "0 auto" }}>
    <h2 style={{ fontFamily: "'Barlow Condensed', sans-serif", fontWeight: 900, fontSize: 32, textTransform: "uppercase", letterSpacing: 1, marginBottom: 16 }}>Team Changes</h2>

    {transferState?.admin_review ? (
      <div style={{ background: "rgba(245,166,35,0.08)", border: "1px solid rgba(245,166,35,0.4)", borderRadius: 10, padding: "20px 24px", marginBottom: 20 }}>
        <div style={{ fontFamily: "'Barlow Condensed', sans-serif", fontWeight: 900, fontSize: 18, textTransform: "uppercase", letterSpacing: 1, color: "#f5a623", marginBottom: 8 }}>Lineup Under Review</div>
        <div style={{ fontSize: 13, color: "var(--text-secondary)", lineHeight: 1.6 }}>
          Your Round 1 lineup needs to be verified before you can make transfers.<br />
          <strong style={{ color: "var(--text)" }}>What was your lineup before the Australian GP?</strong><br />
          Please message the league admin with your 5 drivers, 2 constructors and captain.
        </div>
      </div>
    ) : !inTransferWindow ? (
      <div style={{ background: "rgba(225,6,0,0.08)", border: "1px solid rgba(225,6,0,0.2)", borderRadius: 10, padding: "16px 20px", marginBottom: 20, display: "flex", gap: 12, alignItems: "center" }}>
        <div style={{ fontSize: 20 }}>🔒</div>
        <div>
          <div style={{ fontWeight: 700, fontSize: 14 }}>Transfer window closed</div>
          <div style={{ fontSize: 12, color: "var(--text-muted)", marginTop: 2 }}>Opens after the {lastCompletedRace?.name || "next race"} race ends.</div>
        </div>
      </div>
    ) : (() => {
      const lockedSpent = (lockedTeam?.driver_ids || []).map(id => DRIVERS.find(d => String(d.id) === String(id))).filter(Boolean).reduce((s, d) => s + d.price, 0)
        + (lockedTeam?.constructor_ids || []).map(id => CONSTRUCTORS.find(c => String(c.id) === String(id))).filter(Boolean).reduce((s, c) => s + c.price, 0);
      const pendingSpent = pendingDrivers.reduce((s, d) => s + d.price, 0) + pendingConstructors.reduce((s, c) => s + c.price, 0);
      const originalHeadroom = lockedTeam ? parseFloat(lockedTeam.budget_remaining || 0) : BUDGET;
      const remaining = originalHeadroom + lockedSpent - pendingSpent;
      const netChanges = wildcardActive ? 0 : countNetTransfers(lockedTeam, pendingDrivers, pendingConstructors);
      const freeAvail = wildcardActive ? Infinity : (transferState?.free_transfers ?? 2);
      const freeTotal = wildcardActive ? Infinity : freeTransfersStart; // total allocation this window
      const extraTransfers = Math.max(0, netChanges - freeTotal);
      const penalty = extraTransfers * 10;
      // Unsaved changes = pending differs from last saved team (selectedDrivers/Constructors)
      const hasUnsavedChanges = countNetTransfers(
        { driver_ids: selectedDrivers.map(d => String(d.id)), constructor_ids: selectedConstructors.map(c => String(c.id)) },
        pendingDrivers, pendingConstructors
      ) > 0;
      const hasChanges = hasUnsavedChanges;

      const emptyDriverSlots = MAX_DRIVERS - pendingDrivers.length;
      const emptyConSlots = 2 - pendingConstructors.length;

      const resetToLocked = () => {
        setPendingDrivers((lockedTeam?.driver_ids || []).map(id => DRIVERS.find(d => String(d.id) === String(id))).filter(Boolean));
        setPendingConstructors((lockedTeam?.constructor_ids || []).map(id => CONSTRUCTORS.find(c => String(c.id) === String(id))).filter(Boolean));
        setPendingCaptain(lockedTeam?.captain_id ? DRIVERS.find(d => String(d.id) === String(lockedTeam.captain_id)) || null : null);
      };

      return (
        <>
          {/* Lock deadline */}
          <div style={{ background: "var(--bg-elevated)", borderRadius: 100, padding: "12px 20px", display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 20, border: "1px solid var(--border)" }}>
            <span style={{ fontSize: 12, color: "var(--text-muted)", fontWeight: 600 }}>Lock Deadline:</span>
            <span style={{ fontFamily: "'Barlow Condensed', sans-serif", fontWeight: 900, fontSize: 18, letterSpacing: 2 }}>
              {(() => {
                const ms = Math.max(0, nextRaceLockDate - now);
                const d = Math.floor(ms / 86400000);
                const h = Math.floor((ms % 86400000) / 3600000);
                const m = Math.floor((ms % 3600000) / 60000);
                return `${String(d).padStart(2,'0')} D : ${String(h).padStart(2,'0')} H : ${String(m).padStart(2,'0')} M`;
              })()}
            </span>
          </div>

          {/* Summary bar */}
          <div style={{ background: "var(--bg-card)", border: "1px solid var(--border)", borderRadius: 12, marginBottom: 20, overflow: "hidden" }}>
            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "12px 18px", borderBottom: "1px solid var(--border)" }}>
              <span style={{ fontFamily: "'Barlow Condensed', sans-serif", fontWeight: 800, fontSize: 15, textTransform: "uppercase", letterSpacing: 1 }}>Summary</span>
              {!transferState?.wildcard_used && (
                <button onClick={() => setWildcardActive(w => !w)} style={{ background: wildcardActive ? "#f5a623" : "var(--bg-elevated)", border: `1px solid ${wildcardActive ? "#f5a623" : "var(--border-strong)"}`, borderRadius: 8, padding: "5px 12px", cursor: "pointer", fontSize: 12, fontWeight: 700, color: wildcardActive ? "#000" : "var(--text-secondary)" }}>
                  ⚡ Wildcard
                </button>
              )}
            </div>
            {[
              ["Free Transfers", freeAvail === Infinity ? `${netChanges} (∞)` : netChanges > 0 ? `${Math.min(netChanges, freeAvail)} of ${freeAvail}` : `${freeAvail} remaining`],
              ["Penalty", penalty > 0 ? `−${penalty} pts` : "None", penalty > 0 ? "#e10600" : null],
              ["Budget Remaining", `$${remaining.toFixed(1)}M`, remaining < 0 ? "#e10600" : null],
            ].map(([label, value, color]) => (
              <div key={label} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "10px 18px", borderBottom: "1px solid var(--border-sub)" }}>
                <span style={{ fontSize: 13, color: "var(--text-muted)" }}>{label}</span>
                <span style={{ fontSize: 13, fontWeight: 700, color: color || "var(--text)" }}>{value}</span>
              </div>
            ))}
          </div>

          {/* Drivers */}
          <div style={{ marginBottom: 6 }}>
            <div style={{ fontSize: 10, fontWeight: 800, letterSpacing: 1, textTransform: "uppercase", color: "var(--text-muted)", marginBottom: 8 }}>Drivers</div>
            {pendingDrivers.map(d => (
              <div key={d.id} style={{ display: "flex", alignItems: "center", gap: 10, background: "var(--bg-card)", border: "1px solid var(--border)", borderRadius: 10, padding: "10px 12px", marginBottom: 6 }}>
                <div style={{ width: 3, height: 20, borderRadius: 2, background: d.teamColor, flexShrink: 0 }} />
                <img src={`/drivers/driver-${d.id}.png`} alt={d.name} style={{ width: 36, height: 36, objectFit: "cover", objectPosition: "top center", borderRadius: 4, flexShrink: 0 }} />
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div style={{ fontFamily: "'Barlow Condensed', sans-serif", fontWeight: 800, fontSize: 14, textTransform: "uppercase", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{d.name}</div>
                  <div style={{ fontSize: 11, color: "var(--text-muted)" }}>{d.team} · ${d.price}m<PriceDelta item={d} /></div>
                </div>
                {pendingCaptain?.id === d.id && (
                  <div style={{ background: "#f5a623", borderRadius: 4, padding: "2px 6px", fontSize: 10, fontWeight: 800, color: "#000", flexShrink: 0 }}>CAP</div>
                )}
                <button onClick={() => {
                  setPendingDrivers(prev => prev.filter(pd => pd.id !== d.id));
                  if (pendingCaptain?.id === d.id) setPendingCaptain(null);
                }} style={{ background: "rgba(225,6,0,0.12)", border: "1px solid rgba(225,6,0,0.3)", borderRadius: 6, width: 28, height: 28, display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer", flexShrink: 0, color: "#e10600", fontSize: 14, fontWeight: 700 }}>✕</button>
              </div>
            ))}
            {Array.from({ length: emptyDriverSlots }).map((_, i) => (
              <button key={`empty-d-${i}`} onClick={() => setPickingSlot({ type: 'driver', replacing: null })}
                style={{ width: "100%", display: "flex", alignItems: "center", justifyContent: "center", gap: 8, background: "var(--bg-elevated)", border: "1px dashed var(--border-strong)", borderRadius: 10, padding: "14px 12px", marginBottom: 6, cursor: "pointer", color: "var(--text-muted)", fontSize: 13, fontWeight: 600 }}>
                <span style={{ fontSize: 18, lineHeight: 1 }}>+</span> Add Driver
              </button>
            ))}
          </div>

          {/* Constructors */}
          <div style={{ marginBottom: 20 }}>
            <div style={{ fontSize: 10, fontWeight: 800, letterSpacing: 1, textTransform: "uppercase", color: "var(--text-muted)", marginBottom: 8 }}>Constructors</div>
            {pendingConstructors.map(c => (
              <div key={c.id} style={{ display: "flex", alignItems: "center", gap: 10, background: "var(--bg-card)", border: "1px solid var(--border)", borderRadius: 10, padding: "10px 12px", marginBottom: 6 }}>
                <div style={{ width: 4, height: 24, borderRadius: 2, background: c.color, flexShrink: 0 }} />
                <div style={{ flex: 1 }}>
                  <div style={{ fontFamily: "'Barlow Condensed', sans-serif", fontWeight: 800, fontSize: 14, textTransform: "uppercase" }}>{c.name}</div>
                  <div style={{ fontSize: 11, color: "var(--text-muted)" }}>${c.price}m<PriceDelta item={c} /></div>
                </div>
                <button onClick={() => setPendingConstructors(prev => prev.filter(pc => pc.id !== c.id))}
                  style={{ background: "rgba(225,6,0,0.12)", border: "1px solid rgba(225,6,0,0.3)", borderRadius: 6, width: 28, height: 28, display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer", flexShrink: 0, color: "#e10600", fontSize: 14, fontWeight: 700 }}>✕</button>
              </div>
            ))}
            {Array.from({ length: emptyConSlots }).map((_, i) => (
              <button key={`empty-c-${i}`} onClick={() => setPickingSlot({ type: 'constructor', replacing: null })}
                style={{ width: "100%", display: "flex", alignItems: "center", justifyContent: "center", gap: 8, background: "var(--bg-elevated)", border: "1px dashed var(--border-strong)", borderRadius: 10, padding: "14px 12px", marginBottom: 6, cursor: "pointer", color: "var(--text-muted)", fontSize: 13, fontWeight: 600 }}>
                <span style={{ fontSize: 18, lineHeight: 1 }}>+</span> Add Constructor
              </button>
            ))}
          </div>

          {/* Captain picker */}
          {pendingDrivers.length > 0 && (
            <div style={{ background: "var(--bg-card)", border: "1px solid var(--border)", borderRadius: 10, padding: "12px 18px", marginBottom: 20 }}>
              <div style={{ fontSize: 10, color: "var(--text-faint)", textTransform: "uppercase", letterSpacing: 1, marginBottom: 8 }}>Captain (×2 pts)</div>
              <div style={{ display: "flex", gap: 6, flexWrap: "wrap" }}>
                {pendingDrivers.map(d => (
                  <button key={d.id} onClick={() => setPendingCaptain(d)}
                    style={{ background: pendingCaptain?.id === d.id ? d.teamColor + "33" : "var(--bg-elevated)", border: `1px solid ${pendingCaptain?.id === d.id ? d.teamColor : "var(--border)"}`, borderRadius: 6, padding: "5px 10px", cursor: "pointer", fontSize: 12, fontWeight: 700, fontFamily: "'Barlow Condensed', sans-serif", textTransform: "uppercase", color: "var(--text)" }}>
                    {pendingCaptain?.id === d.id ? "⭐ " : ""}{d.name.split(" ").slice(1).join(" ")}
                  </button>
                ))}
              </div>
            </div>
          )}

          {/* Changes + reset */}
          {hasChanges && (
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 12 }}>
              <span style={{ fontFamily: "'Barlow Condensed', sans-serif", fontWeight: 800, fontSize: 16 }}>
                {netChanges} change{netChanges !== 1 ? "s" : ""}{penalty > 0 ? ` · −${penalty} pts` : ""}
              </span>
              <button onClick={resetToLocked} style={{ background: "none", border: "none", color: "var(--text-muted)", fontSize: 13, cursor: "pointer", textDecoration: "underline", padding: 0 }}>Reset</button>
            </div>
          )}

          {/* No captain warning */}
          {!pendingCaptain && pendingDrivers.length === MAX_DRIVERS && (
            <div style={{ background: "#f5a62322", border: "1px solid #f5a623", borderRadius: 8, padding: "10px 14px", marginBottom: 12, fontSize: 13, color: "#f5a623", fontWeight: 600 }}>
              ⭐ Select a captain above before confirming
            </div>
          )}

          {/* Confirm button */}
          <button
            onClick={saveTransfers}
            disabled={pendingDrivers.length !== MAX_DRIVERS || pendingConstructors.length !== 2 || remaining < 0 || !pendingCaptain}
            style={{ width: "100%", padding: "16px", background: "#e10600", border: "none", borderRadius: 12, color: "#fff", fontSize: 16, fontWeight: 900, fontFamily: "'Barlow Condensed', sans-serif", textTransform: "uppercase", letterSpacing: 1, cursor: "pointer", opacity: pendingDrivers.length === MAX_DRIVERS && pendingConstructors.length === 2 && remaining >= 0 && pendingCaptain ? 1 : 0.4, marginBottom: 16 }}>
            Confirm Changes
          </button>

          {/* Player picker overlay */}
          {pickingSlot && (
            <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.88)", zIndex: 1000, display: "flex", alignItems: "flex-end", justifyContent: "center" }}
              onClick={() => setPickingSlot(null)}>
              <div style={{ background: "var(--bg-card)", borderRadius: "16px 16px 0 0", width: "100%", maxWidth: 480, height: "80vh", overflowY: "scroll", WebkitOverflowScrolling: "touch", padding: "16px 0 32px" }}
                onClick={e => e.stopPropagation()}>
                <div style={{ padding: "0 18px 12px", borderBottom: "1px solid var(--border)", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                  <div style={{ fontFamily: "'Barlow Condensed', sans-serif", fontWeight: 800, fontSize: 18, textTransform: "uppercase" }}>
                    Select {pickingSlot.type === 'driver' ? 'Driver' : 'Constructor'}
                  </div>
                  <button onClick={() => setPickingSlot(null)} style={{ background: "none", border: "none", fontSize: 20, cursor: "pointer", color: "var(--text-muted)" }}>✕</button>
                </div>
                <div style={{ padding: "12px 18px" }}>
                  {pickingSlot.type === 'driver' ? (
                    DRIVERS
                      .filter(d => !pendingDrivers.find(pd => pd.id === d.id) || d.id === pickingSlot.replacing?.id)
                      .sort((a, b) => a.price - b.price)
                      .map(d => {
                        const newPendingSpent = pendingDrivers.filter(pd => pd.id !== pickingSlot.replacing?.id).reduce((s, pd) => s + pd.price, 0) + d.price + pendingConstructors.reduce((s, c) => s + c.price, 0);
                        const overBudget = newPendingSpent > lockedSpent + originalHeadroom;
                        return (
                          <button key={d.id} disabled={overBudget} onClick={() => {
                            if (overBudget) { showToast("Over budget!", "error"); return; }
                            setPendingDrivers(prev => {
                              const without = prev.filter(pd => pd.id !== pickingSlot.replacing?.id);
                              return [...without, d];
                            });
                            setPickingSlot(null);
                          }} style={{ width: "100%", background: overBudget ? "var(--bg-elevated)" : "var(--bg-card)", border: `1px solid ${overBudget ? "var(--border)" : "var(--border-strong)"}`, borderRadius: 8, padding: "10px 14px", marginBottom: 6, cursor: overBudget ? "not-allowed" : "pointer", display: "flex", alignItems: "center", gap: 10, opacity: overBudget ? 0.4 : 1, textAlign: "left" }}>
                            <div style={{ width: 3, height: 20, borderRadius: 2, background: d.teamColor, flexShrink: 0 }} />
                            <img src={`/drivers/driver-${d.id}.png`} alt={d.name} style={{ width: 36, height: 36, objectFit: "cover", objectPosition: "top center", borderRadius: 4, flexShrink: 0 }} />
                            <div style={{ flex: 1 }}>
                              <div style={{ fontFamily: "'Barlow Condensed', sans-serif", fontWeight: 800, fontSize: 14, textTransform: "uppercase" }}>{d.name}</div>
                              <div style={{ fontSize: 11, color: "var(--text-muted)" }}>{d.team}</div>
                            </div>
                            <div style={{ textAlign: "right" }}>
                              <div style={{ fontFamily: "'Barlow Condensed', sans-serif", fontWeight: 800, fontSize: 14 }}>${d.price}m<PriceDelta item={d} /></div>
                              {overBudget && <div style={{ fontSize: 10, color: "#e10600" }}>Over budget</div>}
                            </div>
                          </button>
                        );
                      })
                  ) : (
                    CONSTRUCTORS
                      .filter(c => !pendingConstructors.find(pc => pc.id === c.id) || c.id === pickingSlot.replacing?.id)
                      .sort((a, b) => a.price - b.price)
                      .map(c => {
                        const newPendingSpent = pendingDrivers.reduce((s, d) => s + d.price, 0) + pendingConstructors.filter(pc => pc.id !== pickingSlot.replacing?.id).reduce((s, pc) => s + pc.price, 0) + c.price;
                        const overBudget = newPendingSpent > lockedSpent + originalHeadroom;
                        return (
                          <button key={c.id} disabled={overBudget} onClick={() => {
                            if (overBudget) { showToast("Over budget!", "error"); return; }
                            setPendingConstructors(prev => {
                              const without = prev.filter(pc => pc.id !== pickingSlot.replacing?.id);
                              return [...without, c];
                            });
                            setPickingSlot(null);
                          }} style={{ width: "100%", background: overBudget ? "var(--bg-elevated)" : "var(--bg-card)", border: `1px solid ${overBudget ? "var(--border)" : "var(--border-strong)"}`, borderRadius: 8, padding: "10px 14px", marginBottom: 6, cursor: overBudget ? "not-allowed" : "pointer", display: "flex", alignItems: "center", gap: 10, opacity: overBudget ? 0.4 : 1, textAlign: "left" }}>
                            <div style={{ width: 3, height: 20, borderRadius: 2, background: c.color, flexShrink: 0 }} />
                            <div style={{ flex: 1 }}>
                              <div style={{ fontFamily: "'Barlow Condensed', sans-serif", fontWeight: 800, fontSize: 14, textTransform: "uppercase" }}>{c.name}</div>
                            </div>
                            <div style={{ textAlign: "right" }}>
                              <div style={{ fontFamily: "'Barlow Condensed', sans-serif", fontWeight: 800, fontSize: 14 }}>${c.price}m<PriceDelta item={c} /></div>
                              {overBudget && <div style={{ fontSize: 10, color: "#e10600" }}>Over budget</div>}
                            </div>
                          </button>
                        );
                      })
                  )}
                </div>
              </div>
            </div>
          )}
        </>
      );
    })()}
  </div>
        )}

        {/* ADMIN TAB */}
        {activeTab === "admin" && user.email === SUPER_ADMIN_EMAIL && (
          <div style={{ maxWidth: 680 }}>
            <h2 style={{ fontFamily: "'Barlow Condensed', sans-serif", fontWeight: 800, fontSize: 24, letterSpacing: 1, textTransform: "uppercase", marginBottom: 8 }}>
              Admin — Manual Scoring
            </h2>
            <p style={{ color: "var(--text-muted)", fontSize: 13, marginBottom: 24 }}>
              Set Driver of the Day (+10 pts) and overtake counts (+1 pt each) after a race.
            </p>

            {/* Race selector */}
            <div style={{ background: "var(--bg-card)", border: "1px solid var(--border)", borderRadius: 10, padding: 20, marginBottom: 16 }}>
              <div style={{ fontFamily: "'Barlow Condensed', sans-serif", fontWeight: 700, fontSize: 14, marginBottom: 12, color: "var(--text-secondary)", textTransform: "uppercase", letterSpacing: 1 }}>Select Race Weekend</div>
              <div style={{ display: "flex", gap: 10, alignItems: "center", flexWrap: "wrap" }}>
                <select
                  value={adminSelectedMeeting?.meeting_key || ""}
                  onChange={e => {
                    const m = adminRaces.find(r => String(r.meeting_key) === e.target.value);
                    setAdminSelectedMeeting(m || null);
                    if (m) loadAdminScoring(m.meeting_key);
                  }}
                  style={{ flex: 1, minWidth: 200, background: "var(--bg-elevated)", border: "1px solid var(--border-strong)", borderRadius: 6, color: "var(--text)", padding: "8px 12px", fontSize: 14 }}
                >
                  <option value="">— pick a race —</option>
                  {adminRaces.map(m => (
                    <option key={m.meeting_key} value={m.meeting_key}>{m.meeting_name}</option>
                  ))}
                </select>
                <button
                  className="btn-primary"
                  onClick={loadAdminRaces}
                  disabled={adminLoading}
                  style={{ whiteSpace: "nowrap", fontSize: 13 }}
                >
                  {adminLoading ? "Loading…" : "Load Races"}
                </button>
              </div>
            </div>

            {adminSelectedMeeting && (
              <>
                {/* Driver of the Day */}
                <div style={{ background: "var(--bg-card)", border: "1px solid var(--border)", borderRadius: 10, padding: 20, marginBottom: 16 }}>
                  <div style={{ fontFamily: "'Barlow Condensed', sans-serif", fontWeight: 700, fontSize: 14, marginBottom: 12, color: "var(--text-secondary)", textTransform: "uppercase", letterSpacing: 1 }}>Driver of the Day <span style={{ color: "#0fd679", marginLeft: 6 }}>+10 pts</span></div>
                  <select
                    value={adminDotd}
                    onChange={e => setAdminDotd(e.target.value)}
                    style={{ width: "100%", background: "var(--bg-elevated)", border: "1px solid var(--border-strong)", borderRadius: 6, color: "var(--text)", padding: "8px 12px", fontSize: 14 }}
                  >
                    <option value="">— none —</option>
                    {DRIVERS.map(d => (
                      <option key={d.id} value={d.id}>{d.name} ({d.team})</option>
                    ))}
                  </select>
                </div>

                {/* Overtakes */}
                <div style={{ background: "var(--bg-card)", border: "1px solid var(--border)", borderRadius: 10, padding: 20, marginBottom: 16 }}>
                  <div style={{ fontFamily: "'Barlow Condensed', sans-serif", fontWeight: 700, fontSize: 14, marginBottom: 12, color: "var(--text-secondary)", textTransform: "uppercase", letterSpacing: 1 }}>Overtakes <span style={{ color: "#0fd679", marginLeft: 6 }}>+1 pt each</span></div>
                  <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(220px, 1fr))", gap: 8 }}>
                    {DRIVERS.map(d => (
                      <div key={d.id} style={{ display: "flex", alignItems: "center", gap: 8, background: "var(--bg-elevated)", borderRadius: 6, padding: "6px 10px" }}>
                        <div style={{ width: 3, height: 28, borderRadius: 2, background: d.teamColor, flexShrink: 0 }} />
                        <div style={{ flex: 1, fontSize: 13, color: "var(--text)", fontWeight: 600, minWidth: 0, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{d.name.split(" ").pop()}</div>
                        <input
                          type="number"
                          min="0"
                          max="30"
                          value={adminOvertakes[d.id] ?? ""}
                          onChange={e => {
                            const val = e.target.value === "" ? undefined : parseInt(e.target.value);
                            setAdminOvertakes(prev => {
                              const next = { ...prev };
                              if (val === undefined || val === 0) delete next[d.id];
                              else next[d.id] = val;
                              return next;
                            });
                          }}
                          style={{ width: 52, background: "var(--bg)", border: "1px solid var(--border-strong)", borderRadius: 4, color: "var(--text)", padding: "4px 6px", fontSize: 13, textAlign: "center" }}
                        />
                      </div>
                    ))}
                  </div>
                </div>

                {/* Save + Re-sync */}
                <div style={{ display: "flex", gap: 12, flexWrap: "wrap" }}>
                  <button
                    className="btn-primary"
                    onClick={saveManualScoring}
                    disabled={adminSaving}
                    style={{ flex: 1, minWidth: 140, fontSize: 14 }}
                  >
                    {adminSaving ? "Saving…" : "Save Manual Scoring"}
                  </button>
                  <button
                    onClick={async () => {
                      await supabase.from('scored_sessions').delete().neq('session_key', 0);
                      setSyncedSessions(new Set());
                      setRaceLog([]);
                      setDrivers(DRIVERS.map(d => ({ ...d, fantasyPoints: 0 })));
                      setConstructors(CONSTRUCTORS.map(c => ({ ...c, points: 0 })));
                      setQualiPositions({});
                      showToast("Scoring reset — re-syncing...", "info");
                      syncResults(false);
                    }}
                    style={{ flex: 1, minWidth: 140, background: "var(--bg-elevated)", border: "1px solid var(--border-strong)", borderRadius: 6, color: "var(--text)", fontSize: 14, fontWeight: 700, padding: "10px 16px", cursor: "pointer" }}
                  >
                    Reset &amp; Re-sync
                  </button>
                </div>
              </>
            )}
          </div>
        )}
      </main>

      {/* Captain Modal */}
      {showCaptainModal && (
        <div className="modal-overlay" onClick={() => setShowCaptainModal(false)}>
          <div style={{ background: "var(--bg-card)", border: "1px solid var(--border-strong)", borderRadius: 12, padding: 24, width: 400, maxHeight: "80vh", overflow: "auto", WebkitOverflowScrolling: "touch" }} onClick={e => e.stopPropagation()}>
            <h3 style={{ fontFamily: "'Barlow Condensed', sans-serif", fontWeight: 800, fontSize: 20, letterSpacing: 1, textTransform: "uppercase", marginBottom: 6 }}>Choose Your Captain</h3>
            <p style={{ color: "var(--text-muted)", fontSize: 13, marginBottom: 20 }}>Your captain scores double points this race weekend.</p>
            <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
              {selectedDrivers.map(d => {
                const isChosen = captain?.id === d.id;
                return (
                  <button key={d.id} onClick={() => { if (!isLocked) { setCaptain(d); setShowCaptainModal(false); } }} style={{
                    background: isChosen ? d.teamColor + "14" : "var(--bg-elevated)",
                    border: `1px solid ${isChosen ? d.teamColor + "80" : "var(--border)"}`,
                    borderRadius: 10, padding: 0, cursor: "pointer",
                    display: "flex", alignItems: "stretch",
                    textAlign: "left", transition: "all 0.15s", overflow: "hidden",
                    boxShadow: isChosen ? `0 0 0 1px ${d.teamColor}22, 0 4px 20px ${d.teamColor}18` : "none",
                    minHeight: 64,
                  }}>
                    <div style={{ width: 4, alignSelf: "stretch", background: isChosen ? d.teamColor : "var(--border-strong)", borderRadius: "10px 0 0 10px", flexShrink: 0 }} />
                    {/* Portrait */}
                    <div style={{ width: 56, flexShrink: 0, background: d.teamColor + "08", borderRight: "1px solid var(--border-sub)", display: "flex", alignItems: "center", justifyContent: "center", position: "relative", overflow: "hidden" }}>
                      <div style={{ position: "absolute", right: -2, bottom: -8, fontFamily: "'Barlow Condensed', sans-serif", fontWeight: 900, fontSize: 34, color: d.teamColor + "20", lineHeight: 1, userSelect: "none", pointerEvents: "none" }}>{d.number}</div>
                      <img src={`/drivers/driver-${d.id}.png`} alt={d.name} style={{ width: 44, height: 44, objectFit: "cover", objectPosition: "top center", position: "relative", zIndex: 1 }} />
                    </div>
                    <div style={{ flex: 1, padding: "10px 14px" }}>
                      <div style={{ color: "var(--text)", fontFamily: "'Barlow Condensed', sans-serif", fontWeight: 800, fontSize: 16, textTransform: "uppercase", lineHeight: 1.1 }}>
                        {FLAG_MAP[d.country]} {d.name.split(" ").slice(1).join(" ")}
                      </div>
                      <div style={{ color: "var(--text-muted)", fontSize: 11, marginTop: 3 }}>{d.team}</div>
                    </div>
                    <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", padding: "0 16px", gap: 2, borderLeft: "1px solid var(--border)", flexShrink: 0 }}>
                      <div style={{ fontSize: 9, color: "var(--text-muted)", textTransform: "uppercase", letterSpacing: 1 }}>×2 pts</div>
                      <div style={{ fontFamily: "'Barlow Condensed', sans-serif", fontWeight: 800, fontSize: 20, color: isChosen ? d.teamColor : "#e10600" }}>{d.fantasyPoints * 2}</div>
                    </div>
                    <div style={{ display: "flex", alignItems: "center", padding: "0 14px", flexShrink: 0, fontSize: 18 }}>
                      {isChosen ? "⭐" : <div style={{ width: 22, height: 22, borderRadius: "50%", border: "2px solid var(--border-strong)", display: "flex", alignItems: "center", justifyContent: "center" }}><div style={{ width: 8, height: 8, borderRadius: "50%", background: "var(--border-strong)" }} /></div>}
                    </div>
                  </button>
                );
              })}
            </div>
          </div>
        </div>
      )}

      {/* DRIVER BREAKDOWN MODAL */}
    {selectedStatsDriver && (() => {
      const d = selectedStatsDriver;
      const sessions = raceLog.filter(s => (s.pts[d.id] !== undefined || s.breakdown?.[d.id]) && s.scored);
      const totalPts = sessions.reduce((sum, s) => sum + (s.pts[d.id] || 0), 0);
      return (
        <div
          style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.88)", zIndex: 1000, display: "flex", alignItems: "flex-end", justifyContent: "center", padding: 0 }}
          onClick={() => setSelectedStatsDriver(null)}
        >
          <div
            style={{ background: "var(--bg-card)", borderRadius: "16px 16px 0 0", width: "100%", maxWidth: 480, height: "90vh", overflowY: "scroll", WebkitOverflowScrolling: "touch", paddingBottom: 48 }}
            onClick={e => e.stopPropagation()}
          >
            {/* Header */}
            <div style={{ display: "flex", alignItems: "center", gap: 0, background: d.teamColor + "22", borderBottom: "1px solid var(--border)", position: "relative", overflow: "hidden" }}>
              <div style={{ width: 5, background: d.teamColor, alignSelf: "stretch", flexShrink: 0 }} />
              <div style={{ padding: "16px 16px", flex: 1, minWidth: 0 }}>
                <div style={{ fontSize: 10, color: "var(--text-muted)", marginBottom: 2 }}>{FLAG_MAP[d.country]} {d.name.split(" ")[0].toUpperCase()}</div>
                <div style={{ fontFamily: "'Barlow Condensed', sans-serif", fontWeight: 900, fontSize: 28, textTransform: "uppercase", lineHeight: 1, color: "var(--text)" }}>{d.name.split(" ").slice(1).join(" ")}</div>
                <div style={{ fontSize: 10, color: "var(--text-faint)", marginTop: 3, fontWeight: 700, letterSpacing: 1, textTransform: "uppercase" }}>{d.team}</div>
              </div>
              <img src={`/drivers/driver-${d.id}.png`} alt={d.name} style={{ width: 90, height: 90, objectFit: "cover", objectPosition: "top center", flexShrink: 0 }} />
              <div style={{ position: "absolute", right: 96, bottom: -8, fontFamily: "'Barlow Condensed', sans-serif", fontWeight: 900, fontSize: 72, color: d.teamColor + "22", lineHeight: 1, userSelect: "none" }}>{d.number}</div>
              <button onClick={() => setSelectedStatsDriver(null)} style={{ position: "absolute", top: 12, right: 12, background: "rgba(255,255,255,0.1)", border: "none", borderRadius: "50%", width: 28, height: 28, display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer", color: "var(--text-muted)", fontSize: 16, lineHeight: 1 }}>✕</button>
            </div>

            {/* Total */}
            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "14px 20px", borderBottom: "1px solid var(--border)" }}>
              <span style={{ fontFamily: "'Barlow Condensed', sans-serif", fontWeight: 800, fontSize: 14, textTransform: "uppercase", letterSpacing: 1, color: "var(--text-secondary)" }}>Total Points</span>
              <span style={{ fontFamily: "'Barlow Condensed', sans-serif", fontWeight: 900, fontSize: 26, color: "#e10600" }}>{totalPts}</span>
            </div>

            {/* Per-session breakdown */}
            {sessions.length === 0 && (
              <div style={{ padding: "24px 20px", color: "var(--text-muted)", fontSize: 13, textAlign: "center" }}>No scored sessions yet.</div>
            )}
            {sessions.map((s, si) => {
              const bd = s.breakdown?.[d.id];
              const rows = calcBreakdownRows(s.session_name, bd);
              const sessionPts = s.pts[d.id] || 0;
              return (
                <div key={si} style={{ borderBottom: "1px solid var(--border)" }}>
                  {/* Session header */}
                  <div style={{ padding: "10px 20px 6px", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                    <div>
                      <div style={{ fontFamily: "'Barlow Condensed', sans-serif", fontWeight: 800, fontSize: 15, textTransform: "uppercase", letterSpacing: 0.5, color: "var(--text)" }}>{s.session_name}</div>
                      <div style={{ fontSize: 10, color: "var(--text-faint)", marginTop: 1 }}>{s.meeting_name}</div>
                    </div>
                    <div style={{ fontFamily: "'Barlow Condensed', sans-serif", fontWeight: 900, fontSize: 20, color: sessionPts >= 0 ? "#0fd679" : "#e10600" }}>{sessionPts > 0 ? `+${sessionPts}` : sessionPts}</div>
                  </div>
                  {/* Rows */}
                  {rows.length > 0 ? (
                    <div style={{ padding: "0 20px 10px" }}>
                      {rows.map((row, ri) => (
                        <div key={ri} style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "5px 0", borderTop: ri === 0 ? "1px solid var(--border-sub)" : "none" }}>
                          <span style={{ fontSize: 12, color: "var(--text-secondary)" }}>{row.label}</span>
                          <div style={{ display: "flex", gap: 10, alignItems: "center" }}>
                            <span style={{ fontSize: 11, color: "var(--text-muted)", fontWeight: 600 }}>{row.value}</span>
                            <span style={{ fontFamily: "'Barlow Condensed', sans-serif", fontWeight: 800, fontSize: 13, color: row.pts > 0 ? "#0fd679" : row.pts < 0 ? "#e10600" : "var(--text-muted)", minWidth: 36, textAlign: "right" }}>{row.pts > 0 ? `+${row.pts}` : row.pts}</span>
                          </div>
                        </div>
                      ))}
                    </div>
                  ) : (
                    <div style={{ padding: "4px 20px 10px", fontSize: 11, color: "var(--text-faint)" }}>No breakdown data available</div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      );
    })()}
    </div>
  );
}